import { Price } from "./price";
import { Deserializable } from "./deserializable";

export class Product implements Deserializable {
  id: string;
  name: string;
  category: string;
  description: string;
  description2: string;
  photo: string;
  prices: Price[] = new Array();

  deserialize(input: any): this {
    Object.assign(this, input);
    this.prices = input.prices.map((price: Price) =>
      new Price().deserialize(price)
    );
    return this;
  }
}

export const PRODUCTS: Product[] = [
  // Rolex Start Brand Collection
  {
    id: "rolex-cosmograph-daytona-rainbow-116595rbow",
    name: "Rolex Cosmograph Daytona “Rainbow” – 116595RBOW",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-cosmograph-daytona-rainbow-116595rbow.jfif",
    description: `<ul data-start="1791" data-end="2428">
    <li data-start="1791" data-end="1840">
    <p data-start="1793" data-end="1840"><strong data-start="1793" data-end="1803">Model:</strong> Rolex Cosmograph Daytona “Rainbow”</p>
    </li>
    <li data-start="1841" data-end="1877">
    <p data-start="1843" data-end="1877"><strong data-start="1843" data-end="1864">Reference Number:</strong> 116595RBOW</p>
    </li>
    <li data-start="1878" data-end="1925">
    <p data-start="1880" data-end="1925"><strong data-start="1880" data-end="1893">Movement:</strong> Automatic, Rolex Caliber 4130</p>
    </li>
    <li data-start="1926" data-end="1971">
    <p data-start="1928" data-end="1971"><strong data-start="1928" data-end="1946">Power Reserve:</strong> Approximately 72 hours</p>
    </li>
    <li data-start="1972" data-end="1995">
    <p data-start="1974" data-end="1995"><strong data-start="1974" data-end="1988">Case Size:</strong> 40mm</p>
    </li>
    <li data-start="1996" data-end="2035">
    <p data-start="1998" data-end="2035"><strong data-start="1998" data-end="2016">Case Material:</strong> 18K Everose Gold</p>
    </li>
    <li data-start="2036" data-end="2086">
    <p data-start="2038" data-end="2086"><strong data-start="2038" data-end="2048">Bezel:</strong> Rainbow baguette-cut sapphire bezel</p>
    </li>
    <li data-start="2087" data-end="2139">
    <p data-start="2089" data-end="2139"><strong data-start="2089" data-end="2098">Dial:</strong> Black dial with Everose gold sub-dials</p>
    </li>
    <li data-start="2140" data-end="2197">
    <p data-start="2142" data-end="2197"><strong data-start="2142" data-end="2159">Hour Markers:</strong> Multicolored baguette-cut sapphires</p>
    </li>
    <li data-start="2198" data-end="2249">
    <p data-start="2200" data-end="2249"><strong data-start="2200" data-end="2212">Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li data-start="2250" data-end="2300">
    <p data-start="2252" data-end="2300"><strong data-start="2252" data-end="2265">Bracelet:</strong> 18K Everose gold Oyster bracelet</p>
    </li>
    <li data-start="2301" data-end="2346">
    <p data-start="2303" data-end="2346"><strong data-start="2303" data-end="2324">Water Resistance:</strong> 100 meters (10 ATM)</p>
    </li>
    <li data-start="2347" data-end="2368">
    <p data-start="2349" data-end="2368"><strong data-start="2349" data-end="2360">Gender:</strong> Men’s</p>
    </li>
    <li data-start="2369" data-end="2428">
    <p data-start="2371" data-end="2428"><strong data-start="2371" data-end="2384">Warranty:</strong> Covered by <strong data-start="2396" data-end="2428">JD Watches 24-month warranty</strong></p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><h3 data-start="157" data-end="244"><strong data-start="161" data-end="244"><span class="hover:entity-accent entity-underline inline cursor-pointer align-baseline"><span class="whitespace-normal">Rolex</span></span> Cosmograph Daytona “Rainbow” – 116595RBOW</strong></h3>
  <p data-start="246" data-end="480">The <strong data-start="250" data-end="299">Rolex Cosmograph Daytona 116595RBOW “Rainbow”</strong> is a breathtaking fusion of haute horology and high jewelry, transforming Rolex’s legendary chronograph into one of the most visually striking and coveted timepieces ever produced.</p>
  <p data-start="482" data-end="840">Crafted in <strong data-start="493" data-end="513">18K Everose gold</strong>, the 40mm case is crowned with an extraordinary <strong data-start="562" data-end="588">rainbow sapphire bezel</strong>, meticulously set with a perfectly graduated spectrum of baguette-cut sapphires. The lugs and crown guards are further adorned with <strong data-start="721" data-end="747">brilliant-cut diamonds</strong>, adding an additional layer of brilliance and reinforcing the watch’s unmistakable presence.</p>
  <p data-start="842" data-end="1186">The <strong data-start="846" data-end="860">black dial</strong> provides a dramatic contrast to the vibrant bezel, featuring <strong data-start="922" data-end="948">Everose gold sub-dials</strong> that mirror the warmth of the case. Completing the aesthetic, the hour markers are set with <strong data-start="1041" data-end="1080">multicolored baguette-cut sapphires</strong>, precisely matched to the bezel’s color transition—an exceptional display of Rolex’s gem-setting mastery.</p>
  <p data-start="1188" data-end="1514">Powering this masterpiece is the <strong data-start="1221" data-end="1243">Rolex Caliber 4130</strong>, a self-winding chronograph movement renowned for its precision, reliability, and efficiency, offering an approximate <strong data-start="1362" data-end="1387">72-hour power reserve</strong>. Beyond its dazzling appearance, the 116595RBOW remains a true tool watch at heart, built to Rolex’s uncompromising standards.</p>
  <p data-start="1516" data-end="1755">Ultra-rare, instantly recognizable, and produced in extremely limited quantities, the <strong data-start="1602" data-end="1623">Daytona “Rainbow”</strong> stands as a symbol of exclusivity, craftsmanship, and modern Rolex prestige—an unquestionable grail for elite collectors worldwide.</p>
  <hr data-start="1757" data-end="1760">
  <h3 data-start="1762" data-end="1790"><strong data-start="1766" data-end="1790">Watch Specifications</strong></h3>
  <ul data-start="1791" data-end="2428">
  <li data-start="1791" data-end="1840">
  <p data-start="1793" data-end="1840"><strong data-start="1793" data-end="1803">Model:</strong> Rolex Cosmograph Daytona “Rainbow”</p>
  </li>
  <li data-start="1841" data-end="1877">
  <p data-start="1843" data-end="1877"><strong data-start="1843" data-end="1864">Reference Number:</strong> 116595RBOW</p>
  </li>
  <li data-start="1878" data-end="1925">
  <p data-start="1880" data-end="1925"><strong data-start="1880" data-end="1893">Movement:</strong> Automatic, Rolex Caliber 4130</p>
  </li>
  <li data-start="1926" data-end="1971">
  <p data-start="1928" data-end="1971"><strong data-start="1928" data-end="1946">Power Reserve:</strong> Approximately 72 hours</p>
  </li>
  <li data-start="1972" data-end="1995">
  <p data-start="1974" data-end="1995"><strong data-start="1974" data-end="1988">Case Size:</strong> 40mm</p>
  </li>
  <li data-start="1996" data-end="2035">
  <p data-start="1998" data-end="2035"><strong data-start="1998" data-end="2016">Case Material:</strong> 18K Everose Gold</p>
  </li>
  <li data-start="2036" data-end="2086">
  <p data-start="2038" data-end="2086"><strong data-start="2038" data-end="2048">Bezel:</strong> Rainbow baguette-cut sapphire bezel</p>
  </li>
  <li data-start="2087" data-end="2139">
  <p data-start="2089" data-end="2139"><strong data-start="2089" data-end="2098">Dial:</strong> Black dial with Everose gold sub-dials</p>
  </li>
  <li data-start="2140" data-end="2197">
  <p data-start="2142" data-end="2197"><strong data-start="2142" data-end="2159">Hour Markers:</strong> Multicolored baguette-cut sapphires</p>
  </li>
  <li data-start="2198" data-end="2249">
  <p data-start="2200" data-end="2249"><strong data-start="2200" data-end="2212">Crystal:</strong> Scratch-resistant sapphire crystal</p>
  </li>
  <li data-start="2250" data-end="2300">
  <p data-start="2252" data-end="2300"><strong data-start="2252" data-end="2265">Bracelet:</strong> 18K Everose gold Oyster bracelet</p>
  </li>
  <li data-start="2301" data-end="2346">
  <p data-start="2303" data-end="2346"><strong data-start="2303" data-end="2324">Water Resistance:</strong> 100 meters (10 ATM)</p>
  </li>
  <li data-start="2347" data-end="2368">
  <p data-start="2349" data-end="2368"><strong data-start="2349" data-end="2360">Gender:</strong> Men’s</p>
  </li>
  <li data-start="2369" data-end="2428">
  <p data-start="2371" data-end="2428"><strong data-start="2371" data-end="2384">Warranty:</strong> Covered by <strong data-start="2396" data-end="2428">JD Watches 24-month warranty</strong></p>
  </li>
  </ul></div>`,
    prices: [{ unit: "unit", amount: 440000.0 }],
  } as Product,
  {
    id: "rolex-stainless-steel-and-white-gold-datejust-16014-jubilee-bracelet",
    name: "Rolex Stainless Steel and White Gold Datejust (16014) Jubilee bracelet",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-stainless-steel-and-white-gold-datejust-16014-jubilee-bracelet.jfif",
    description: `<div class="productdesc"><p><strong>Brand</strong><span>:&nbsp; &nbsp; Rolex</span><br><strong>Model Name</strong><span>:&nbsp; Rolex Stainless Steel and White Gold Datejust with Jubilee Bracelet</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model Number</strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">:&nbsp; &nbsp; 16014</span></p>
    <p><strong>Movement</strong><span>: &nbsp; Automatic</span><br><strong>Case</strong><span>:&nbsp; &nbsp;36 mm Case diameter.</span><br><strong>Crystal</strong><span>: &nbsp; &nbsp;Scratch resistant sapphire crystal</span><br><strong>Dial</strong><span>:&nbsp; Blue Dial</span></p>
    <p><b>Bezel: </b>18K White Gold Fluted Bezel</p>
    <p><strong>Bracelet:</strong> Stainless Steel and White Gold Jubilee Bracelet.<br><strong>Condition</strong><span>: &nbsp; &nbsp;Excellent condition.</span><br><strong>Working Condition</strong><span>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</span><br><strong>Authenticity</strong><span>: &nbsp; &nbsp;100% authentic.</span><br><strong>Warranty</strong><span>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p></div>`,
    description2: `<div class="productdesc"><p><strong>Brand</strong><span>:&nbsp; &nbsp; Rolex</span><br><strong>Model Name</strong><span>:&nbsp; Rolex Stainless Steel and White Gold Datejust with Jubilee Bracelet</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model Number</strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">:&nbsp; &nbsp; 16014</span></p>
    <p><strong>Movement</strong><span>: &nbsp; Automatic</span><br><strong>Case</strong><span>:&nbsp; &nbsp;36 mm Case diameter.</span><br><strong>Crystal</strong><span>: &nbsp; &nbsp;Scratch resistant sapphire crystal</span><br><strong>Dial</strong><span>:&nbsp; Blue Dial</span></p>
    <p><b>Bezel: </b>18K White Gold Fluted Bezel</p>
    <p><strong>Bracelet:</strong> Stainless Steel and White Gold Jubilee Bracelet.<br><strong>Condition</strong><span>: &nbsp; &nbsp;Excellent condition.</span><br><strong>Working Condition</strong><span>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</span><br><strong>Authenticity</strong><span>: &nbsp; &nbsp;100% authentic.</span><br><strong>Warranty</strong><span>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p></div>`,
    prices: [{ unit: "unit", amount: 7000.0 }],
  } as Product,
  {
    id: "rolex-submariner-date-116610ln-40mm-black-dial-with-stainless-steel-bracelet-copy",
    name: "Rolex Submariner Date 40MM Stainless Steel Black Insert Bezel Black Dial 16610",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-submariner-date-116610ln-40mm-black-dial-with-stainless-steel-bracelet-copy.jfif",
    description: `<div class="productdesc"><ul>
    <li>
    <p><strong>Brand:</strong> Rolex</p>
    </li>
    <li>
    <p><strong>Model Name:</strong> Submariner</p>
    </li>
    <li>
    <p><strong>Model Number:</strong> 16610</p>
    </li>
    <li>
    <p><strong>Movement:</strong> Automatic</p>
    </li>
    <li>
    <p><strong>Case:</strong> Stainless Steel</p>
    </li>
    <li>
    <p><strong>Bezel:</strong> Stainless steel bezel with black insert</p>
    </li>
    <li>
    <p><strong>Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li>
    <p><strong>Dial:</strong> Black dial</p>
    </li>
    <li>
    <p><strong>Bracelet:</strong> Stainless steel Oyster bracelet</p>
    </li>
    <li>
    <p><strong>Condition:</strong> Excellent condition</p>
    </li>
    <li>
    <p><strong>Box &amp; Papers:</strong> Includes Rolex box and appraisal certificate</p>
    </li>
    <li>
    <p><strong>Age:</strong> 1989–1994</p>
    </li>
    <li>
    <p><strong>Working Condition:</strong> Timed to precision on Witschi watch expert timing machine; running strong and keeping accurate time</p>
    </li>
    <li>
    <p><strong>Authenticity:</strong> 100% authentic. Inspected and certified by our elite in-house team of Swiss-trained master watchmakers</p>
    </li>
    <li>
    <p><strong>Warranty:</strong> Covered by JD Watches 24-month warranty</p>
    </li>
    </ul></div>`,
    description2: `<div class="productdesc"><ul>
    <li>
    <p><strong>Brand:</strong> Rolex</p>
    </li>
    <li>
    <p><strong>Model Name:</strong> Submariner</p>
    </li>
    <li>
    <p><strong>Model Number:</strong> 16610</p>
    </li>
    <li>
    <p><strong>Movement:</strong> Automatic</p>
    </li>
    <li>
    <p><strong>Case:</strong> Stainless Steel</p>
    </li>
    <li>
    <p><strong>Bezel:</strong> Stainless steel bezel with black insert</p>
    </li>
    <li>
    <p><strong>Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li>
    <p><strong>Dial:</strong> Black dial</p>
    </li>
    <li>
    <p><strong>Bracelet:</strong> Stainless steel Oyster bracelet</p>
    </li>
    <li>
    <p><strong>Condition:</strong> Excellent condition</p>
    </li>
    <li>
    <p><strong>Box &amp; Papers:</strong> Includes Rolex box and appraisal certificate</p>
    </li>
    <li>
    <p><strong>Age:</strong> 1989–1994</p>
    </li>
    <li>
    <p><strong>Working Condition:</strong> Timed to precision on Witschi watch expert timing machine; running strong and keeping accurate time</p>
    </li>
    <li>
    <p><strong>Authenticity:</strong> 100% authentic. Inspected and certified by our elite in-house team of Swiss-trained master watchmakers</p>
    </li>
    <li>
    <p><strong>Warranty:</strong> Covered by JD Watches 24-month warranty</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 10800.0 }],
  } as Product,
  {
    id: "rolex-datejust-36-16013-gold-steel-with-champagne-linen-dial-on-jubilee-bracelet",
    name: "Rolex Datejust 36 16013 – Gold & Steel with Champagne Linen Dial on Jubilee Bracelet",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-datejust-36-16013-gold-steel-with-champagne-linen-dial-on-jubilee-bracelet.jfif",
    description: `<p data-start="1068" data-end="1434" class=""><strong data-start="1068" data-end="1078">Model:</strong> Rolex Datejust 36<br data-start="1096" data-end="1099"><strong data-start="1099" data-end="1113">Reference:</strong> 16013<br data-start="1119" data-end="1122"><strong data-start="1122" data-end="1140">Case Material:</strong> Stainless Steel with 18k Yellow Gold Fluted Bezel<br data-start="1190" data-end="1193"><strong data-start="1193" data-end="1207">Case Size:</strong> 36mm<br data-start="1212" data-end="1215"><strong data-start="1215" data-end="1224">Dial:</strong> Champagne Linen with Applied Gold Hour Markers<br data-start="1271" data-end="1274"><strong data-start="1274" data-end="1287">Bracelet:</strong> Two-Tone Jubilee (Stainless Steel &amp; 18k Yellow Gold)<br data-start="1340" data-end="1343" data-is-only-node=""><strong data-start="1343" data-end="1354">Buckle:</strong> Fold-Over Clasp<br data-start="1370" data-end="1373"><strong data-start="1373" data-end="1386">Movement:</strong> Automatic – Rolex Caliber 3035<br data-start="1417" data-end="1420"><strong data-start="1420" data-end="1434">Functions:</strong></p>`,
    description2: `<div class="productdesc"><p data-start="106" data-end="194" class=""><strong data-start="106" data-end="194">Rolex Datejust 36 16013 – Gold &amp; Steel with Champagne Linen Dial on Jubilee Bracelet</strong></p>
    <p data-start="196" data-end="605" class="">Timeless elegance meets iconic Rolex design in the <strong data-start="247" data-end="284">Rolex Datejust 36 reference 16013</strong>, a striking two-tone classic that captures the essence of refined sophistication. Featuring a 36mm stainless steel case with an 18k yellow gold fluted bezel, this model pairs perfectly with a vintage <strong data-start="485" data-end="509">champagne linen dial</strong>—a rare and coveted texture that adds depth and character to an already distinguished aesthetic.</p>
    <p data-start="607" data-end="822" class="">The <strong data-start="611" data-end="631">Jubilee bracelet</strong>, originally designed for the Datejust in 1945, completes the look with its supple five-link construction in stainless steel and yellow gold, offering comfort and unmistakable Rolex heritage.</p>
    <p data-start="824" data-end="1038" class="">Powered by the reliable <strong data-start="848" data-end="883">Caliber 3035 automatic movement</strong>, this timepiece includes a quickset date function and smooth sweep seconds, housed under scratch-resistant acrylic crystal for that classic vintage charm.</p>
    <hr data-start="1040" data-end="1043" class="">
    <h3 data-start="1045" data-end="1066" class=""><strong data-start="1049" data-end="1066">Key Features:</strong></h3>
    <p data-start="1068" data-end="1434" class=""><strong data-start="1068" data-end="1078">Model:</strong> Rolex Datejust 36<br data-start="1096" data-end="1099"><strong data-start="1099" data-end="1113">Reference:</strong> 16013<br data-start="1119" data-end="1122"><strong data-start="1122" data-end="1140">Case Material:</strong> Stainless Steel with 18k Yellow Gold Fluted Bezel<br data-start="1190" data-end="1193"><strong data-start="1193" data-end="1207">Case Size:</strong> 36mm<br data-start="1212" data-end="1215"><strong data-start="1215" data-end="1224">Dial:</strong> Champagne Linen with Applied Gold Hour Markers<br data-start="1271" data-end="1274"><strong data-start="1274" data-end="1287">Bracelet:</strong> Two-Tone Jubilee (Stainless Steel &amp; 18k Yellow Gold)<br data-start="1340" data-end="1343" data-is-only-node=""><strong data-start="1343" data-end="1354">Buckle:</strong> Fold-Over Clasp<br data-start="1370" data-end="1373"><strong data-start="1373" data-end="1386">Movement:</strong> Automatic – Rolex Caliber 3035<br data-start="1417" data-end="1420"><strong data-start="1420" data-end="1434">Functions:</strong></p>
    <ul data-start="1435" data-end="1730">
    <li data-start="1435" data-end="1462" class="">
    <p data-start="1437" data-end="1462" class="">Hours, Minutes, Seconds</p>
    </li>
    <li data-start="1463" data-end="1730" class="">
    <p data-start="1465" data-end="1730" class="">Quickset Date at 3 o’clock<br data-start="1491" data-end="1494"><strong data-start="1494" data-end="1506">Crystal:</strong> Acrylic<br data-start="1514" data-end="1517"><strong data-start="1517" data-end="1531">Case Back:</strong> Solid Stainless Steel<br data-start="1553" data-end="1556"><strong data-start="1556" data-end="1577">Water Resistance:</strong> 100m&nbsp;<br data-start="1618" data-end="1621"><strong data-start="1621" data-end="1635">Condition:</strong> Pre-Owned</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 7500.0 }],
  } as Product,
  {
    id: "rolex-lady-datejust-26mm-69173-champagne-diamond-dial-18k-yellow-gold-amp-stainless-steel-jubilee-bracelet",
    name: "Rolex Lady-Datejust 26mm – 69173, Champagne Diamond Dial, 18k Yellow Gold & Stainless Steel Jubilee Bracelet",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-lady-datejust-26mm-69173-champagne-diamond-dial-18k-yellow-gold-amp-stainless-steel-jubilee-bracelet.jfif",
    description: `<p data-start="1404" data-end="2090" class=""><strong data-start="1404" data-end="1423">Specifications:</strong><br data-start="1423" data-end="1426"><strong data-start="1426" data-end="1436">Brand:</strong> Rolex<br data-start="1442" data-end="1445"><strong data-start="1445" data-end="1455">Model:</strong> Lady-Datejust 26mm<br data-start="1474" data-end="1477"><strong data-start="1477" data-end="1498">Reference Number:</strong> 69173<br data-start="1504" data-end="1507"><strong data-start="1507" data-end="1525">Case Material:</strong> Stainless Steel &amp; 18k Yellow Gold<br data-start="1559" data-end="1562"><strong data-start="1562" data-end="1580">Case Diameter:</strong> 26mm<br data-start="1585" data-end="1588"><strong data-start="1588" data-end="1598">Bezel:</strong> Fluted 18k Yellow Gold<br data-start="1621" data-end="1624"><strong data-start="1624" data-end="1633">Dial:</strong> Champagne with Diamond Hour Markers<br data-start="1669" data-end="1672"><strong data-start="1672" data-end="1689">Date Display:</strong> At 3 o'clock with Cyclops Lens<br data-start="1720" data-end="1723"><strong data-start="1723" data-end="1736">Bracelet:</strong> Two-Tone Jubilee Bracelet (Stainless Steel and 18k Yellow Gold)<br data-start="1800" data-end="1803"><strong data-start="1803" data-end="1816">Movement:</strong> Rolex Caliber 2135, Self-Winding Automatic<br data-start="1859" data-end="1862"><strong data-start="1862" data-end="1880">Power Reserve:</strong> Approximately 48 Hours<br data-start="1903" data-end="1906"><strong data-start="1906" data-end="1920">Functions:</strong> Hours, Minutes, Seconds, Date<br data-start="1950" data-end="1953"><strong data-start="1953" data-end="1965">Crystal:</strong> Scratch-resistant Sapphire<br data-start="1992" data-end="1995"><strong data-start="1995" data-end="2016">Water Resistance:</strong> 100 meters / 330 feet<br data-start="2038" data-end="2041"><strong data-start="2041" data-end="2055">Condition:</strong> Excellent (JD Certified Pre-Owned)</p>`,
    description2: `<div class="productdesc"><p data-start="160" data-end="301" class=""><strong data-start="160" data-end="272">Rolex Lady-Datejust 26mm – 69173, Champagne Diamond Dial, 18k Yellow Gold &amp; Stainless Steel Jubilee Bracelet</strong><br data-start="272" data-end="275"><strong data-start="275" data-end="301">JD Certified Pre-Owned</strong></p>
    <p data-start="303" data-end="798" class=""><strong data-start="303" data-end="319">Description:</strong><br data-start="319" data-end="322">The Rolex Lady-Datejust 69173 26mm is a vintage masterpiece that combines elegance, luxury, and a touch of sparkle. Featuring a stunning champagne dial adorned with diamond hour markers, this timepiece exudes sophistication and timeless beauty. The diamonds catch the light, adding a hint of glamour to the already exquisite design. The 26mm case is crafted in a durable combination of stainless steel and 18k yellow gold, offering both strength and a warm, refined aesthetic.</p>
    <p data-start="800" data-end="1229" class="">The Lady-Datejust 69173 is powered by the automatic Rolex Caliber 2135 movement, providing precision timekeeping with a 48-hour power reserve. The watch is equipped with the signature Jubilee bracelet, a five-piece link design that is comfortable to wear and perfectly complements the elegant two-tone case. The date display at 3 o'clock is magnified by the iconic Cyclops lens, ensuring that the wearer can easily read the date.</p>
    <p data-start="1231" data-end="1402" class="">A true classic, the Rolex Lady-Datejust 69173 is the ideal piece for any woman seeking a sophisticated, vintage timepiece that can seamlessly transition from day to night.</p>
    <p data-start="1404" data-end="2090" class=""><strong data-start="1404" data-end="1423">Specifications:</strong><br data-start="1423" data-end="1426"><strong data-start="1426" data-end="1436">Brand:</strong> Rolex<br data-start="1442" data-end="1445"><strong data-start="1445" data-end="1455">Model:</strong> Lady-Datejust 26mm<br data-start="1474" data-end="1477"><strong data-start="1477" data-end="1498">Reference Number:</strong> 69173<br data-start="1504" data-end="1507"><strong data-start="1507" data-end="1525">Case Material:</strong> Stainless Steel &amp; 18k Yellow Gold<br data-start="1559" data-end="1562"><strong data-start="1562" data-end="1580">Case Diameter:</strong> 26mm<br data-start="1585" data-end="1588"><strong data-start="1588" data-end="1598">Bezel:</strong> Fluted 18k Yellow Gold<br data-start="1621" data-end="1624"><strong data-start="1624" data-end="1633">Dial:</strong> Champagne with Diamond Hour Markers<br data-start="1669" data-end="1672"><strong data-start="1672" data-end="1689">Date Display:</strong> At 3 o'clock with Cyclops Lens<br data-start="1720" data-end="1723"><strong data-start="1723" data-end="1736">Bracelet:</strong> Two-Tone Jubilee Bracelet (Stainless Steel and 18k Yellow Gold)<br data-start="1800" data-end="1803"><strong data-start="1803" data-end="1816">Movement:</strong> Rolex Caliber 2135, Self-Winding Automatic<br data-start="1859" data-end="1862"><strong data-start="1862" data-end="1880">Power Reserve:</strong> Approximately 48 Hours<br data-start="1903" data-end="1906"><strong data-start="1906" data-end="1920">Functions:</strong> Hours, Minutes, Seconds, Date<br data-start="1950" data-end="1953"><strong data-start="1953" data-end="1965">Crystal:</strong> Scratch-resistant Sapphire<br data-start="1992" data-end="1995"><strong data-start="1995" data-end="2016">Water Resistance:</strong> 100 meters / 330 feet<br data-start="2038" data-end="2041"><strong data-start="2041" data-end="2055">Condition:</strong> Excellent (JD Certified Pre-Owned)</p></div>`,
    prices: [{ unit: "unit", amount: 6500.0 }],
  } as Product,
  {
    id: "rolex-stainless-steel-oyster-perpetual-76080-24mm-with-oyster-bracelet",
    name: "Rolex Stainless Steel Oyster Perpetual 76080 24mm with Oyster Bracelet",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-stainless-steel-oyster-perpetual-76080-24mm-with-oyster-bracelet.jfif",
    description: `<div class="productdesc"><div>
    <span data-canva-clipboard="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"></span>
    <div>
    <div>
    <p><span><meta charset="utf-8"> <strong>Brand</strong>: &nbsp; &nbsp;Rolex<br><strong>Model Name</strong>: &nbsp;Rolex Stainless Steel Oyster Perpetual 24mm with Oyster Bracelet<br><strong>Model Number</strong>:&nbsp; &nbsp; 76080<br><strong>Gender</strong>:&nbsp; &nbsp; Ladies<br><strong>Movement</strong>: Automatic self-winding movement.<br><strong>Case</strong>:&nbsp; &nbsp; 24mm Stainless Steel<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless Steel Smooth Bezel<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal&nbsp;<br><strong>Dial</strong>: &nbsp; &nbsp;Pink Arabic Dial<br><strong>Bracelet</strong>: &nbsp;Stainless Steel Oyster Bracelet<br><strong>Condition</strong>:&nbsp; Excellent&nbsp;<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic.<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p>
    </div>
    </div>
    </div></div>`,
    description2: `<div class="productdesc"><div>
    <span data-canva-clipboard="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"></span>
    <div>
    <div>
    <p><span><meta charset="utf-8"> <strong>Brand</strong>: &nbsp; &nbsp;Rolex<br><strong>Model Name</strong>: &nbsp;Rolex Stainless Steel Oyster Perpetual 24mm with Oyster Bracelet<br><strong>Model Number</strong>:&nbsp; &nbsp; 76080<br><strong>Gender</strong>:&nbsp; &nbsp; Ladies<br><strong>Movement</strong>: Automatic self-winding movement.<br><strong>Case</strong>:&nbsp; &nbsp; 24mm Stainless Steel<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless Steel Smooth Bezel<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal&nbsp;<br><strong>Dial</strong>: &nbsp; &nbsp;Pink Arabic Dial<br><strong>Bracelet</strong>: &nbsp;Stainless Steel Oyster Bracelet<br><strong>Condition</strong>:&nbsp; Excellent&nbsp;<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic.<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p>
    </div>
    </div>
    </div></div>`,
    prices: [{ unit: "unit", amount: 4000.0 }],
  } as Product,
  {
    id: "rolex-daytona-116503-two-tone-18k-yellow-gold-stainless-steel-mother-of-pearl-diamond-dial",
    name: "Rolex Daytona 116503 – Two-Tone 18k Yellow Gold & Stainless Steel Mother of Pearl Diamond Dial",
    category: "Rolex",
    photo:
      "assets/img/products/rolex-daytona-116503-two-tone-18k-yellow-gold-stainless-steel-mother-of-pearl-diamond-dial.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/diamond-rolex">
  Rolex
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         

     <a href="/collections/diamond-rolex?rb_snize_facet1=Daytona">Daytona</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">116503</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           

     <a href="/collections/diamond-rolex?rb_snize_facet2=40mm">40mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed 18k yellow gold tachymeter bezel</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">White mother of pearl dial with diamond hour markers and luminous hands</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Swiss automatic Rolex Caliber 4130 chronograph movement</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Two-tone Oyster bracelet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">100 meters (330 feet)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           

     <a href="/collections/diamond-rolex?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><p>The Rolex Daytona 116503 pairs 18k yellow gold and stainless steel in a two-tone design, featuring a stunning mother of pearl dial with diamond hour markers.</p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/diamond-rolex">
  Rolex
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         

     <a href="/collections/diamond-rolex?rb_snize_facet1=Daytona">Daytona</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">116503</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           

     <a href="/collections/diamond-rolex?rb_snize_facet2=40mm">40mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed 18k yellow gold tachymeter bezel</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">White mother of pearl dial with diamond hour markers and luminous hands</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Swiss automatic Rolex Caliber 4130 chronograph movement</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Two-tone Oyster bracelet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">100 meters (330 feet)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           

     <a href="/collections/diamond-rolex?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 28400.0 }],
  } as Product,
  // Rolex End Brand Collection

  // Audemars Piguet Start Brand Collection
  {
    id: "audemars-piguet-royal-oak-perpetual-calendar-26579cs-oo-1225cs-01-blue-ceramic",
    name: "Audemars Piguet Royal Oak Perpetual Calendar 26579CS.OO.1225CS.01 Blue Ceramic",
    category: "Audemars Piguet",
    photo:
      "assets/img/products/audemars-piguet-royal-oak-perpetual-calendar-26579cs-oo-1225cs-01-blue-ceramic.jfif",
    description: `<ul data-start="1391" data-end="1844">
    <li data-section-id="1f15ig9" data-start="1391" data-end="1426">
    <strong data-start="1393" data-end="1403">Model:</strong> 26579CS.OO.1225CS.01</li>
    <li data-section-id="ebyk06" data-start="1427" data-end="1450">
    <strong data-start="1429" data-end="1443">Case Size:</strong> 41mm</li>
    <li data-section-id="hhc47h" data-start="1451" data-end="1497">
    <strong data-start="1453" data-end="1466">Material:</strong> Blue ceramic case &amp; bracelet</li>
    <li data-section-id="72pmgo" data-start="1498" data-end="1556">
    <strong data-start="1500" data-end="1509">Dial:</strong> Blue perpetual calendar</li>
    <li data-section-id="6eexnt" data-start="1557" data-end="1607">
    <strong data-start="1559" data-end="1572">Bracelet:</strong> Integrated blue ceramic bracelet</li>
    <li data-section-id="11egyr7" data-start="1608" data-end="1685">
    <strong data-start="1610" data-end="1623">Movement:</strong> Audemars Piguet Caliber 5135 (Automatic Perpetual Calendar)</li>
    <li data-section-id="etjisg" data-start="1686" data-end="1743">
    <strong data-start="1688" data-end="1702">Functions:</strong> Day, date, month, leap year, moonphase</li>
    <li data-section-id="wddtmq" data-start="1744" data-end="1798">
    <strong data-start="1746" data-end="1758">Crystal:</strong> Sapphire crystal (front and caseback)</li>
    <li data-section-id="1p51alf" data-start="1799" data-end="1844">
    <strong data-start="1801" data-end="1822">Water Resistance:</strong> 20 meters / 66 feet</li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="201" data-end="578">Ultra-rare, technically extraordinary, and visually breathtaking — the Audemars Piguet Royal Oak Perpetual Calendar 26579CS.OO.1225CS.01 is one of the most advanced and collectible modern Royal Oaks ever produced. Crafted entirely in&nbsp;<strong data-start="446" data-end="462">blue ceramic</strong>, this 41mm timepiece represents the pinnacle of innovation, combining high-tech materials with elite complications.</p>
    <p data-start="580" data-end="921">&nbsp;The layout includes <strong data-start="785" data-end="831">day, date, month, leap year, and moonphase</strong>, all seamlessly integrated into the skeletonized display without compromising legibility.</p>
    <p data-start="923" data-end="1143">The striking <strong data-start="936" data-end="981">blue ceramic case and integrated bracelet</strong> offer exceptional scratch resistance and durability while delivering a bold, contemporary aesthetic that sets this piece apart from traditional Royal Oak models.</p>
    <p data-start="1145" data-end="1362">At its core is the in-house <strong data-start="1173" data-end="1224">Audemars Piguet Caliber 5135 automatic movement</strong>, a highly complex perpetual calendar mechanism finished to the highest standards and visible through both the dial and sapphire caseback.</p>
    <hr data-start="1364" data-end="1367">
    <h3 data-section-id="1s1yvt8" data-start="1369" data-end="1390"><span role="text"><strong data-start="1373" data-end="1390">Key Features:</strong></span></h3>
    <ul data-start="1391" data-end="1844">
    <li data-section-id="1f15ig9" data-start="1391" data-end="1426">
    <strong data-start="1393" data-end="1403">Model:</strong> 26579CS.OO.1225CS.01</li>
    <li data-section-id="ebyk06" data-start="1427" data-end="1450">
    <strong data-start="1429" data-end="1443">Case Size:</strong> 41mm</li>
    <li data-section-id="hhc47h" data-start="1451" data-end="1497">
    <strong data-start="1453" data-end="1466">Material:</strong> Blue ceramic case &amp; bracelet</li>
    <li data-section-id="72pmgo" data-start="1498" data-end="1556">
    <strong data-start="1500" data-end="1509">Dial:</strong> Blue perpetual calendar</li>
    <li data-section-id="6eexnt" data-start="1557" data-end="1607">
    <strong data-start="1559" data-end="1572">Bracelet:</strong> Integrated blue ceramic bracelet</li>
    <li data-section-id="11egyr7" data-start="1608" data-end="1685">
    <strong data-start="1610" data-end="1623">Movement:</strong> Audemars Piguet Caliber 5135 (Automatic Perpetual Calendar)</li>
    <li data-section-id="etjisg" data-start="1686" data-end="1743">
    <strong data-start="1688" data-end="1702">Functions:</strong> Day, date, month, leap year, moonphase</li>
    <li data-section-id="wddtmq" data-start="1744" data-end="1798">
    <strong data-start="1746" data-end="1758">Crystal:</strong> Sapphire crystal (front and caseback)</li>
    <li data-section-id="1p51alf" data-start="1799" data-end="1844">
    <strong data-start="1801" data-end="1822">Water Resistance:</strong> 20 meters / 66 feet</li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 460000.0 }],
  } as Product,
  {
    id: "audemars-piguet-royal-oak-selfwinding-chronograph-41mm-18k-rose-gold-green-grande-tapisserie-dial-ref-26240or-oo-1320or-04-nbsp",
    name: "Audemars Piguet Royal Oak Selfwinding Chronograph 41mm – 18K Rose Gold – Green Grande Tapisserie Dial – Ref. 26240OR.OO.1320OR.04",
    category: "Audemars Piguet",
    photo:
      "assets/img/products/audemars-piguet-royal-oak-selfwinding-chronograph-41mm-18k-rose-gold-green-grande-tapisserie-dial-ref-26240or-oo-1320or-04-nbsp.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/audemars-piguet">
  Audemars Piguet
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/audemars-piguet?rb_snize_facet1= Royal Oak Selfwinding Chronograph"> Royal Oak Selfwinding Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">26240OR.OO.1320OR.04</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/audemars-piguet?rb_snize_facet2=41mm">41mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed, octagonal, 18K rose gold</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Green “Grande Tapisserie” with rose gold hands and markers, date at 4:30</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Caliber 4401 – In-house automatic flyback chronograph</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Integrated 18K rose gold bracelet with AP folding clasp</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">50 meters / 5 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/audemars-piguet?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><p>The Audemars Piguet Royal Oak Selfwinding Chronograph Ref. 26240OR.OO.1320OR.04 is a stunning tribute to 50 years of one of the most iconic designs in horology. This 41mm timepiece is crafted entirely in 18K rose gold and features a striking green “Grande Tapisserie” dial — a rare and collectible configuration highly sought after by collectors. The case showcases the latest evolution of the Royal Oak design, with refined bevels, updated ergonomics, and the signature integrated bracelet. The green dial contrasts beautifully with the rose gold hands and applied hour markers, all with luminescent coating for optimal legibility. Three chronograph subdials and a discreet date window at 4:30 add balance and function.&nbsp;Inside, the watch is powered by the in-house Caliber 4401, a flyback chronograph movement visible through the sapphire caseback.&nbsp;</p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/audemars-piguet">
  Audemars Piguet
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/audemars-piguet?rb_snize_facet1= Royal Oak Selfwinding Chronograph"> Royal Oak Selfwinding Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">26240OR.OO.1320OR.04</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/audemars-piguet?rb_snize_facet2=41mm">41mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed, octagonal, 18K rose gold</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Green “Grande Tapisserie” with rose gold hands and markers, date at 4:30</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Caliber 4401 – In-house automatic flyback chronograph</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Integrated 18K rose gold bracelet with AP folding clasp</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">50 meters / 5 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/audemars-piguet?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 126500.0 }],
  } as Product,
  {
    id: "audemars-piguet-royal-oak-openworked-39mm-steel-skeleton-dial-15305st",
    name: "Audemars Piguet Royal Oak Openworked 39mm Steel Skeleton Dial 15305ST",
    category: "Audemars Piguet",
    photo:
      "assets/img/products/audemars-piguet-royal-oak-openworked-39mm-steel-skeleton-dial-15305st.jfif",
    description: `<ul data-start="1392" data-end="2030">
    <li data-section-id="h5tfxn" data-start="1392" data-end="1422">
    <strong data-start="1394" data-end="1404">Brand:</strong> Audemars Piguet</li>
    <li data-section-id="1ensfvp" data-start="1423" data-end="1458">
    <strong data-start="1425" data-end="1435">Model:</strong> Royal Oak Openworked</li>
    <li data-section-id="1vuheti" data-start="1459" data-end="1505">
    <strong data-start="1461" data-end="1482">Reference Number:</strong> 15305ST.OO.1220ST.01</li>
    <li data-section-id="8ntqsp" data-start="1506" data-end="1529">
    <strong data-start="1508" data-end="1522">Case Size:</strong> 39mm</li>
    <li data-section-id="egkgby" data-start="1530" data-end="1568">
    <strong data-start="1532" data-end="1550">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="lj31ao" data-start="1569" data-end="1619">
    <strong data-start="1571" data-end="1581">Bezel:</strong> Stainless Steel, Brushed &amp; Polished</li>
    <li data-section-id="lytuze" data-start="1620" data-end="1659">
    <strong data-start="1622" data-end="1631">Dial:</strong> Skeletonized / Openworked</li>
    <li data-section-id="1itv0na" data-start="1660" data-end="1713">
    <strong data-start="1662" data-end="1675">Bracelet:</strong> Integrated Stainless Steel Bracelet</li>
    <li data-section-id="1tgvhnf" data-start="1714" data-end="1761">
    <strong data-start="1716" data-end="1729">Movement:</strong> AP Caliber 3120 (Selfwinding)</li>
    <li data-section-id="1k1afra" data-start="1762" data-end="1794">
    <strong data-start="1764" data-end="1782">Power Reserve:</strong> ~60 Hours</li>
    <li data-section-id="12g72au" data-start="1795" data-end="1850">
    <strong data-start="1797" data-end="1809">Crystal:</strong> Sapphire (Front &amp; Exhibition Caseback)</li>
    <li data-section-id="18hwqft" data-start="1851" data-end="1886">
    <strong data-start="1853" data-end="1874">Water Resistance:</strong> 50 meters</li>
    <li data-section-id="f3mej2" data-start="1887" data-end="1929">
    <strong data-start="1889" data-end="1903">Functions:</strong> Hours, Minutes, Seconds</li>
    <li data-section-id="14c44fb" data-start="1930" data-end="1976">
    <strong data-start="1932" data-end="1946">Condition:</strong> Mint</li>
    <li data-section-id="1wtxqpd" data-start="1977" data-end="2030">
    <strong data-start="1979" data-end="2001">Scope of Delivery:</strong> Box &amp; Papers</li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="183" data-end="396">The Audemars Piguet Royal Oak 15305ST Openworked Steel is a landmark piece in the evolution of the Royal Oak—one of the earliest modern openworked models produced in stainless steel, and a true collector favorite.</p>
    <p data-start="398" data-end="769">Housed in a 39mm stainless steel case, this reference preserves the classic proportions of the original Royal Oak design while introducing a fully skeletonized dial that reveals the intricate architecture of the movement. Every bridge and component is meticulously finished, offering a clear view into the craftsmanship that defines <span class="hover:entity-accent entity-underline inline cursor-pointer align-baseline"><span class="whitespace-normal">Audemars Piguet</span></span>.</p>
    <p data-start="771" data-end="1113">At its core is the selfwinding Caliber 3120, a highly respected in-house movement known for its reliability and refined finishing, including the signature 22K gold rotor visible through the caseback. The openworked design transforms the watch into a dynamic display of mechanical artistry—blending traditional horology with modern aesthetics.</p>
    <p data-start="1115" data-end="1364">Integrated seamlessly with the iconic steel bracelet, the 15305ST delivers both everyday wearability and high-end appeal. Discontinued and increasingly difficult to source, it stands as one of the most important openworked Royal Oaks for collectors.</p>
    <hr data-start="1366" data-end="1369">
    <h3 data-section-id="pm8yra" data-start="1371" data-end="1391"><span role="text"><strong data-start="1375" data-end="1391">Key Features</strong></span></h3>
    <ul data-start="1392" data-end="2030">
    <li data-section-id="h5tfxn" data-start="1392" data-end="1422">
    <strong data-start="1394" data-end="1404">Brand:</strong> Audemars Piguet</li>
    <li data-section-id="1ensfvp" data-start="1423" data-end="1458">
    <strong data-start="1425" data-end="1435">Model:</strong> Royal Oak Openworked</li>
    <li data-section-id="1vuheti" data-start="1459" data-end="1505">
    <strong data-start="1461" data-end="1482">Reference Number:</strong> 15305ST.OO.1220ST.01</li>
    <li data-section-id="8ntqsp" data-start="1506" data-end="1529">
    <strong data-start="1508" data-end="1522">Case Size:</strong> 39mm</li>
    <li data-section-id="egkgby" data-start="1530" data-end="1568">
    <strong data-start="1532" data-end="1550">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="lj31ao" data-start="1569" data-end="1619">
    <strong data-start="1571" data-end="1581">Bezel:</strong> Stainless Steel, Brushed &amp; Polished</li>
    <li data-section-id="lytuze" data-start="1620" data-end="1659">
    <strong data-start="1622" data-end="1631">Dial:</strong> Skeletonized / Openworked</li>
    <li data-section-id="1itv0na" data-start="1660" data-end="1713">
    <strong data-start="1662" data-end="1675">Bracelet:</strong> Integrated Stainless Steel Bracelet</li>
    <li data-section-id="1tgvhnf" data-start="1714" data-end="1761">
    <strong data-start="1716" data-end="1729">Movement:</strong> AP Caliber 3120 (Selfwinding)</li>
    <li data-section-id="1k1afra" data-start="1762" data-end="1794">
    <strong data-start="1764" data-end="1782">Power Reserve:</strong> ~60 Hours</li>
    <li data-section-id="12g72au" data-start="1795" data-end="1850">
    <strong data-start="1797" data-end="1809">Crystal:</strong> Sapphire (Front &amp; Exhibition Caseback)</li>
    <li data-section-id="18hwqft" data-start="1851" data-end="1886">
    <strong data-start="1853" data-end="1874">Water Resistance:</strong> 50 meters</li>
    <li data-section-id="f3mej2" data-start="1887" data-end="1929">
    <strong data-start="1889" data-end="1903">Functions:</strong> Hours, Minutes, Seconds</li>
    <li data-section-id="14c44fb" data-start="1930" data-end="1976">
    <strong data-start="1932" data-end="1946">Condition:</strong> Mint</li>
    <li data-section-id="1wtxqpd" data-start="1977" data-end="2030">
    <strong data-start="1979" data-end="2001">Scope of Delivery:</strong> Box &amp; Papers</li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 135000.0 }],
  } as Product,
  {
    id: "audemars-piguet-royal-oak-56175st-midsize-33mm-stainless-steel-white-dial-quartz",
    name: "Audemars Piguet Royal Oak 56175ST Midsize 33mm Stainless Steel White Dial Quartz",
    category: "Audemars Piguet",
    photo:
      "assets/img/products/audemars-piguet-royal-oak-56175st-midsize-33mm-stainless-steel-white-dial-quartz.jfif",
    description: `<ul data-start="1468" data-end="1799">
    <li data-start="1468" data-end="1494">
    <p data-start="1470" data-end="1494"><strong data-start="1470" data-end="1484">Reference:</strong> 56175ST</p>
    </li>
    <li data-start="1495" data-end="1528">
    <p data-start="1497" data-end="1528"><strong data-start="1497" data-end="1511">Case Size:</strong> 33mm (Midsize)</p>
    </li>
    <li data-start="1529" data-end="1567">
    <p data-start="1531" data-end="1567"><strong data-start="1531" data-end="1549">Case Material:</strong> Stainless Steel</p>
    </li>
    <li data-start="1568" data-end="1607">
    <p data-start="1570" data-end="1607"><strong data-start="1570" data-end="1579">Dial:</strong> White “Petite Tapisserie”</p>
    </li>
    <li data-start="1608" data-end="1648">
    <p data-start="1610" data-end="1648"><strong data-start="1610" data-end="1623">Movement:</strong> Audemars Piguet Quartz</p>
    </li>
    <li data-start="1649" data-end="1688">
    <p data-start="1651" data-end="1688"><strong data-start="1651" data-end="1665">Functions:</strong> Hours, Minutes, Date</p>
    </li>
    <li data-start="1689" data-end="1714">
    <p data-start="1691" data-end="1714"><strong data-start="1691" data-end="1703">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1715" data-end="1768">
    <p data-start="1717" data-end="1768"><strong data-start="1717" data-end="1730">Bracelet:</strong> Integrated Stainless Steel Bracelet</p>
    </li>
    <li data-start="1769" data-end="1799">
    <p data-start="1771" data-end="1799"><strong data-start="1771" data-end="1792">Water Resistance:</strong> ~50M</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="279" data-end="499">Clean, refined, and unmistakably iconic—the <strong data-start="323" data-end="360">Audemars Piguet Royal Oak 56175ST</strong> delivers the essence of Gérald Genta’s legendary design in a sleek midsize format, elevated by a crisp <strong data-start="464" data-end="498">white “Petite Tapisserie” dial</strong>.</p>
    <p data-start="501" data-end="758">Crafted entirely in <strong data-start="521" data-end="540">stainless steel</strong>, the 33mm case features the signature Royal Oak architecture: an octagonal bezel with exposed screws, integrated bracelet, and exceptional finishing that transitions seamlessly between brushed and polished surfaces.</p>
    <p data-start="760" data-end="1062">The <strong data-start="764" data-end="787">white textured dial</strong> brings a brighter, more modern feel to this vintage reference—offering strong contrast, excellent legibility, and a more versatile look on the wrist. Paired with applied hour markers, baton hands, and a <strong data-start="991" data-end="1020">date display at 3 o’clock</strong>, the design remains clean and balanced.</p>
    <p data-start="1064" data-end="1273">Powered by a slim <strong data-start="1082" data-end="1101">quartz movement</strong>, the 56175ST prioritizes precision and ease of ownership, allowing for a lightweight, low-maintenance wearing experience—true to many Royal Oak references from this era.</p>
    <p data-start="1275" data-end="1439">At <strong data-start="1278" data-end="1286">33mm</strong>, this watch wears elegantly and comfortably, making it ideal for those who appreciate classic proportions or want a more understated Royal Oak presence.</p>
    <hr data-start="1441" data-end="1444">
    <h3 data-start="1446" data-end="1466"><strong data-start="1450" data-end="1466">Key Features</strong></h3>
    <ul data-start="1468" data-end="1799">
    <li data-start="1468" data-end="1494">
    <p data-start="1470" data-end="1494"><strong data-start="1470" data-end="1484">Reference:</strong> 56175ST</p>
    </li>
    <li data-start="1495" data-end="1528">
    <p data-start="1497" data-end="1528"><strong data-start="1497" data-end="1511">Case Size:</strong> 33mm (Midsize)</p>
    </li>
    <li data-start="1529" data-end="1567">
    <p data-start="1531" data-end="1567"><strong data-start="1531" data-end="1549">Case Material:</strong> Stainless Steel</p>
    </li>
    <li data-start="1568" data-end="1607">
    <p data-start="1570" data-end="1607"><strong data-start="1570" data-end="1579">Dial:</strong> White “Petite Tapisserie”</p>
    </li>
    <li data-start="1608" data-end="1648">
    <p data-start="1610" data-end="1648"><strong data-start="1610" data-end="1623">Movement:</strong> Audemars Piguet Quartz</p>
    </li>
    <li data-start="1649" data-end="1688">
    <p data-start="1651" data-end="1688"><strong data-start="1651" data-end="1665">Functions:</strong> Hours, Minutes, Date</p>
    </li>
    <li data-start="1689" data-end="1714">
    <p data-start="1691" data-end="1714"><strong data-start="1691" data-end="1703">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1715" data-end="1768">
    <p data-start="1717" data-end="1768"><strong data-start="1717" data-end="1730">Bracelet:</strong> Integrated Stainless Steel Bracelet</p>
    </li>
    <li data-start="1769" data-end="1799">
    <p data-start="1771" data-end="1799"><strong data-start="1771" data-end="1792">Water Resistance:</strong> ~50M</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 24500.0 }],
  } as Product,
  {
    id: "audemars-piguet-royal-oak-offshore-chronograph-26170st-42mm-black-dial-with-rubber-bracelet",
    name: "Audemars Piguet Royal Oak Offshore Chronograph 15703ST 42MM Black Dial With Rubber Bracelet",
    category: "Audemars Piguet",
    photo:
      "assets/img/products/audemars-piguet-royal-oak-offshore-chronograph-26170st-42mm-black-dial-with-rubber-bracelet.jfif",
    description: `<p><br><strong>Condition</strong> – Previosly Worn<br><strong>Model</strong> <span data-mce-fragment="1">–</span> Audemars Piguet Royal Oak Offshore Chronograph<br><strong>Reference Number</strong> <span data-mce-fragment="1">–</span> 15703ST.OO.A002CA.01<br><strong>Movement</strong> – Automatic<br><strong>Bezel</strong> <span data-mce-fragment="1">–</span> Stainless Steel<br><strong>Dial</strong> <span data-mce-fragment="1">–</span> Black Dial<br><strong>Case Size</strong> – 42mm <br><strong>Crystal</strong> <span data-mce-fragment="1">–</span> Scratch-resistant Sapphire Crystal <br><strong>Bracelet</strong> <span data-mce-fragment="1">–</span> Rubber Bracelet <br><strong>Water Resistant</strong> <span data-mce-fragment="1">–</span> 10 ATM<br><strong>Gender</strong> – Men's<br><span><strong>Warranty </strong>- The watch is covered by JD Watches 24-month warranty</span>&nbsp;<script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script> <script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p>`,
    description2: `<div class="productdesc"><p>&nbsp;</p>
    <p><strong>Audemars Piguet Royal Oak Offshore Chronograph 15703ST 42MM Black Dial With Rubber Bracelet</strong><br><strong></strong></p>
    <p><br><strong>Condition</strong> – Previosly Worn<br><strong>Model</strong> <span data-mce-fragment="1">–</span> Audemars Piguet Royal Oak Offshore Chronograph<br><strong>Reference Number</strong> <span data-mce-fragment="1">–</span> 15703ST.OO.A002CA.01<br><strong>Movement</strong> – Automatic<br><strong>Bezel</strong> <span data-mce-fragment="1">–</span> Stainless Steel<br><strong>Dial</strong> <span data-mce-fragment="1">–</span> Black Dial<br><strong>Case Size</strong> – 42mm <br><strong>Crystal</strong> <span data-mce-fragment="1">–</span> Scratch-resistant Sapphire Crystal <br><strong>Bracelet</strong> <span data-mce-fragment="1">–</span> Rubber Bracelet <br><strong>Water Resistant</strong> <span data-mce-fragment="1">–</span> 10 ATM<br><strong>Gender</strong> – Men's<br><span><strong>Warranty </strong>- The watch is covered by JD Watches 24-month warranty</span>&nbsp;<script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script> <script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p></div>`,
    prices: [{ unit: "unit", amount: 18750.0 }],
  } as Product,
  // Audemars Piguet End Brand Collection

  // Cartier Start Brand Collection
  {
    id: "cartier-santos-galbee-xl-steel-yellow-gold-mens-watch-w20099c4",
    name: "Cartier Santos Galbee XL W20099C4 Steel Yellow Gold Mens Watch",
    category: "Cartier",
    photo:
      "assets/img/products/cartier-santos-galbee-xl-steel-yellow-gold-mens-watch-w20099c4.jfif",
    description: `<div class="productdesc"><table>
    <tbody>
    <tr data-cow-cart-observed="true">
    <th>Stock Number:</th>
    <td><span>MW01655-6</span></td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Brand:</th>
    <td>Cartier</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Model Name:</th>
    <td>Cartier Santos Galbee XL Steel Yellow Gold Mens Watch W20099C4</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Model Number:</th>
    <td>W20099C4</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Serial Number:</th>
    <td><span>XXXX3523414NX</span></td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Gender:</th>
    <td>Men's</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Movement:</th>
    <td>Automatic self-winding movement, Caliber 049.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Case:</th>
    <td>Stainless steel and 18k yellow gold case 32.0 X 45.0 mm. Stainless steel protected octagonal crown set with a faceted blue spinel cabochon.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Bezel:</th>
    <td>18K yellow gold bezel punctuated with 8 signature screws.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Crystal:</th>
    <td>Scratch resistant sapphire crystal.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Dial:</th>
    <td>Silver dial with black radial Roman numeral hour markers. An inner minute track. Blue sword-shaped hands. Calendar window between 4 and 5 o'clock. Secret Cartier signature at VII.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Bracelet:</th>
    <td>Stainless steel and 18K yellow gold bracelet with a hidden butterfly clasp. Fits an 8 1/4" wrist.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Condition:</th>
    <td>Previously Worn</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Grade:</th>
    <td>Excellent condition.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Engravings:</th>
    <td>None</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Box &amp; Papers:</th>
    <td>Presentation non-Cartier box.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Working Condition:</th>
    <td>Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Authenticity:</th>
    <td>100% authentic.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Warranty:</th>
    <td>The watch is covered by JD Watches 24-month warranty</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Pictures:</th>
    <td>All the photos are of the actual watch for sale.</td>
    </tr>
    </tbody>
    </table></div>`,
    description2: `<div class="productdesc"><table>
    <tbody>
    <tr data-cow-cart-observed="true">
    <th>Stock Number:</th>
    <td><span>MW01655-6</span></td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Brand:</th>
    <td>Cartier</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Model Name:</th>
    <td>Cartier Santos Galbee XL Steel Yellow Gold Mens Watch W20099C4</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Model Number:</th>
    <td>W20099C4</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Serial Number:</th>
    <td><span>XXXX3523414NX</span></td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Gender:</th>
    <td>Men's</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Movement:</th>
    <td>Automatic self-winding movement, Caliber 049.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Case:</th>
    <td>Stainless steel and 18k yellow gold case 32.0 X 45.0 mm. Stainless steel protected octagonal crown set with a faceted blue spinel cabochon.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Bezel:</th>
    <td>18K yellow gold bezel punctuated with 8 signature screws.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Crystal:</th>
    <td>Scratch resistant sapphire crystal.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Dial:</th>
    <td>Silver dial with black radial Roman numeral hour markers. An inner minute track. Blue sword-shaped hands. Calendar window between 4 and 5 o'clock. Secret Cartier signature at VII.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Bracelet:</th>
    <td>Stainless steel and 18K yellow gold bracelet with a hidden butterfly clasp. Fits an 8 1/4" wrist.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Condition:</th>
    <td>Previously Worn</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Grade:</th>
    <td>Excellent condition.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Engravings:</th>
    <td>None</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Box &amp; Papers:</th>
    <td>Presentation non-Cartier box.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Working Condition:</th>
    <td>Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Authenticity:</th>
    <td>100% authentic.</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Warranty:</th>
    <td>The watch is covered by JD Watches 24-month warranty</td>
    </tr>
    <tr data-cow-cart-observed="true">
    <th>Pictures:</th>
    <td>All the photos are of the actual watch for sale.</td>
    </tr>
    </tbody>
    </table></div>`,
    prices: [{ unit: "unit", amount: 7300.0 }],
  } as Product,
  {
    id: "cartier-panthere-6692-18k-yellow-gold-and-stainless-steel-case-with-silver-dial-two-row-bracelet",
    name: "Cartier Panthère W2PN0006, 18k Yellow Gold and Stainless Steel Case with Silver Dial, Two-Row Bracelet",
    category: "Cartier",
    photo:
      "assets/img/products/cartier-panthere-6692-18k-yellow-gold-and-stainless-steel-case-with-silver-dial-two-row-bracelet.jfif",
    description: `<ul data-start="1209" data-end="1666">
    <li data-start="1209" data-end="1231">
    <p data-start="1211" data-end="1231"><strong data-start="1211" data-end="1221">Brand:</strong> Cartier</p>
    </li>
    <li data-start="1232" data-end="1255">
    <p data-start="1234" data-end="1255"><strong data-start="1234" data-end="1244">Model:</strong> Panthère</p>
    </li>
    <li data-start="1256" data-end="1290">
    <p data-start="1258" data-end="1290"><strong data-start="1258" data-end="1279">Reference Number:</strong> W2PN0006</p>
    </li>
    <li data-start="1291" data-end="1349">
    <p data-start="1293" data-end="1349"><strong data-start="1293" data-end="1311">Case Material:</strong> 18k Yellow Gold and Stainless Steel</p>
    </li>
    <li data-start="1350" data-end="1377">
    <p data-start="1352" data-end="1377"><strong data-start="1352" data-end="1370">Case Diameter:</strong> 22mm</p>
    </li>
    <li data-start="1378" data-end="1423">
    <p data-start="1380" data-end="1423"><strong data-start="1380" data-end="1389">Dial:</strong> White with Black Roman Numerals</p>
    </li>
    <li data-start="1424" data-end="1448">
    <p data-start="1426" data-end="1448"><strong data-start="1426" data-end="1439">Movement:</strong> Quartz</p>
    </li>
    <li data-start="1449" data-end="1510">
    <p data-start="1451" data-end="1510"><strong data-start="1451" data-end="1464">Bracelet:</strong> Two-Row Stainless Steel and 18k Yellow Gold</p>
    </li>
    <li data-start="1511" data-end="1548">
    <p data-start="1513" data-end="1548"><strong data-start="1513" data-end="1523">Clasp:</strong> Hidden Butterfly Clasp</p>
    </li>
    <li data-start="1549" data-end="1574">
    <p data-start="1551" data-end="1574"><strong data-start="1551" data-end="1563">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1615" data-end="1666">
    <p data-start="1617" data-end="1666"><strong data-start="1617" data-end="1631">Condition:</strong> Excellent (JD Certified Pre-Owned)</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="0" data-end="134"><strong data-start="0" data-end="105">Cartier Panthère W2PN0006, 18k Yellow Gold and Stainless Steel Case with White Dial, Two-Row Bracelet</strong><br data-start="105" data-end="108"><strong data-start="108" data-end="134">JD Certified Pre-Owned</strong></p>
    <p data-start="136" data-end="574"><strong data-start="136" data-end="152">Description:</strong><br data-start="152" data-end="155">The <strong data-start="159" data-end="188">Cartier Panthère W2PN0006</strong> is a stunning representation of Cartier’s iconic design, seamlessly blending luxury, sophistication, and timeless style. The 18k yellow gold and stainless steel case, with a 22mm diameter, offers a refined, elegant look. Its signature octagonal bezel frames a crisp white dial adorned with bold Roman numerals in black, accompanied by delicate blue steel hands that add a pop of color.</p>
    <p data-start="576" data-end="932">Powered by a precise quartz movement, this timepiece guarantees reliable timekeeping with minimal upkeep. The watch features a two-row bracelet crafted from alternating stainless steel and 18k yellow gold links, which exudes both durability and elegance. The bracelet fastens securely with a hidden butterfly clasp, ensuring a comfortable and seamless fit.</p>
    <p data-start="934" data-end="1185">With its classic combination of gold and stainless steel, as well as the refined Roman numeral dial, the <strong data-start="1039" data-end="1068">Cartier Panthère W2PN0006</strong> is an ideal choice for those seeking a versatile yet luxurious watch for both day-to-day wear and special occasions.</p>
    <p data-start="1187" data-end="1208"><strong data-start="1187" data-end="1206">Specifications:</strong></p>
    <ul data-start="1209" data-end="1666">
    <li data-start="1209" data-end="1231">
    <p data-start="1211" data-end="1231"><strong data-start="1211" data-end="1221">Brand:</strong> Cartier</p>
    </li>
    <li data-start="1232" data-end="1255">
    <p data-start="1234" data-end="1255"><strong data-start="1234" data-end="1244">Model:</strong> Panthère</p>
    </li>
    <li data-start="1256" data-end="1290">
    <p data-start="1258" data-end="1290"><strong data-start="1258" data-end="1279">Reference Number:</strong> W2PN0006</p>
    </li>
    <li data-start="1291" data-end="1349">
    <p data-start="1293" data-end="1349"><strong data-start="1293" data-end="1311">Case Material:</strong> 18k Yellow Gold and Stainless Steel</p>
    </li>
    <li data-start="1350" data-end="1377">
    <p data-start="1352" data-end="1377"><strong data-start="1352" data-end="1370">Case Diameter:</strong> 22mm</p>
    </li>
    <li data-start="1378" data-end="1423">
    <p data-start="1380" data-end="1423"><strong data-start="1380" data-end="1389">Dial:</strong> White with Black Roman Numerals</p>
    </li>
    <li data-start="1424" data-end="1448">
    <p data-start="1426" data-end="1448"><strong data-start="1426" data-end="1439">Movement:</strong> Quartz</p>
    </li>
    <li data-start="1449" data-end="1510">
    <p data-start="1451" data-end="1510"><strong data-start="1451" data-end="1464">Bracelet:</strong> Two-Row Stainless Steel and 18k Yellow Gold</p>
    </li>
    <li data-start="1511" data-end="1548">
    <p data-start="1513" data-end="1548"><strong data-start="1513" data-end="1523">Clasp:</strong> Hidden Butterfly Clasp</p>
    </li>
    <li data-start="1549" data-end="1574">
    <p data-start="1551" data-end="1574"><strong data-start="1551" data-end="1563">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1615" data-end="1666">
    <p data-start="1617" data-end="1666"><strong data-start="1617" data-end="1631">Condition:</strong> Excellent (JD Certified Pre-Owned)</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 9675.0 }],
  } as Product,
  {
    id: "cartier-tank-francaise-small-watch-w51008q3-25mm-white-dial-copy",
    name: "Cartier Tank Francaise Steel Yellow Gold Watch W51006Q4",
    category: "Cartier",
    photo:
      "assets/img/products/cartier-tank-francaise-small-watch-w51008q3-25mm-white-dial-copy.jfif",
    description: `<p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">&nbsp;– Pre-Owned<br data-mce-fragment="1"></span><strong data-mce-fragment="1">Model</strong><span data-mce-fragment="1"> – Cartier&nbsp;Tank Francaise </span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1"> – W51006Q4</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1"> – <span>Quartz movement</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> – Stainless Steel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1"> – <span>Silvered grained dial with black radial Roman numeral hour markers and an inner minute track</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1"> – <span>&nbsp;Rectangular stainless steel case 25.0 x 30.0 mm</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1">&nbsp;– Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> – <span>Stainless steel and 18K yellow gold bracelet with a hidden butterfly clasp</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1">&nbsp;– 3 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1"> – Unisex<br><strong>Box </strong>- Cartier Box<br></span><span data-mce-fragment="1"><span><strong>Warranty&nbsp;</strong>- The watch is covered by JD Watches Inc 24-month warranty</span></span><br></p>`,
    description2: `<div class="productdesc"><h4 class="tablet-hide">Cartier Tank Francaise Steel Yellow Gold Watch W51006Q4</h4>
    <p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">&nbsp;– Pre-Owned<br data-mce-fragment="1"></span><strong data-mce-fragment="1">Model</strong><span data-mce-fragment="1"> – Cartier&nbsp;Tank Francaise </span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1"> – W51006Q4</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1"> – <span>Quartz movement</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> – Stainless Steel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1"> – <span>Silvered grained dial with black radial Roman numeral hour markers and an inner minute track</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1"> – <span>&nbsp;Rectangular stainless steel case 25.0 x 30.0 mm</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1">&nbsp;– Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> – <span>Stainless steel and 18K yellow gold bracelet with a hidden butterfly clasp</span></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1">&nbsp;– 3 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1"> – Unisex<br><strong>Box </strong>- Cartier Box<br></span><span data-mce-fragment="1"><span><strong>Warranty&nbsp;</strong>- The watch is covered by JD Watches Inc 24-month warranty</span></span><br></p></div>`,
    prices: [{ unit: "unit", amount: 6000.0 }],
  } as Product,
  {
    id: "cartier-drive-de-cartier-wsnm0004",
    name: "Cartier Drive de Cartier WSNM0004",
    category: "Cartier",
    photo: "assets/img/products/cartier-drive-de-cartier-wsnm0004.jfif",
    description: `<div class="productdesc"><p><strong>Brand</strong><span>:&nbsp; &nbsp; Cartier</span><span>Extra-Flat</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model: </strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Cartier Drive de Cartier WSNM0004</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model Number</strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">:&nbsp; &nbsp; WSNM0004</span></p>
    <p><strong>Movement</strong><span>: &nbsp; Automatic</span><br><strong>Case</strong><span>:&nbsp; &nbsp;39 mm Case diameter.</span><br><strong>Crystal</strong><span>: &nbsp; &nbsp;Scratch resistant sapphire crystal</span><br><strong>Dial</strong><span>: &nbsp;<meta charset="utf-8">White Roman Dial</span></p>
    <p><strong>Bezel:</strong> <meta charset="utf-8">Polished Stainless Steel Bezel</p>
    <p><strong>Bracelet:</strong> Black Leather Strap<br><strong>Condition</strong><span>: &nbsp; &nbsp;Excellent condition.</span><br><strong>Working Condition</strong><span>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</span><br><strong>Authenticity</strong><span>: &nbsp; &nbsp;100% authentic.</span><br><strong>Warranty</strong><span>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p></div>`,
    description2: `<div class="productdesc"><p><strong>Brand</strong><span>:&nbsp; &nbsp; Cartier</span><span>Extra-Flat</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model: </strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Cartier Drive de Cartier WSNM0004</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model Number</strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">:&nbsp; &nbsp; WSNM0004</span></p>
    <p><strong>Movement</strong><span>: &nbsp; Automatic</span><br><strong>Case</strong><span>:&nbsp; &nbsp;39 mm Case diameter.</span><br><strong>Crystal</strong><span>: &nbsp; &nbsp;Scratch resistant sapphire crystal</span><br><strong>Dial</strong><span>: &nbsp;<meta charset="utf-8">White Roman Dial</span></p>
    <p><strong>Bezel:</strong> <meta charset="utf-8">Polished Stainless Steel Bezel</p>
    <p><strong>Bracelet:</strong> Black Leather Strap<br><strong>Condition</strong><span>: &nbsp; &nbsp;Excellent condition.</span><br><strong>Working Condition</strong><span>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</span><br><strong>Authenticity</strong><span>: &nbsp; &nbsp;100% authentic.</span><br><strong>Warranty</strong><span>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p></div>`,
    prices: [{ unit: "unit", amount: 5200.0 }],
  } as Product,
  {
    id: "cartier-18k-yellow-gold-panthere-de-cartier-883969-large-diamond-watch",
    name: "Cartier 18K Yellow Gold Panthere De Cartier 883969 Large Diamond Watch",
    category: "Cartier",
    photo:
      "assets/img/products/cartier-18k-yellow-gold-panthere-de-cartier-883969-large-diamond-watch.jfif",
    description: `<div class="productdesc"><p><strong>Brand</strong><span>:&nbsp; &nbsp; Cartier</span><br><strong>Model Name</strong><span>:&nbsp; Cartier 18K Yellow Gold Panthere De Cartier with Diamond Case</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model Number</strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">: &nbsp; &nbsp;<meta charset="utf-8"> <span>883969</span></span></p>
    <p><strong>Movement</strong><span>:&nbsp; &nbsp;Quartz</span><br><strong>Case</strong><span>:&nbsp; &nbsp;29 mm Case diameter.</span><br><strong>Crystal</strong><span>: &nbsp; &nbsp;Scratch resistant sapphire crystal</span><br><strong>Dial</strong><span>:&nbsp; White Roman</span></p>
    <p><b>Bezel: </b>18K Yellow Gold Bezel</p>
    <p><strong>Bracelet:</strong> 18K Yellow Gold Bracelet with Hidden Butterfly Clasp.<br><strong>Condition</strong><span>: &nbsp; &nbsp;Excellent condition.</span><br><strong>Working Condition</strong><span>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</span><br><strong>Authenticity</strong><span>: &nbsp; &nbsp;100% authentic.</span><br><strong>Warranty</strong><span>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p></div>`,
    description2: `<div class="productdesc"><p><strong>Brand</strong><span>:&nbsp; &nbsp; Cartier</span><br><strong>Model Name</strong><span>:&nbsp; Cartier 18K Yellow Gold Panthere De Cartier with Diamond Case</span></p>
    <p><strong style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">Model Number</strong><span style="font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;">: &nbsp; &nbsp;<meta charset="utf-8"> <span>883969</span></span></p>
    <p><strong>Movement</strong><span>:&nbsp; &nbsp;Quartz</span><br><strong>Case</strong><span>:&nbsp; &nbsp;29 mm Case diameter.</span><br><strong>Crystal</strong><span>: &nbsp; &nbsp;Scratch resistant sapphire crystal</span><br><strong>Dial</strong><span>:&nbsp; White Roman</span></p>
    <p><b>Bezel: </b>18K Yellow Gold Bezel</p>
    <p><strong>Bracelet:</strong> 18K Yellow Gold Bracelet with Hidden Butterfly Clasp.<br><strong>Condition</strong><span>: &nbsp; &nbsp;Excellent condition.</span><br><strong>Working Condition</strong><span>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.</span><br><strong>Authenticity</strong><span>: &nbsp; &nbsp;100% authentic.</span><br><strong>Warranty</strong><span>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty.</span></p></div>`,
    prices: [{ unit: "unit", amount: 25000.0 }],
  } as Product,
  // Cartier End Brand Collection

  // Patek Philippe Start Brand Collection
  {
    id: "patek-philippe-chronograph-reference-5070a-platinum",
    name: "Patek Philippe Chronograph Reference 5070P Platinum",
    category: "Patek Philippe",
    photo:
      "assets/img/products/patek-philippe-chronograph-reference-5070a-platinum.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Chronograph">Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5070A</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=Platinum 42mm">Platinum 42mm</a>


          
          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Classic two-register chronograph dial</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Manual-winding – Caliber CH 27-70</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Black leather strap</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">10 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Patek Philippe Watch for Men">Patek Philippe Watch for Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Pre-owned</span>
    </div>
  

</div>`,
    description2: `<div class="productdesc"><p data-end="680" data-start="298">The&nbsp;<strong data-end="336" data-start="302">Patek Philippe Reference 5070P</strong> is one of the most revered modern chronographs ever produced by <strong data-end="442" data-start="401"><span class="hover:entity-accent entity-underline inline cursor-pointer align-baseline"><span class="whitespace-normal">Patek Philippe</span></span></strong>, representing the brand’s triumphant return to large, classical chronograph wristwatches in the late 20th century. This exceptional example, presented in <strong data-end="609" data-start="597">platinum</strong>, stands among the rarest and most coveted executions of the reference.</p>
    <p data-end="955" data-start="682">The 5070 is celebrated for its balanced proportions, timeless two-register chronograph layout, and traditional construction. Its generous case size delivers strong wrist presence while maintaining elegant restraint—hallmarks of Patek Philippe’s classical design philosophy.</p>
    <p data-end="1344" data-start="957">Powering the watch is the legendary <strong data-end="1028" data-start="993">manual-winding Caliber CH 27-70</strong>, derived from the iconic Lemania 2310 and finished to Patek Philippe’s uncompromising standards. Long regarded as one of the finest manually wound chronograph movements ever made, it is admired for its architecture, tactile operation, and exceptional finishing, all visible through the sapphire exhibition caseback.</p>
    <p data-end="1604" data-start="1346">Rarely encountered in platinum, this <strong data-end="1402" data-start="1383">Reference 5070P</strong> represents an extraordinary opportunity for collectors seeking historical importance, mechanical purity, and true investment-grade rarity. A cornerstone piece for any serious Patek Philippe collection.</p>
    <h3 data-end="2216" data-start="2192"><strong data-end="2216" data-start="2196">Collector’s Note</strong></h3>
    <ul data-end="2464" data-start="2218">
    <li data-end="2282" data-start="2218">
    <p data-end="2282" data-start="2220">One of the most important modern Patek Philippe chronographs</p>
    </li>
    <li data-end="2334" data-start="2283">
    <p data-end="2334" data-start="2285">Powered by the legendary Lemania-based CH 27-70</p>
    </li>
    <li data-end="2403" data-start="2335">
    <p data-end="2403" data-start="2337">Platinum examples are exceptionally rare and highly sought after</p>
    </li>
    <li data-end="2464" data-start="2404">
    <p data-end="2464" data-start="2406">Strong historical, collector, and long-term value appeal</p>
    </li>
    </ul></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Chronograph">Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5070A</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=Platinum 42mm">Platinum 42mm</a>


          
          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Classic two-register chronograph dial</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Manual-winding – Caliber CH 27-70</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Black leather strap</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">10 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Patek Philippe Watch for Men">Patek Philippe Watch for Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Pre-owned</span>
    </div>
  

</div>`,
    prices: [{ unit: "unit", amount: 175000.0 }],
  } as Product,
  {
    id: "patek-philippe-nautilus-chronograph-5980-1a-019-white-dial-40-5mm-stainless-steel",
    name: "Patek Philippe Nautilus Chronograph 5980/1A-019 White Dial 40.5mm Stainless Steel",
    category: "Patek Philippe",
    photo:
      "assets/img/products/patek-philippe-nautilus-chronograph-5980-1a-019-white-dial-40-5mm-stainless-steel.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Nautilus">Nautilus</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5980/1A-019</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=40.5mm">40.5mm</a>


          
          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">White Embossed Dial with Black Markers</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire Crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Patek Philippe Caliber CH 28-520 C Automatic Flyback Chronograph</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Integrated Stainless Steel Bracelet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">12 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Mens">Mens</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Excellent pre-owned</span>
    </div>
  

</div>`,
    description2: `<div class="productdesc"><p data-start="274" data-end="516">The <strong data-start="278" data-end="319"><span class="hover:entity-accent entity-underline inline cursor-pointer align-baseline"><span class="whitespace-normal">Patek Philippe Nautilus Chronograph 5980/1A-019</span></span></strong> is one of the most collectible modern Nautilus references ever produced—combining the iconic Gérald Genta-designed case with Patek Philippe’s highly regarded in-house flyback chronograph movement.</p>
    <p data-start="518" data-end="944">Crafted in <strong data-start="529" data-end="548">stainless steel</strong>, the 40.5mm case retains the unmistakable Nautilus silhouette with its rounded octagonal bezel, integrated bracelet, and alternating brushed and polished finishing throughout. This particular reference stands out with its striking <strong data-start="780" data-end="803">white embossed dial</strong>, contrasted by blackened hands and hour markers for a sportier, more contemporary appearance than the traditional blue-dial Nautilus models.</p>
    <p data-start="946" data-end="1267">Powered by the automatic <strong data-start="971" data-end="986">CH 28-520 C</strong> caliber, the watch features a flyback chronograph with a unique monocounter display positioned at 6 o’clock, combining elapsed hours and minutes into a single highly legible subdial. The integrated stainless steel bracelet completes the unmistakable Nautilus profile on the wrist.</p>
    <p data-start="1269" data-end="1495">Introduced in 2012 and later discontinued, the 5980/1A-019 has become increasingly sought after among collectors due to its rarity, cleaner modern aesthetic, and limited production period.&nbsp;<span class="" data-state="closed"></span></p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Nautilus">Nautilus</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5980/1A-019</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=40.5mm">40.5mm</a>


          
          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">White Embossed Dial with Black Markers</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire Crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Patek Philippe Caliber CH 28-520 C Automatic Flyback Chronograph</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Integrated Stainless Steel Bracelet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">12 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Mens">Mens</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Excellent pre-owned</span>
    </div>
  

</div>`,
    prices: [{ unit: "unit", amount: 130000.0 }],
  } as Product,
  {
    id: "patek-philippe-aquanaut-chronograph-5968r-rose-gold-brown-dial",
    name: "Patek Philippe Aquanaut Chronograph 5968R Rose Gold Brown Dial",
    category: "Patek Philippe",
    photo:
      "assets/img/products/patek-philippe-aquanaut-chronograph-5968r-rose-gold-brown-dial.jfif",
    description: `<ul data-start="991" data-end="1369">
    <li data-section-id="149gs8d" data-start="991" data-end="1011">
    <strong data-start="993" data-end="1003">Model:</strong> 5968R</li>
    <li data-section-id="vn0ogp" data-start="1012" data-end="1037">
    <strong data-start="1014" data-end="1028">Case Size:</strong> 42.2mm</li>
    <li data-section-id="fi6568" data-start="1038" data-end="1069">
    <strong data-start="1040" data-end="1053">Material:</strong> 18k Rose Gold</li>
    <li data-section-id="onxss9" data-start="1070" data-end="1119">
    <strong data-start="1072" data-end="1081">Dial:</strong> Sunburst brown with Arabic numerals</li>
    <li data-section-id="1j4b5v4" data-start="1120" data-end="1165">
    <strong data-start="1122" data-end="1132">Strap:</strong> Brown composite (rubber) strap</li>
    <li data-section-id="1mqgt32" data-start="1166" data-end="1250">
    <strong data-start="1168" data-end="1181">Movement:</strong> Patek Philippe Caliber CH 28-520 C (Automatic Flyback Chronograph)</li>
    <li data-section-id="l0jgf4" data-start="1251" data-end="1287">
    <strong data-start="1253" data-end="1267">Functions:</strong> Chronograph, date</li>
    <li data-section-id="9xjaye" data-start="1288" data-end="1321">
    <strong data-start="1290" data-end="1302">Crystal:</strong> Sapphire crystal</li>
    <li data-section-id="z1zjt2" data-start="1322" data-end="1369">
    <strong data-start="1324" data-end="1345">Water Resistance:</strong> 120 meters / 400 feet</li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="171" data-end="459">Warm, bold, and unmistakably luxurious — the Patek Philippe Aquanaut Chronograph 5968R is a standout in modern haute horology. Crafted entirely in <strong data-start="318" data-end="335">18k rose gold</strong>, this 42.2mm timepiece blends the sporty DNA of the Aquanaut with the prestige and elegance of precious metal construction.</p>
    <p data-start="461" data-end="732">The rich <strong data-start="470" data-end="493">sunburst brown dial</strong>, paired with a matching composite strap, creates a cohesive and sophisticated look. Accented by applied Arabic numerals, luminous hands, and a chronograph subdial, the watch delivers both striking visual presence and excellent legibility.</p>
    <p data-start="734" data-end="962">At its core is the in-house <strong data-start="762" data-end="839">Patek Philippe Caliber CH 28-520 C automatic flyback chronograph movement</strong>, offering precision timing, reliability, and seamless chronograph functionality—hallmarks of Patek Philippe craftsmanship.</p>
    <hr data-start="964" data-end="967">
    <h3 data-section-id="1s1yvt8" data-start="969" data-end="990"><span role="text"><strong data-start="973" data-end="990">Key Features:</strong></span></h3>
    <ul data-start="991" data-end="1369">
    <li data-section-id="149gs8d" data-start="991" data-end="1011">
    <strong data-start="993" data-end="1003">Model:</strong> 5968R</li>
    <li data-section-id="vn0ogp" data-start="1012" data-end="1037">
    <strong data-start="1014" data-end="1028">Case Size:</strong> 42.2mm</li>
    <li data-section-id="fi6568" data-start="1038" data-end="1069">
    <strong data-start="1040" data-end="1053">Material:</strong> 18k Rose Gold</li>
    <li data-section-id="onxss9" data-start="1070" data-end="1119">
    <strong data-start="1072" data-end="1081">Dial:</strong> Sunburst brown with Arabic numerals</li>
    <li data-section-id="1j4b5v4" data-start="1120" data-end="1165">
    <strong data-start="1122" data-end="1132">Strap:</strong> Brown composite (rubber) strap</li>
    <li data-section-id="1mqgt32" data-start="1166" data-end="1250">
    <strong data-start="1168" data-end="1181">Movement:</strong> Patek Philippe Caliber CH 28-520 C (Automatic Flyback Chronograph)</li>
    <li data-section-id="l0jgf4" data-start="1251" data-end="1287">
    <strong data-start="1253" data-end="1267">Functions:</strong> Chronograph, date</li>
    <li data-section-id="9xjaye" data-start="1288" data-end="1321">
    <strong data-start="1290" data-end="1302">Crystal:</strong> Sapphire crystal</li>
    <li data-section-id="z1zjt2" data-start="1322" data-end="1369">
    <strong data-start="1324" data-end="1345">Water Resistance:</strong> 120 meters / 400 feet</li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 160000.0 }],
  } as Product,
  {
    id: "patek-philippe-complications-world-time-flyback-chronograph-5930p-001-platinum-green-dial",
    name: "Patek Philippe Complications World Time Flyback Chronograph 5930P-001 Platinum Green Dial",
    category: "Patek Philippe",
    photo:
      "assets/img/products/patek-philippe-complications-world-time-flyback-chronograph-5930p-001-platinum-green-dial.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Complications">Complications</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5930P-001</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=39.5mm">39.5mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Platinum</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Green guilloché dial with world time display</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant Sapphire Crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Automatic – Caliber CH 28-520 HU</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Green alligator leather strap</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">3 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><p data-start="264" data-end="545">The <strong data-start="268" data-end="310">Patek Philippe Complications 5930P-001</strong> is one of the most technically impressive and visually striking watches ever produced by <strong data-start="400" data-end="441"><span class="hover:entity-accent entity-underline inline cursor-pointer align-baseline"><span class="whitespace-normal">Patek Philippe</span></span></strong>, combining a <strong data-start="455" data-end="482">World Time complication</strong> with a <strong data-start="490" data-end="513">Flyback Chronograph</strong> in a refined <strong data-start="527" data-end="544">platinum case</strong>.</p>
    <p data-start="547" data-end="917">This exceptional reference is distinguished by its rare and captivating <strong data-start="619" data-end="643">green guilloché dial</strong>, featuring a hand-engraved center that reflects light with remarkable depth and texture. Surrounding the dial is the world time ring displaying 24 time zones, allowing instant global time readability—an elegant solution designed for seasoned travelers and collectors alike.</p>
    <p data-start="919" data-end="1303">At the heart of the 5930P-001 is the in-house <strong data-start="965" data-end="989">Caliber CH 28-520 HU</strong>, an automatic movement that integrates a column-wheel flyback chronograph with Patek Philippe’s world time mechanism. Both complications are operated intuitively, including adjustment via the signature pusher at 10 o’clock. The movement’s exceptional finishing is visible through the sapphire exhibition caseback.</p>
    <p data-start="1305" data-end="1608">Completed with a <strong data-start="1322" data-end="1369">hand-stitched green alligator leather strap</strong> and a platinum fold-over clasp, the watch exudes understated authority and refinement. As with all platinum Patek Philippe timepieces, a discreet <strong data-start="1516" data-end="1561">diamond is set into the case at 6 o’clock</strong>, a hallmark reserved for those who truly know.</p>
    <p data-start="1610" data-end="1779">The <strong data-start="1614" data-end="1638">5930P-001 Green Dial</strong> is a rare, highly collectible complication—perfect for connoisseurs seeking technical mastery, exclusivity, and long-term investment appeal.<strong data-start="1790" data-end="1807"></strong></p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Complications">Complications</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5930P-001</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=39.5mm">39.5mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Platinum</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Green guilloché dial with world time display</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant Sapphire Crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Automatic – Caliber CH 28-520 HU</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Green alligator leather strap</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">3 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 105000.0 }],
  } as Product,
  {
    id: "patek-philippe-5396g-017-annual-calendar-moonphase-white-gold-blue-dial",
    name: "Patek Philippe 5396G-017 – Annual Calendar Moonphase – White Gold – Blue Dial",
    category: "Patek Philippe",
    photo:
      "assets/img/products/patek-philippe-5396g-017-annual-calendar-moonphase-white-gold-blue-dial.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe 
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Annual Calendar Moonphase">Annual Calendar Moonphase</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5396G-017</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=38.5mm">38.5mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed, polished white gold</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Sunburst blue dial with Breguet numerals and calendar apertures</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Caliber 324 S QA LU 24H/303 – Automatic</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Blue alligator leather with 18k white gold deployant clasp</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">30 meters</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><ul>
    <li data-start="421" data-end="486">Own the elegance of a Patek Philippe Annual Calendar Moonphase.</li>
    <li data-start="489" data-end="549">Limited availability—secure this white gold classic today.</li>
    <li data-start="552" data-end="618">Shop now and elevate your collection with timeless Swiss luxury.</li>
    </ul></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/patek-philippe">
  Patek Philippe 
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/patek-philippe?rb_snize_facet1=Annual Calendar Moonphase">Annual Calendar Moonphase</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">5396G-017</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/patek-philippe?rb_snize_facet2=38.5mm">38.5mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed, polished white gold</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Sunburst blue dial with Breguet numerals and calendar apertures</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Caliber 324 S QA LU 24H/303 – Automatic</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Blue alligator leather with 18k white gold deployant clasp</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">30 meters</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/patek-philippe?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 62100.0 }],
  } as Product,
  // Patek Philippe End Brand Collection

  // Richard Mille Start Brand Collection
  {
    id: "richard-mille-rm-011-rose-gold-felipe-massa-watch",
    name: "Richard Mille RM 011 Rose Gold, Felipe Massa Watch (2017 to 2020)",
    category: "Richard Mille",
    photo:
      "assets/img/products/richard-mille-rm-011-rose-gold-felipe-massa-watch.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/richard-mille">
  Richard Mille  
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/richard-mille?rb_snize_facet1=Flyback Chronograph">Flyback Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">RM 011</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/richard-mille?rb_snize_facet2=50mm">50mm</a>


          
          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Skeletonized with luminous hands and Arabic numeral markers</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire crystal with anti-reflective coating</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">RMAC1 automatic movement</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Rubber or leather strap with titanium or rose gold buckle</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">50 meters / 165 feet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/richard-mille?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><ul>
    <li data-start="405" data-end="467">Own the legendary Richard Mille Felipe Massa racing edition.</li>
    <li data-start="470" data-end="523">Limited availability—secure this rare RM 011 today.</li>
    <li data-start="526" data-end="590">Shop now and elevate your collection with cutting-edge luxury.</li>
    </ul></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/richard-mille">
  Richard Mille  
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/richard-mille?rb_snize_facet1=Flyback Chronograph">Flyback Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">RM 011</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/richard-mille?rb_snize_facet2=50mm">50mm</a>


          
          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Skeletonized with luminous hands and Arabic numeral markers</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire crystal with anti-reflective coating</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">RMAC1 automatic movement</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Rubber or leather strap with titanium or rose gold buckle</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">50 meters / 165 feet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/richard-mille?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 215270.0 }],
  } as Product,
  // Richard Mille End Brand Collection

  // Breitling Start Brand Collection
  {
    id: "breitling-super-avenger-ii-a13371-blue-dial-dial-watch",
    name: "Breitling Aeromarine Super Avenger A13371 Blue Dial Steel Mens Watch",
    category: "Breitling",
    photo:
      "assets/img/products/breitling-super-avenger-ii-a13371-blue-dial-dial-watch.jfif",
    description: `<div class="productdesc"><p style="text-align: left;" data-mce-fragment="1"><br><strong>Stock Number</strong>: &nbsp; &nbsp;MW01064-7<br><strong>Brand</strong>: &nbsp; &nbsp;Breitling<br><strong>Model Name</strong>: &nbsp; &nbsp;Breitling Aeromarine Super Avenger Blue Dial Steel Mens Watch A13371&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;A13371<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic movement. Chronograph function.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel case 48 mm in diameter with screwed-locked crown and pushers. Case thickness 17.75 mm.<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless steel unidirectional rotating bezel. 0-60 elapsed-time. Four 15 minute markers.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Blue dial with luminous baton hour markers and hands. Date aperture at 3 o’clock. Three chronograph subdials -- 60 seconds, 30 minutes and 12 hours.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet with flip-lock clasp. Fits 8.5" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition.<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Breitling box<br><strong>Working Condition</strong>: &nbsp; &nbsp;Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty<br></p></div>`,
    description2: `<div class="productdesc"><p style="text-align: left;" data-mce-fragment="1"><br><strong>Stock Number</strong>: &nbsp; &nbsp;MW01064-7<br><strong>Brand</strong>: &nbsp; &nbsp;Breitling<br><strong>Model Name</strong>: &nbsp; &nbsp;Breitling Aeromarine Super Avenger Blue Dial Steel Mens Watch A13371&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;A13371<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic movement. Chronograph function.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel case 48 mm in diameter with screwed-locked crown and pushers. Case thickness 17.75 mm.<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless steel unidirectional rotating bezel. 0-60 elapsed-time. Four 15 minute markers.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Blue dial with luminous baton hour markers and hands. Date aperture at 3 o’clock. Three chronograph subdials -- 60 seconds, 30 minutes and 12 hours.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet with flip-lock clasp. Fits 8.5" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition.<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Breitling box<br><strong>Working Condition</strong>: &nbsp; &nbsp;Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty<br></p></div>`,
    prices: [{ unit: "unit", amount: 3950.0 }],
  } as Product,
  {
    id: "breitling-chronomat-44-ab0110-44mm-white-dial-automatic-chronograph",
    name: "Breitling Chronomat 44 AB0110 – 44mm White Dial Automatic Chronograph",
    category: "Breitling",
    photo:
      "assets/img/products/breitling-chronomat-44-ab0110-44mm-white-dial-automatic-chronograph.jfif",
    description: `<ul data-start="1274" data-end="2074">
    <li data-start="1274" data-end="1314">
    <p data-start="1276" data-end="1314">Reference: <strong data-start="1287" data-end="1297">AB0110</strong> (Chronomat 44)</p>
    </li>
    <li data-start="1315" data-end="1414">
    <p data-start="1317" data-end="1414">Case: 44 mm stainless steel; approximately 16.95 mm thick.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1415" data-end="1516">
    <p data-start="1417" data-end="1516">Dial: <strong data-start="1423" data-end="1437">White dial</strong> with Roman numerals and luminous hands.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1517" data-end="1627">
    <p data-start="1519" data-end="1627">Movement: Automatic in-house Calibre B01 with ~70-hour power reserve.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1628" data-end="1753">
    <p data-start="1630" data-end="1753">Bezel: Unidirectional rotating bezel with “rider tabs” — signature Chronomat design.</p>
    </li>
    <li data-start="1754" data-end="1855">
    <p data-start="1756" data-end="1855">Water Resistance: Up to <strong data-start="1780" data-end="1798">500 m / 50 ATM</strong> in steel version.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1856" data-end="1933">
    <p data-start="1858" data-end="1933">Crystal: Scratch-resistant sapphire.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1934" data-end="2074">
    <p data-start="1936" data-end="2074">Bracelet/Strap: Stainless steel bracelet (or optional strap variant) matching large case profile</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p><meta charset="utf-8">Elevate your wrist game with the Breitling Chronomat 44 AB0110 — a statement of precision, performance and timeless style. Housed in a robust 44 mm stainless steel case, this automatic chronograph features Breitling’s in-house Calibre B01 movement with a 70-hour power reserve.<br data-start="647" data-end="650">The crisp <strong data-start="660" data-end="674">white dial</strong> with Roman numeral markers offers a clean, high-contrast aesthetic that blends sporty sophistication with classical refinement.<br data-start="839" data-end="842">With a unidirectional rider-tab bezel, chronograph sub-dials, a date display and 500 m water resistance, this watch is built to perform — whether in the boardroom or on weekend adventures,<br data-start="1067" data-end="1070">This particular AB0110 model is ideal for the discerning collector seeking a large-format luxury chronograph that stands out while remaining rooted in Swiss watchmaking heritage.</p>
    <h3 data-start="1255" data-end="1273">Key Features</h3>
    <ul data-start="1274" data-end="2074">
    <li data-start="1274" data-end="1314">
    <p data-start="1276" data-end="1314">Reference: <strong data-start="1287" data-end="1297">AB0110</strong> (Chronomat 44)</p>
    </li>
    <li data-start="1315" data-end="1414">
    <p data-start="1317" data-end="1414">Case: 44 mm stainless steel; approximately 16.95 mm thick.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1415" data-end="1516">
    <p data-start="1417" data-end="1516">Dial: <strong data-start="1423" data-end="1437">White dial</strong> with Roman numerals and luminous hands.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1517" data-end="1627">
    <p data-start="1519" data-end="1627">Movement: Automatic in-house Calibre B01 with ~70-hour power reserve.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1628" data-end="1753">
    <p data-start="1630" data-end="1753">Bezel: Unidirectional rotating bezel with “rider tabs” — signature Chronomat design.</p>
    </li>
    <li data-start="1754" data-end="1855">
    <p data-start="1756" data-end="1855">Water Resistance: Up to <strong data-start="1780" data-end="1798">500 m / 50 ATM</strong> in steel version.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1856" data-end="1933">
    <p data-start="1858" data-end="1933">Crystal: Scratch-resistant sapphire.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1934" data-end="2074">
    <p data-start="1936" data-end="2074">Bracelet/Strap: Stainless steel bracelet (or optional strap variant) matching large case profile</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 5200.0 }],
  } as Product,
  {
    id: "breitling-superocean-heritage-ii-chronograph-a13313-44mm-steel-diver-chronograph",
    name: "Breitling Superocean Heritage II Chronograph A13313 – 44mm Steel Diver Chronograph",
    category: "Breitling",
    photo:
      "assets/img/products/breitling-superocean-heritage-ii-chronograph-a13313-44mm-steel-diver-chronograph.jfif",
    description: `<ul data-start="1147" data-end="2128">
    <li data-start="1147" data-end="1246">
    <p data-start="1149" data-end="1246">Reference: <strong data-start="1160" data-end="1170">A13313</strong> (Superocean Heritage II Chronograph)<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1247" data-end="1342">
    <p data-start="1249" data-end="1342">Case Size: 44 mm diameter; thickness approx. 15.65 mm.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1343" data-end="1415">
    <p data-start="1345" data-end="1415">Case Material: Stainless steel.</p>
    </li>
    <li data-start="1416" data-end="1541">
    <p data-start="1418" data-end="1541">Movement: Automatic self-winding Calibre 13, offering approx. 48-hour power reserve.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1542" data-end="1658">
    <p data-start="1544" data-end="1658">Functions: Chronograph (30-minute &amp; 12-hour registers), day &amp; date display.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1659" data-end="1766">
    <p data-start="1661" data-end="1766">Water Resistance: 200 m / 20 ATM — suitable for serious water use.</p>
    </li>
    <li data-start="1767" data-end="1891">
    <p data-start="1769" data-end="1891">Dial &amp; Bezel: Blue Dial, Dark Grey Bezel<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1892" data-end="1969">
    <p data-start="1894" data-end="1969">Crystal: Scratch-resistant sapphire.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1970" data-end="2128">
    <p data-start="1972" data-end="2128">Strap/Bracelet: Stainless steel bracelet or rubber/mesh strap variants — versatile for both sport and refined wear.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="333" data-end="821">Dive into performance and style with the Breitling Superocean Heritage II Chronograph A13313. With a robust 44 mm stainless steel case, this model blends professional diver functions with Breitling’s refined styling heritage. Powered by the automatic Calibre 13 movement (based on the Valjoux 7750), the A13313 offers chronograph capability, day &amp; date display, and a strong 200 m (20 ATM) water resistance — making it both versatile and dependable.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    <p data-start="823" data-end="1121">Whether you’re exploring the ocean or navigating the city, the Superocean Heritage II offers timeless aesthetic cues — vintage triangular hands, a polished bezel, and modern materials — centered on a design that stands out on the wrist. Ideal for the discerning collector seeking sporty elegance.</p>
    <h3 data-start="1128" data-end="1146">Key Features</h3>
    <ul data-start="1147" data-end="2128">
    <li data-start="1147" data-end="1246">
    <p data-start="1149" data-end="1246">Reference: <strong data-start="1160" data-end="1170">A13313</strong> (Superocean Heritage II Chronograph)<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1247" data-end="1342">
    <p data-start="1249" data-end="1342">Case Size: 44 mm diameter; thickness approx. 15.65 mm.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1343" data-end="1415">
    <p data-start="1345" data-end="1415">Case Material: Stainless steel.</p>
    </li>
    <li data-start="1416" data-end="1541">
    <p data-start="1418" data-end="1541">Movement: Automatic self-winding Calibre 13, offering approx. 48-hour power reserve.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1542" data-end="1658">
    <p data-start="1544" data-end="1658">Functions: Chronograph (30-minute &amp; 12-hour registers), day &amp; date display.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1659" data-end="1766">
    <p data-start="1661" data-end="1766">Water Resistance: 200 m / 20 ATM — suitable for serious water use.</p>
    </li>
    <li data-start="1767" data-end="1891">
    <p data-start="1769" data-end="1891">Dial &amp; Bezel: Blue Dial, Dark Grey Bezel<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1892" data-end="1969">
    <p data-start="1894" data-end="1969">Crystal: Scratch-resistant sapphire.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1970" data-end="2128">
    <p data-start="1972" data-end="2128">Strap/Bracelet: Stainless steel bracelet or rubber/mesh strap variants — versatile for both sport and refined wear.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 4700.0 }],
  } as Product,
  {
    id: "breitling-for-bentley-a25362-bronze-havana-dial-with-date-chronograph-luxury-watch",
    name: "Breitling for Bentley A25362 – Bronze “Havana” Dial with Date | Chronograph Luxury Watch",
    category: "Breitling",
    photo:
      "assets/img/products/breitling-for-bentley-a25362-bronze-havana-dial-with-date-chronograph-luxury-watch.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/breitling">
  Breitling
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/breitling?rb_snize_facet1=Breitling for Bentley Motors Chronograph">Breitling for Bentley Motors Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">A25362</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/breitling?rb_snize_facet2=48.7mm">48.7mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed Knurled Bezel (Bentley-Inspired)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Bronze “Havana” Sunburst Dial with Luminous Hands</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Breitling Caliber 25B (Automatic, Chronometer)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Stainless Steel Bracelet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">100 meters / 330 feet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/breitling?rb_snize_facet5=Men's">Men's</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><p><meta charset="utf-8">Blending Swiss precision with British elegance, the <strong data-start="435" data-end="467">Breitling for Bentley A25362</strong> is a bold, motorsport-inspired chronograph that exudes luxury and performance.</p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/breitling">
  Breitling
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/breitling?rb_snize_facet1=Breitling for Bentley Motors Chronograph">Breitling for Bentley Motors Chronograph</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">A25362</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/breitling?rb_snize_facet2=48.7mm">48.7mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed Knurled Bezel (Bentley-Inspired)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Bronze “Havana” Sunburst Dial with Luminous Hands</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Breitling Caliber 25B (Automatic, Chronometer)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Stainless Steel Bracelet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">100 meters / 330 feet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/breitling?rb_snize_facet5=Men's">Men's</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 6000.0 }],
  } as Product,
  {
    id: "breitling-windrider-cockpit-a71356-ladies-black-diamond-ladies-watch",
    name: "Breitling Windrider Cockpit A71356 Ladies Black Diamond Ladies Watch",
    category: "Breitling",
    photo:
      "assets/img/products/breitling-windrider-cockpit-a71356-ladies-black-diamond-ladies-watch.jfif",
    description: `<div class="productdesc"><p style="text-align: left;"><br><strong>Stock Number</strong>: &nbsp; &nbsp;LW01055-2<br><strong>Brand</strong>: &nbsp; &nbsp;Breitling<br><strong>Model Name</strong>: &nbsp; &nbsp;Breitling Windrider Cockpit Ladies Black Diamond Ladies Watch A71356<br><strong>Model Number</strong>: &nbsp; &nbsp;A71356<br><strong>Gender</strong>: &nbsp; &nbsp;Ladies<br><strong>Movement</strong>: &nbsp; &nbsp;Quartz movement<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel case 31.8 mm in diameter.<br><strong>Bezel</strong>: &nbsp; &nbsp;Unidirectional rotating bezel. Four 15 minute markers.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Black dial with original Breitling diamond hour markers and roman numerals. Date window at 3 o'clock.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet. Breitling logo on a buckle. Fits 6 3/4" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Presentation non-Breitling box<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    description2: `<div class="productdesc"><p style="text-align: left;"><br><strong>Stock Number</strong>: &nbsp; &nbsp;LW01055-2<br><strong>Brand</strong>: &nbsp; &nbsp;Breitling<br><strong>Model Name</strong>: &nbsp; &nbsp;Breitling Windrider Cockpit Ladies Black Diamond Ladies Watch A71356<br><strong>Model Number</strong>: &nbsp; &nbsp;A71356<br><strong>Gender</strong>: &nbsp; &nbsp;Ladies<br><strong>Movement</strong>: &nbsp; &nbsp;Quartz movement<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel case 31.8 mm in diameter.<br><strong>Bezel</strong>: &nbsp; &nbsp;Unidirectional rotating bezel. Four 15 minute markers.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Black dial with original Breitling diamond hour markers and roman numerals. Date window at 3 o'clock.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet. Breitling logo on a buckle. Fits 6 3/4" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Presentation non-Breitling box<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    prices: [{ unit: "unit", amount: 3700.0 }],
  } as Product,
  // Breitling End Brand Collection

  // Hublot Start Brand Collection
  {
    id: "hublot-king-power-701ne0127-48mm-transparent-dial-with-rubber-bracelet",
    name: "Hublot King Power 701.NE.0127 48MM Transparent Dial With Rubber Bracelet",
    category: "Hublot",
    photo:
      "assets/img/products/hublot-king-power-701ne0127-48mm-transparent-dial-with-rubber-bracelet.jfif",
    description: `<div class="productdesc"><ul>
    <li data-start="83" data-end="111">
    <p data-start="85" data-end="111"><strong data-start="85" data-end="99">Condition:</strong> Pre-Owned</p>
    </li>
    <li data-start="112" data-end="144">
    <p data-start="114" data-end="144"><strong data-start="114" data-end="124">Model:</strong> Hublot King Power</p>
    </li>
    <li data-start="145" data-end="182">
    <p data-start="147" data-end="182"><strong data-start="147" data-end="168">Reference Number:</strong> 701.NE.0127</p>
    </li>
    <li data-start="183" data-end="210">
    <p data-start="185" data-end="210"><strong data-start="185" data-end="198">Movement:</strong> Automatic</p>
    </li>
    <li data-start="211" data-end="234">
    <p data-start="213" data-end="234"><strong data-start="213" data-end="223">Bezel:</strong> Titanium</p>
    </li>
    <li data-start="235" data-end="265">
    <p data-start="237" data-end="265"><strong data-start="237" data-end="246">Dial:</strong> Transparent dial</p>
    </li>
    <li data-start="266" data-end="289">
    <p data-start="268" data-end="289"><strong data-start="268" data-end="282">Case Size:</strong> 48mm</p>
    </li>
    <li data-start="290" data-end="341">
    <p data-start="292" data-end="341"><strong data-start="292" data-end="304">Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li data-start="342" data-end="372">
    <p data-start="344" data-end="372"><strong data-start="344" data-end="357">Bracelet:</strong> Rubber strap</p>
    </li>
    <li data-start="373" data-end="429">
    <p data-start="375" data-end="429"><strong data-start="375" data-end="396">Water Resistance:</strong> 10 ATM (100 meters / 330 feet)</p>
    </li>
    <li data-start="430" data-end="451">
    <p data-start="432" data-end="451"><strong data-start="432" data-end="443">Gender:</strong> Men's</p>
    </li>
    </ul></div>`,
    description2: `<div class="productdesc"><ul>
    <li data-start="83" data-end="111">
    <p data-start="85" data-end="111"><strong data-start="85" data-end="99">Condition:</strong> Pre-Owned</p>
    </li>
    <li data-start="112" data-end="144">
    <p data-start="114" data-end="144"><strong data-start="114" data-end="124">Model:</strong> Hublot King Power</p>
    </li>
    <li data-start="145" data-end="182">
    <p data-start="147" data-end="182"><strong data-start="147" data-end="168">Reference Number:</strong> 701.NE.0127</p>
    </li>
    <li data-start="183" data-end="210">
    <p data-start="185" data-end="210"><strong data-start="185" data-end="198">Movement:</strong> Automatic</p>
    </li>
    <li data-start="211" data-end="234">
    <p data-start="213" data-end="234"><strong data-start="213" data-end="223">Bezel:</strong> Titanium</p>
    </li>
    <li data-start="235" data-end="265">
    <p data-start="237" data-end="265"><strong data-start="237" data-end="246">Dial:</strong> Transparent dial</p>
    </li>
    <li data-start="266" data-end="289">
    <p data-start="268" data-end="289"><strong data-start="268" data-end="282">Case Size:</strong> 48mm</p>
    </li>
    <li data-start="290" data-end="341">
    <p data-start="292" data-end="341"><strong data-start="292" data-end="304">Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li data-start="342" data-end="372">
    <p data-start="344" data-end="372"><strong data-start="344" data-end="357">Bracelet:</strong> Rubber strap</p>
    </li>
    <li data-start="373" data-end="429">
    <p data-start="375" data-end="429"><strong data-start="375" data-end="396">Water Resistance:</strong> 10 ATM (100 meters / 330 feet)</p>
    </li>
    <li data-start="430" data-end="451">
    <p data-start="432" data-end="451"><strong data-start="432" data-end="443">Gender:</strong> Men's</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 13900.0 }],
  } as Product,
  {
    id: "hublot-classic-fusion-aerofusion-king-gold-45-mm-525-ox-0180-rx",
    name: "Hublot Classic Fusion Aerofusion King Gold 45 mm 525.OX.0180.RX",
    category: "Hublot",
    photo:
      "assets/img/products/hublot-classic-fusion-aerofusion-king-gold-45-mm-525-ox-0180-rx.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/hublot">
  Hublot
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/hublot?rb_snize_facet1=Aerofusion King Gold">Aerofusion King Gold</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">525.OX.0180.RX</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/hublot?rb_snize_facet2=45 mm">45 mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">18 k King Gold, secured by H-shaped screws</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Skeleton dial revealing movement</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">HUB1155 self-winding skeleton chronograph calibre</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Black-lined rubber strap</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">50 m / 5 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/hublot?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Pre-Owned - Excellent</span>
    </div>
  

</div>`,
    description2: `<div class="productdesc"><p><meta charset="utf-8">Discover the pre-owned <strong data-start="764" data-end="815">Hublot Classic Fusion Aerofusion King Gold 45mm</strong>, one of the most searched luxury watches for men. Crafted in stunning King Gold with an open-worked dial, this signature Hublot blends modern engineering with bold design. Our pre-owned Hublot watches undergo full authentication, performance testing, and polishing for a like-new feel. Shop this Aerofusion at JD Watches NY for trusted quality, transparent pricing, fast shipping, and unmatched service. Perfect for collectors seeking a statement Hublot with strong resale value. Limited availability—secure yours today.<strong data-start="1000" data-end="1016"></strong></p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/hublot">
  Hublot
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/hublot?rb_snize_facet1=Aerofusion King Gold">Aerofusion King Gold</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">525.OX.0180.RX</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/hublot?rb_snize_facet2=45 mm">45 mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">18 k King Gold, secured by H-shaped screws</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Skeleton dial revealing movement</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire crystal</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">HUB1155 self-winding skeleton chronograph calibre</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Black-lined rubber strap</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">50 m / 5 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/hublot?rb_snize_facet5=Men">Men</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Pre-Owned - Excellent</span>
    </div>
  

</div>`,
    prices: [{ unit: "unit", amount: 41300.0 }],
  } as Product,
  {
    id: "hublot-big-bang-aerobang-gold-44mm-limited-edition-310-pm-1180-rx",
    name: "Hublot Big Bang AeroBang Gold 44mm Limited Edition 310.PM.1180.RX",
    category: "Hublot",
    photo:
      "assets/img/products/hublot-big-bang-aerobang-gold-44mm-limited-edition-310-pm-1180-rx.jfif",
    description: `<div class="productdesc"><ul>
    <li data-start="114" data-end="135">
    <p data-start="116" data-end="135"><strong data-start="116" data-end="126">Brand:</strong> Hublot</p>
    </li>
    <li data-start="136" data-end="199">
    <p data-start="138" data-end="199"><strong data-start="138" data-end="153">Model Name:</strong> Big Bang AeroBang Gold 44mm Limited Edition</p>
    </li>
    <li data-start="200" data-end="236">
    <p data-start="202" data-end="236"><strong data-start="202" data-end="219">Model Number:</strong> 310.PM.1180.RX</p>
    </li>
    <li data-start="237" data-end="264">
    <p data-start="239" data-end="264"><strong data-start="239" data-end="252">Movement:</strong> Automatic</p>
    </li>
    <li data-start="265" data-end="335">
    <p data-start="267" data-end="335"><strong data-start="267" data-end="276">Case:</strong> 44mm (note: listed as 41mm in your input—please confirm)</p>
    </li>
    <li data-start="336" data-end="362">
    <p data-start="338" data-end="362"><strong data-start="338" data-end="348">Bezel:</strong> Black bezel</p>
    </li>
    <li data-start="363" data-end="396">
    <p data-start="365" data-end="396"><strong data-start="365" data-end="377">Crystal:</strong> Sapphire crystal</p>
    </li>
    <li data-start="397" data-end="421">
    <p data-start="399" data-end="421"><strong data-start="399" data-end="408">Dial:</strong> Black dial</p>
    </li>
    <li data-start="422" data-end="461">
    <p data-start="424" data-end="461"><strong data-start="424" data-end="437">Bracelet:</strong> Black rubber bracelet</p>
    </li>
    <li data-start="462" data-end="500">
    <p data-start="464" data-end="500"><strong data-start="464" data-end="478">Condition:</strong> Excellent condition</p>
    </li>
    <li data-start="501" data-end="542">
    <p data-start="503" data-end="542"><strong data-start="503" data-end="520">Box &amp; Papers:</strong> Includes Hublot box</p>
    </li>
    <li data-start="543" data-end="669">
    <p data-start="545" data-end="669"><strong data-start="545" data-end="567">Working Condition:</strong> Timed to precision on Witschi watch expert timing machine; running strong and keeping accurate time</p>
    </li>
    <li data-start="670" data-end="706">
    <p data-start="672" data-end="706"><strong data-start="672" data-end="689">Authenticity:</strong> 100% authentic</p>
    </li>
    <li data-start="707" data-end="764">
    <p data-start="709" data-end="764"><strong data-start="709" data-end="722">Warranty:</strong> Covered by JD Watches 24-month warranty</p>
    </li>
    </ul></div>`,
    description2: `<div class="productdesc"><ul>
    <li data-start="114" data-end="135">
    <p data-start="116" data-end="135"><strong data-start="116" data-end="126">Brand:</strong> Hublot</p>
    </li>
    <li data-start="136" data-end="199">
    <p data-start="138" data-end="199"><strong data-start="138" data-end="153">Model Name:</strong> Big Bang AeroBang Gold 44mm Limited Edition</p>
    </li>
    <li data-start="200" data-end="236">
    <p data-start="202" data-end="236"><strong data-start="202" data-end="219">Model Number:</strong> 310.PM.1180.RX</p>
    </li>
    <li data-start="237" data-end="264">
    <p data-start="239" data-end="264"><strong data-start="239" data-end="252">Movement:</strong> Automatic</p>
    </li>
    <li data-start="265" data-end="335">
    <p data-start="267" data-end="335"><strong data-start="267" data-end="276">Case:</strong> 44mm (note: listed as 41mm in your input—please confirm)</p>
    </li>
    <li data-start="336" data-end="362">
    <p data-start="338" data-end="362"><strong data-start="338" data-end="348">Bezel:</strong> Black bezel</p>
    </li>
    <li data-start="363" data-end="396">
    <p data-start="365" data-end="396"><strong data-start="365" data-end="377">Crystal:</strong> Sapphire crystal</p>
    </li>
    <li data-start="397" data-end="421">
    <p data-start="399" data-end="421"><strong data-start="399" data-end="408">Dial:</strong> Black dial</p>
    </li>
    <li data-start="422" data-end="461">
    <p data-start="424" data-end="461"><strong data-start="424" data-end="437">Bracelet:</strong> Black rubber bracelet</p>
    </li>
    <li data-start="462" data-end="500">
    <p data-start="464" data-end="500"><strong data-start="464" data-end="478">Condition:</strong> Excellent condition</p>
    </li>
    <li data-start="501" data-end="542">
    <p data-start="503" data-end="542"><strong data-start="503" data-end="520">Box &amp; Papers:</strong> Includes Hublot box</p>
    </li>
    <li data-start="543" data-end="669">
    <p data-start="545" data-end="669"><strong data-start="545" data-end="567">Working Condition:</strong> Timed to precision on Witschi watch expert timing machine; running strong and keeping accurate time</p>
    </li>
    <li data-start="670" data-end="706">
    <p data-start="672" data-end="706"><strong data-start="672" data-end="689">Authenticity:</strong> 100% authentic</p>
    </li>
    <li data-start="707" data-end="764">
    <p data-start="709" data-end="764"><strong data-start="709" data-end="722">Warranty:</strong> Covered by JD Watches 24-month warranty</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 20200.0 }],
  } as Product,
  {
    id: "18k-rose-gold-hublot-5980-40-5mm-black-gradient-dial",
    name: "Hublot Classic Fusion Aero King Watch 525.OX.0180.OX",
    category: "Hublot",
    photo:
      "assets/img/products/18k-rose-gold-hublot-5980-40-5mm-black-gradient-dial.jfif",
    description: `<p><span><strong>Condition&nbsp;</strong>– Pre-Owned&nbsp;<strong><br>Model</strong>&nbsp;– Hublot Classic Fusion&nbsp;Aero King<br><strong>Reference Number</strong>&nbsp;- 525.OX.0180.OX<br><strong>Movement</strong>&nbsp;–&nbsp;Self Winding HUB 1155 Movement&nbsp;with Aero Chronograph Function<br><strong>Bezel</strong>&nbsp;- Satin-Finished 18K King Gold Bezel</span><br><span><strong>Dial</strong>&nbsp;–&nbsp;Black Dial with Appliques and Gold-plated Counter Ring</span><br><span><strong>Case Size</strong>&nbsp;– 45mm&nbsp;</span><br><span><strong>Crystal</strong>&nbsp;- Scratch-resistant Sapphire Crystal&nbsp;<br><strong>Bracelet</strong>&nbsp;- 18K Rose Gold King Bracelet&nbsp;<br><strong>Water Resistant</strong>&nbsp;- 50m<br></span><span><strong>Gender</strong>&nbsp;–&nbsp;Men's</span></p>`,
    description2: `<p><span><strong>Condition&nbsp;</strong>– Pre-Owned&nbsp;<strong><br>Model</strong>&nbsp;– Hublot Classic Fusion&nbsp;Aero King<br><strong>Reference Number</strong>&nbsp;- 525.OX.0180.OX<br><strong>Movement</strong>&nbsp;–&nbsp;Self Winding HUB 1155 Movement&nbsp;with Aero Chronograph Function<br><strong>Bezel</strong>&nbsp;- Satin-Finished 18K King Gold Bezel</span><br><span><strong>Dial</strong>&nbsp;–&nbsp;Black Dial with Appliques and Gold-plated Counter Ring</span><br><span><strong>Case Size</strong>&nbsp;– 45mm&nbsp;</span><br><span><strong>Crystal</strong>&nbsp;- Scratch-resistant Sapphire Crystal&nbsp;<br><strong>Bracelet</strong>&nbsp;- 18K Rose Gold King Bracelet&nbsp;<br><strong>Water Resistant</strong>&nbsp;- 50m<br></span><span><strong>Gender</strong>&nbsp;–&nbsp;Men's</span></p>`,
    prices: [{ unit: "unit", amount: 43100.0 }],
  } as Product,
  {
    id: "hublot-big-bang-evolution-44mm-stainless-steel-and-ceramic",
    name: "Hublot Big Bang Evolution Steel and Ceramic 44MM 301.SB.131.RX",
    category: "Hublot",
    photo:
      "assets/img/products/hublot-big-bang-evolution-44mm-stainless-steel-and-ceramic.jfif",
    description: `<div class="productdesc"><ul>
    <li data-start="83" data-end="111">
    <p data-start="85" data-end="111"><strong data-start="85" data-end="99">Condition:</strong> Pre-Owned</p>
    </li>
    <li data-start="112" data-end="140">
    <p data-start="114" data-end="140"><strong data-start="114" data-end="124">Model:</strong> Big Bang 44mm</p>
    </li>
    <li data-start="141" data-end="180">
    <p data-start="143" data-end="180"><strong data-start="143" data-end="164">Reference Number:</strong> 301.SB.131.RX</p>
    </li>
    <li data-start="181" data-end="208">
    <p data-start="183" data-end="208"><strong data-start="183" data-end="196">Movement:</strong> Automatic</p>
    </li>
    <li data-start="209" data-end="239">
    <p data-start="211" data-end="239"><strong data-start="211" data-end="221">Bezel:</strong> Stainless steel</p>
    </li>
    <li data-start="240" data-end="264">
    <p data-start="242" data-end="264"><strong data-start="242" data-end="251">Dial:</strong> Black dial</p>
    </li>
    <li data-start="265" data-end="288">
    <p data-start="267" data-end="288"><strong data-start="267" data-end="281">Case Size:</strong> 44mm</p>
    </li>
    <li data-start="289" data-end="340">
    <p data-start="291" data-end="340"><strong data-start="291" data-end="303">Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li data-start="341" data-end="377">
    <p data-start="343" data-end="377"><strong data-start="343" data-end="356">Bracelet:</strong> Black rubber strap</p>
    </li>
    <li data-start="378" data-end="434">
    <p data-start="380" data-end="434"><strong data-start="380" data-end="401">Water Resistance:</strong> 10 ATM (100 meters / 330 feet)</p>
    </li>
    <li data-start="435" data-end="456">
    <p data-start="437" data-end="456"><strong data-start="437" data-end="448">Gender:</strong> Men's</p>
    </li>
    </ul></div>`,
    description2: `<div class="productdesc"><ul>
    <li data-start="83" data-end="111">
    <p data-start="85" data-end="111"><strong data-start="85" data-end="99">Condition:</strong> Pre-Owned</p>
    </li>
    <li data-start="112" data-end="140">
    <p data-start="114" data-end="140"><strong data-start="114" data-end="124">Model:</strong> Big Bang 44mm</p>
    </li>
    <li data-start="141" data-end="180">
    <p data-start="143" data-end="180"><strong data-start="143" data-end="164">Reference Number:</strong> 301.SB.131.RX</p>
    </li>
    <li data-start="181" data-end="208">
    <p data-start="183" data-end="208"><strong data-start="183" data-end="196">Movement:</strong> Automatic</p>
    </li>
    <li data-start="209" data-end="239">
    <p data-start="211" data-end="239"><strong data-start="211" data-end="221">Bezel:</strong> Stainless steel</p>
    </li>
    <li data-start="240" data-end="264">
    <p data-start="242" data-end="264"><strong data-start="242" data-end="251">Dial:</strong> Black dial</p>
    </li>
    <li data-start="265" data-end="288">
    <p data-start="267" data-end="288"><strong data-start="267" data-end="281">Case Size:</strong> 44mm</p>
    </li>
    <li data-start="289" data-end="340">
    <p data-start="291" data-end="340"><strong data-start="291" data-end="303">Crystal:</strong> Scratch-resistant sapphire crystal</p>
    </li>
    <li data-start="341" data-end="377">
    <p data-start="343" data-end="377"><strong data-start="343" data-end="356">Bracelet:</strong> Black rubber strap</p>
    </li>
    <li data-start="378" data-end="434">
    <p data-start="380" data-end="434"><strong data-start="380" data-end="401">Water Resistance:</strong> 10 ATM (100 meters / 330 feet)</p>
    </li>
    <li data-start="435" data-end="456">
    <p data-start="437" data-end="456"><strong data-start="437" data-end="448">Gender:</strong> Men's</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 12150.0 }],
  } as Product,
  // Hublot End Brand Collection

  // Franck Muller Start Brand Collection
  {
    id: "franck-muller-conquistador-cortez-10000-l-automatic-with-aftermarket-diamond-bezel",
    name: "Franck Muller Conquistador Cortez 10000 L Automatic with Aftermarket Diamond Bezel",
    category: "Franck Muller",
    photo:
      "assets/img/products/franck-muller-conquistador-cortez-10000-l-automatic-with-aftermarket-diamond-bezel.jfif",
    description: `<ul data-start="1297" data-end="2035">
    <li data-start="1297" data-end="1369">
    <p data-start="1299" data-end="1369"><strong data-start="1299" data-end="1313">Reference:</strong> 10000 L — part of the Conquistador Cortez collection.</p>
    </li>
    <li data-start="1370" data-end="1409">
    <p data-start="1372" data-end="1409"><strong data-start="1372" data-end="1390">Case Material:</strong> Stainless steel.</p>
    </li>
    <li data-start="1410" data-end="1465">
    <p data-start="1412" data-end="1465"><strong data-start="1412" data-end="1426">Case Size:</strong> Approx. 32 mm square-tonneau design.</p>
    </li>
    <li data-start="1466" data-end="1559">
    <p data-start="1468" data-end="1559"><strong data-start="1468" data-end="1478">Bezel:</strong> <strong data-start="1479" data-end="1508">Aftermarket diamond bezel</strong> – handset with premium round brilliant diamonds.</p>
    </li>
    <li data-start="1560" data-end="1644">
    <p data-start="1562" data-end="1644"><strong data-start="1562" data-end="1571">Dial:</strong> Red or silver dial with stylized Arabic numerals and luminous accents.</p>
    </li>
    <li data-start="1645" data-end="1703">
    <p data-start="1647" data-end="1703"><strong data-start="1647" data-end="1660">Movement:</strong> Automatic (self-winding) Swiss movement.</p>
    </li>
    <li data-start="1704" data-end="1756">
    <p data-start="1706" data-end="1756"><strong data-start="1706" data-end="1718">Crystal:</strong> Scratch-resistant sapphire crystal.</p>
    </li>
    <li data-start="1757" data-end="1837">
    <p data-start="1759" data-end="1837"><strong data-start="1759" data-end="1769">Strap:</strong> Leather strap or stainless steel bracelet (depending on variant).</p>
    </li>
    <li data-start="1838" data-end="1877">
    <p data-start="1840" data-end="1877"><strong data-start="1840" data-end="1861">Water Resistance:</strong> 30 m / 3 ATM.</p>
    </li>
    <li data-start="1878" data-end="1948">
    <p data-start="1880" data-end="1948"><strong data-start="1880" data-end="1894">Condition:</strong> Excellent; professionally customized and inspected.</p>
    </li>
    <li data-start="1949" data-end="2035">
    <p data-start="1951" data-end="2035"><strong data-start="1951" data-end="1964">Warranty:</strong> 2-Year JD Watches Warranty (includes diamond workmanship guarantee)</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="410" data-end="728">Command attention with the <strong data-start="437" data-end="482">Franck Muller Conquistador Cortez 10000 L</strong>, a bold expression of contemporary luxury enhanced with a stunning <strong data-start="550" data-end="579">aftermarket diamond bezel</strong>. The signature square-tonneau case design, finished in polished stainless steel, showcases Franck Muller’s mastery of both form and craftsmanship.</p>
    <p data-start="730" data-end="1076">The custom diamond bezel adds a radiant brilliance to the piece, framing the vivid red dial (available on select variants) with shimmering precision. Powered by an <strong data-start="894" data-end="922">automatic Swiss movement</strong>, this timepiece combines reliability, performance, and visual impact — the perfect choice for collectors who value individuality and luxury refinement.</p>
    <h3 data-start="1276" data-end="1296"><strong data-start="1280" data-end="1296">Key Features</strong></h3>
    <ul data-start="1297" data-end="2035">
    <li data-start="1297" data-end="1369">
    <p data-start="1299" data-end="1369"><strong data-start="1299" data-end="1313">Reference:</strong> 10000 L — part of the Conquistador Cortez collection.</p>
    </li>
    <li data-start="1370" data-end="1409">
    <p data-start="1372" data-end="1409"><strong data-start="1372" data-end="1390">Case Material:</strong> Stainless steel.</p>
    </li>
    <li data-start="1410" data-end="1465">
    <p data-start="1412" data-end="1465"><strong data-start="1412" data-end="1426">Case Size:</strong> Approx. 32 mm square-tonneau design.</p>
    </li>
    <li data-start="1466" data-end="1559">
    <p data-start="1468" data-end="1559"><strong data-start="1468" data-end="1478">Bezel:</strong> <strong data-start="1479" data-end="1508">Aftermarket diamond bezel</strong> – handset with premium round brilliant diamonds.</p>
    </li>
    <li data-start="1560" data-end="1644">
    <p data-start="1562" data-end="1644"><strong data-start="1562" data-end="1571">Dial:</strong> Red or silver dial with stylized Arabic numerals and luminous accents.</p>
    </li>
    <li data-start="1645" data-end="1703">
    <p data-start="1647" data-end="1703"><strong data-start="1647" data-end="1660">Movement:</strong> Automatic (self-winding) Swiss movement.</p>
    </li>
    <li data-start="1704" data-end="1756">
    <p data-start="1706" data-end="1756"><strong data-start="1706" data-end="1718">Crystal:</strong> Scratch-resistant sapphire crystal.</p>
    </li>
    <li data-start="1757" data-end="1837">
    <p data-start="1759" data-end="1837"><strong data-start="1759" data-end="1769">Strap:</strong> Leather strap or stainless steel bracelet (depending on variant).</p>
    </li>
    <li data-start="1838" data-end="1877">
    <p data-start="1840" data-end="1877"><strong data-start="1840" data-end="1861">Water Resistance:</strong> 30 m / 3 ATM.</p>
    </li>
    <li data-start="1878" data-end="1948">
    <p data-start="1880" data-end="1948"><strong data-start="1880" data-end="1894">Condition:</strong> Excellent; professionally customized and inspected.</p>
    </li>
    <li data-start="1949" data-end="2035">
    <p data-start="1951" data-end="2035"><strong data-start="1951" data-end="1964">Warranty:</strong> 2-Year JD Watches Warranty (includes diamond workmanship guarantee)</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 5450.0 }],
  } as Product,
  {
    id: "franck-muller-cintree-curvex-6850-sc-automatic-silver-dial-tonneau-watch",
    name: "Franck Muller Cintrée Curvex 6850 SC Automatic Silver Dial Tonneau Watch",
    category: "Franck Muller",
    photo:
      "assets/img/products/franck-muller-cintree-curvex-6850-sc-automatic-silver-dial-tonneau-watch.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/franck-muller">
  Franck Muller
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/franck-muller?rb_snize_facet1=Cintrée Curvex">Cintrée Curvex</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">6850 SC</span>
    </div>
  

  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Silver Dial</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Automatic</span>
    </div>
  

  

  

  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Pre-owned - Excellent</span>
    </div>
  

</div>`,
    description2: `<div class="productdesc"><p data-start="156" data-end="695">The <strong data-start="762" data-end="812">pre-owned Franck Muller Cintrée Curvex 6850 SC</strong> is a masterpiece of Art Deco styling and Swiss craftsmanship. Featuring the brand’s signature tonneau-shaped case, bold numerals, and a clean <strong data-start="955" data-end="980">silver guilloché dial</strong>, this automatic timepiece delivers unmistakable elegance and wrist presence. Powered by a reliable Swiss automatic movement, it blends luxury, precision, and unique design flair. At JD Watches NY, every Franck Muller undergoes full authentication, movement testing, and expert detailing to ensure premium quality. This 6850 SC is ideal for collectors seeking a sophisticated, iconic Curvex model with long-term value and timeless character.</p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/franck-muller">
  Franck Muller
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/franck-muller?rb_snize_facet1=Cintrée Curvex">Cintrée Curvex</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">6850 SC</span>
    </div>
  

  

  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Silver Dial</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Automatic</span>
    </div>
  

  

  

  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Pre-owned - Excellent</span>
    </div>
  

</div>`,
    prices: [{ unit: "unit", amount: 6450.0 }],
  } as Product,
  {
    id: "franck-muller-2500qzd-quartz-red-gold-blue-dial",
    name: "Franck Muller 2500QZD Quartz Red Gold Blue Dial with Diamond Bezel and Case",
    category: "Franck Muller",
    photo:
      "assets/img/products/franck-muller-2500qzd-quartz-red-gold-blue-dial.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/franck-muller">
  Franck Muller
</a>



          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">2500QZD</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/franck-muller?rb_snize_facet2=27 x 20mm Tonneau (Curvex) design">27 x 20mm Tonneau (Curvex) design</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Factory-set with brilliant-cut diamonds</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Deep Blue</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant Sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Swiss Quartz (battery-powered precision)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Genuine alligator leather with matching red gold buckle</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">30 meters / 3 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/franck-muller?rb_snize_facet5=Unisex">Unisex</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Unworn</span>
    </div>
  

</div>`,
    description2: `<div class="productdesc"><p data-start="144" data-end="518">Radiate elegance with the Franck Muller 2500QZD, crafted in red gold with a captivating blue dial and a dazzling diamond-set bezel and case. Recently inspected, fully authenticity-certified, and protected with insurance coverage, this masterpiece embodies luxury and artistry. Secure your Franck Muller today with complete confidence and style.</p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/franck-muller">
  Franck Muller
</a>



          
          </span>
    </div>
  

  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">2500QZD</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/franck-muller?rb_snize_facet2=27 x 20mm Tonneau (Curvex) design">27 x 20mm Tonneau (Curvex) design</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Factory-set with brilliant-cut diamonds</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Deep Blue</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Scratch-resistant Sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Swiss Quartz (battery-powered precision)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Genuine alligator leather with matching red gold buckle</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">30 meters / 3 ATM</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/franck-muller?rb_snize_facet5=Unisex">Unisex</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  
    <div class="spec-item">
      <span class="spec-label">Condition</span>
      <span class="spec-value">Unworn</span>
    </div>
  

</div>`,
    prices: [{ unit: "unit", amount: 20100.0 }],
  } as Product,
  {
    id: "franck-muller-conquistador-cortez-10000-hsc-41mm-with-stainless-steel-bracelet",
    name: "Franck Muller Conquistador Cortez 10000 HSC 41MM With Stainless Steel Bracelet",
    category: "Franck Muller",
    photo:
      "assets/img/products/franck-muller-conquistador-cortez-10000-hsc-41mm-with-stainless-steel-bracelet.jfif",
    description: `<div class="productdesc"><strong>Condition</strong>&nbsp;– Pre-Owned<strong><br>Model</strong> – Franck Muller Conquistador Cortez<br><strong>Reference Number</strong> - 10000 HSC<br><strong>Movement</strong> – Automatic<br><strong>Bezel</strong> - Stainless Steel<br><strong>Dial</strong> – White Dial <br><strong>Case Size</strong> – 41mm<br><strong>Crystal</strong> - Scratch-resistant Sapphire Crystal <br><strong>Bracelet</strong> - Stainless Steel Bracelet <br><strong>Water Resistant</strong> - 10 ATM<br><strong>Gender</strong> – Men's</div>`,
    description2: `<div class="productdesc"><strong>Condition</strong>&nbsp;– Pre-Owned<strong><br>Model</strong> – Franck Muller Conquistador Cortez<br><strong>Reference Number</strong> - 10000 HSC<br><strong>Movement</strong> – Automatic<br><strong>Bezel</strong> - Stainless Steel<br><strong>Dial</strong> – White Dial <br><strong>Case Size</strong> – 41mm<br><strong>Crystal</strong> - Scratch-resistant Sapphire Crystal <br><strong>Bracelet</strong> - Stainless Steel Bracelet <br><strong>Water Resistant</strong> - 10 ATM<br><strong>Gender</strong> – Men's</div>`,
    prices: [{ unit: "unit", amount: 7550.0 }],
  } as Product,
  {
    id: "franck-muller-blue-sea-watch",
    name: "Franck Muller Vanguard Blue Sea Men's Watch",
    category: "Franck Muller",
    photo:
      "assets/img/products/franck-muller-blue-sea-watch.jfif",
    description: `<div class="productdesc"><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">–&nbsp;Never Worn</span><strong data-mce-fragment="1"><br data-mce-fragment="1">Model</strong><span data-mce-fragment="1">&nbsp;– Franck Muller</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1">&nbsp;- <a class="text-link" href="https://www.chrono24.com/franckmuller/ref-45scbluseablung.htm" data-mce-fragment="1" data-mce-href="https://www.chrono24.com/franckmuller/ref-45scbluseablung.htm" onclick="tce('refId', 'watch-details-link');">45SCBLUSEABLUNG</a></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Automatic</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1">&nbsp;– Blue Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1">&nbsp;– 45mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1">&nbsp;- Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1">&nbsp;- Rubber band</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1">&nbsp;- 50 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;– Men's</span></div>`,
    description2: `<div class="productdesc"><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">–&nbsp;Never Worn</span><strong data-mce-fragment="1"><br data-mce-fragment="1">Model</strong><span data-mce-fragment="1">&nbsp;– Franck Muller</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1">&nbsp;- <a class="text-link" href="https://www.chrono24.com/franckmuller/ref-45scbluseablung.htm" data-mce-fragment="1" data-mce-href="https://www.chrono24.com/franckmuller/ref-45scbluseablung.htm" onclick="tce('refId', 'watch-details-link');">45SCBLUSEABLUNG</a></span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Automatic</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1">&nbsp;– Blue Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1">&nbsp;– 45mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1">&nbsp;- Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1">&nbsp;- Rubber band</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1">&nbsp;- 50 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;– Men's</span></div>`,
    prices: [{ unit: "unit", amount: 8755.0 }],
  } as Product,
  // Franck Muller End Brand Collection

  // Panerai Start Brand Collection
  {
    id: "panerai-submersible-paltrinieri-edition-pam01162-47-mm-titanium-automatic",
    name: "Panerai Submersible Paltrinieri Edition PAM01162 – 47 mm Titanium Automatic",
    category: "Panerai",
    photo:
      "assets/img/products/panerai-submersible-paltrinieri-edition-pam01162-47-mm-titanium-automatic.jfif",
    description: `<ul data-start="1188" data-end="2163">
    <li data-start="1188" data-end="1288">
    <p data-start="1190" data-end="1288">Reference: <strong data-start="1201" data-end="1213">PAM01162</strong> — Submersible Paltrinieri Edition.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1289" data-end="1415">
    <p data-start="1291" data-end="1415">Case: <strong data-start="1297" data-end="1306">47 mm</strong> diameter, cushion-shaped, made of titanium — ultra-light yet robust.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1416" data-end="1562">
    <p data-start="1418" data-end="1562">Dial: Black dial with luminescent hour markers, date display, and high legibility for diving conditions.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1563" data-end="1679">
    <p data-start="1565" data-end="1679">Movement: Automatic calibre P.9010 with approx. <strong data-start="1613" data-end="1638">72-hour power reserve</strong>.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1680" data-end="1800">
    <p data-start="1682" data-end="1800">Strap: White rubber strap&nbsp; offering both comfort and durability.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1801" data-end="1914">
    <p data-start="1803" data-end="1914">Water Resistance: 300 m / 30 ATM — suitable for serious underwater use.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1915" data-end="2026">
    <p data-start="1917" data-end="2026">Material: Titanium case &amp; bezel — lightweight high-performance metal.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="2027" data-end="2163">
    <p data-start="2029" data-end="2163">Edition Status: Limited Edition model with “Paltrinieri” branding and high collector appeal.</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="329" data-end="714">Discover the Panerai Submersible Paltrinieri Edition PAM01162 — a bold and technically refined 47 mm dive watch crafted in <strong data-start="452" data-end="464">titanium</strong> for lightweight durability and premium performance. This limited edition piece features a striking <strong data-start="564" data-end="578">black dial</strong>, bold luminescent markers, and a robust blue rubber strap that complements its adventurous DNA.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    <p data-start="716" data-end="1162">Powered by Panerai’s automatic calibre P.9010 movement with a 72-hour power reserve, and water-resistant to 300 m, the PAM01162 delivers both rugged functionality and modern luxury. With its special “Paltrinieri” branding and limited edition status, this watch appeals to serious collectors and enthusiasts alike — particularly those in New York or Dallas seeking standout design and mechanical excellence.</p>
    <h3 data-start="1169" data-end="1187">Key Features</h3>
    <ul data-start="1188" data-end="2163">
    <li data-start="1188" data-end="1288">
    <p data-start="1190" data-end="1288">Reference: <strong data-start="1201" data-end="1213">PAM01162</strong> — Submersible Paltrinieri Edition.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1289" data-end="1415">
    <p data-start="1291" data-end="1415">Case: <strong data-start="1297" data-end="1306">47 mm</strong> diameter, cushion-shaped, made of titanium — ultra-light yet robust.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1416" data-end="1562">
    <p data-start="1418" data-end="1562">Dial: Black dial with luminescent hour markers, date display, and high legibility for diving conditions.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1563" data-end="1679">
    <p data-start="1565" data-end="1679">Movement: Automatic calibre P.9010 with approx. <strong data-start="1613" data-end="1638">72-hour power reserve</strong>.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1680" data-end="1800">
    <p data-start="1682" data-end="1800">Strap: White rubber strap&nbsp; offering both comfort and durability.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1801" data-end="1914">
    <p data-start="1803" data-end="1914">Water Resistance: 300 m / 30 ATM — suitable for serious underwater use.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1915" data-end="2026">
    <p data-start="1917" data-end="2026">Material: Titanium case &amp; bezel — lightweight high-performance metal.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="2027" data-end="2163">
    <p data-start="2029" data-end="2163">Edition Status: Limited Edition model with “Paltrinieri” branding and high collector appeal.</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 7750.0 }],
  } as Product,
  {
    id: "panerai-lumina-marina-pam00422-watch",
    name: "Panerai Lumina Marina Pam00422 Watch",
    category: "Panerai",
    photo:
      "assets/img/products/panerai-lumina-marina-pam00422-watch.jfif",
    description: `<div class="productdesc"><p><strong>Reference </strong>- Pam00422<br><strong>Case </strong>- Stainless Steel&nbsp;<br><strong>Bracelet </strong>- Leather<br><strong>Movement </strong>- Automatic<br><strong>Dial </strong>- Black dial<br><strong>Bezel</strong> - Smooth&nbsp;<br><strong>Box</strong> - Panerai Box<br><strong>Papers </strong>- Panerai papers</p></div>`,
    description2: `<div class="productdesc"><p><strong>Reference </strong>- Pam00422<br><strong>Case </strong>- Stainless Steel&nbsp;<br><strong>Bracelet </strong>- Leather<br><strong>Movement </strong>- Automatic<br><strong>Dial </strong>- Black dial<br><strong>Bezel</strong> - Smooth&nbsp;<br><strong>Box</strong> - Panerai Box<br><strong>Papers </strong>- Panerai papers</p></div>`,
    prices: [{ unit: "unit", amount: 6600.0 }],
  } as Product,
  {
    id: "panerai-radiomir-eilean-pam01243-45mm-stainless-steel-brown-dial-manual-wind",
    name: "Panerai Radiomir Eilean PAM01243 – 45mm Stainless Steel Brown Dial Manual Wind",
    category: "Panerai",
    photo:
      "assets/img/products/panerai-radiomir-eilean-pam01243-45mm-stainless-steel-brown-dial-manual-wind.jfif",
    description: `<ul data-start="1258" data-end="2062">
    <li data-start="1258" data-end="1350">
    <p data-start="1260" data-end="1350">Reference: <strong data-start="1271" data-end="1283">PAM01243</strong> — Radiomir Eilean edition.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1351" data-end="1466">
    <p data-start="1353" data-end="1466">Case: <strong data-start="1359" data-end="1368">45 mm</strong> diameter cushion-shaped stainless steel with aged finish.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1467" data-end="1589">
    <p data-start="1469" data-end="1589">Dial: Brown gradient dial with luminous hands and markers, deck-inspired finish.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1590" data-end="1707">
    <p data-start="1592" data-end="1707">Movement: Manual winding calibre P.6000, approx. <strong data-start="1641" data-end="1666">72-hour power reserve</strong>. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://watchesbysjx.com/2021/07/panerai-radiomir-eilean-pam01243.html?utm_source=chatgpt.com" rel="noopener" alt="https://watchesbysjx.com/2021/07/panerai-radiomir-eilean-pam01243.html?utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between"><span class="max-w-[15ch] grow truncate overflow-hidden text-center">&nbsp;</span></span></span></a></span></span></p>
    </li>
    <li data-start="1708" data-end="1811">
    <p data-start="1710" data-end="1811">Water Resistance: <strong data-start="1728" data-end="1746">100 m / 10 ATM</strong> — suited for daily wear.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1812" data-end="1918">
    <p data-start="1814" data-end="1918">Strap: Leather strap matching the brown dial and nautical theme.</p>
    </li>
    <li data-start="1919" data-end="2062">
    <p data-start="1921" data-end="2062">Limited Edition: Produced in <strong data-start="1950" data-end="1964">449 pieces</strong> per year (or similar figure) honoring the Eilean yacht.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="334" data-end="715">Discover the Panerai Radiomir Eilean PAM01243 — a limited-edition tribute to the famous 1936 yacht <em data-start="433" data-end="441">Eilean</em>, combining maritime heritage with refined Swiss craftsmanship. Housed in a 45 mm stainless steel cushion case with an aged “patina-style” finish and a rich brown gradient dial, this timepiece delivers bold presence and subtle elegance. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://escapementmagazine.com/articles/panerai-radiomir-eilean-pam01243/?utm_source=chatgpt.com" rel="noopener" alt="https://escapementmagazine.com/articles/panerai-radiomir-eilean-pam01243/?utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between absolute"><span class="max-w-[15ch] grow truncate overflow-hidden text-center"></span></span></span></a></span></span>Powered by the hand-wound in-house calibre P.6000 movement, offering a 72-hour power reserve and designed for minimalism with hours, minutes and small seconds only.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://www.coveted.com/watches/panerai-radiomir-eilean-01243?utm_source=chatgpt.com" rel="noopener" alt="https://www.coveted.com/watches/panerai-radiomir-eilean-01243?utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between absolute"><span class="-me-1 flex h-full items-center rounded-full px-1 text-[#8F8F8F]"></span></span></span></a></span></span> The watch is water-resistant to 100 m and fitted on a leather strap that complements the maritime inspiration.</p>
<h3 data-start="1239" data-end="1257">Key Features</h3>
<ul data-start="1258" data-end="2062">
<li data-start="1258" data-end="1350">
<p data-start="1260" data-end="1350">Reference: <strong data-start="1271" data-end="1283">PAM01243</strong> — Radiomir Eilean edition.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
</li>
<li data-start="1351" data-end="1466">
<p data-start="1353" data-end="1466">Case: <strong data-start="1359" data-end="1368">45 mm</strong> diameter cushion-shaped stainless steel with aged finish.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
</li>
<li data-start="1467" data-end="1589">
<p data-start="1469" data-end="1589">Dial: Brown gradient dial with luminous hands and markers, deck-inspired finish.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
</li>
<li data-start="1590" data-end="1707">
<p data-start="1592" data-end="1707">Movement: Manual winding calibre P.6000, approx. <strong data-start="1641" data-end="1666">72-hour power reserve</strong>. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://watchesbysjx.com/2021/07/panerai-radiomir-eilean-pam01243.html?utm_source=chatgpt.com" rel="noopener" alt="https://watchesbysjx.com/2021/07/panerai-radiomir-eilean-pam01243.html?utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between"><span class="max-w-[15ch] grow truncate overflow-hidden text-center">&nbsp;</span></span></span></a></span></span></p>
</li>
<li data-start="1708" data-end="1811">
<p data-start="1710" data-end="1811">Water Resistance: <strong data-start="1728" data-end="1746">100 m / 10 ATM</strong> — suited for daily wear.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
</li>
<li data-start="1812" data-end="1918">
<p data-start="1814" data-end="1918">Strap: Leather strap matching the brown dial and nautical theme.</p>
</li>
<li data-start="1919" data-end="2062">
<p data-start="1921" data-end="2062">Limited Edition: Produced in <strong data-start="1950" data-end="1964">449 pieces</strong> per year (or similar figure) honoring the Eilean yacht.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
</li>
</ul></div>`,
    prices: [{ unit: "unit", amount: 8200.0 }],
  } as Product,
  {
    id: "panerai-luminor-daylight-pam00236-44-mm-stainless-steel-chronograph",
    name: "Panerai Luminor Daylight PAM00236 – 44 mm Stainless Steel Chronograph",
    category: "Panerai",
    photo:
      "assets/img/products/panerai-luminor-daylight-pam00236-44-mm-stainless-steel-chronograph.jfif",
    description: `<ul data-start="1047" data-end="2032">
    <li data-start="1047" data-end="1156">
    <p data-start="1049" data-end="1156">Reference: <strong data-start="1060" data-end="1072">PAM00236</strong> – part of the Luminor Daylight Chrono line.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1157" data-end="1258">
    <p data-start="1159" data-end="1258">Case: 44 mm stainless steel cushion case — bold and modern.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1259" data-end="1416">
    <p data-start="1261" data-end="1416">Dial: Black chronograph dial with sub-dials, date display (between 4 and 5 o’clock) and mixed stick/Arabic markers.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1417" data-end="1517">
    <p data-start="1419" data-end="1517">Movement: Automatic (calibre OP XII) chronograph movement. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://watchbase.com/panerai/luminor/pam00236?utm_source=chatgpt.com" rel="noopener" alt="https://watchbase.com/panerai/luminor/pam00236?utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between"><span class="max-w-[15ch] grow truncate overflow-hidden text-center"></span></span></span></a></span></span>Water Resistance: Up to 100 m / 330 ft — built for everyday wear and active use. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://www.jomashop.com/panerai-luminor-chrono-pam00236.html?srsltid=AfmBOor1plvImsOwWXxilz4MHAVNphjQeVrRYx39ZqHYQkXZ7rS6VqYu&amp;utm_source=chatgpt.com" rel="noopener" alt="https://www.jomashop.com/panerai-luminor-chrono-pam00236.html?srsltid=AfmBOor1plvImsOwWXxilz4MHAVNphjQeVrRYx39ZqHYQkXZ7rS6VqYu&amp;utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between"><span class="max-w-[15ch] grow truncate overflow-hidden text-center"></span></span></span></a></span></span>Crystal: Scratch-resistant sapphire crystal for durability and clarity.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1755" data-end="1895">
    <p data-start="1757" data-end="1895">Bracelet/Strap: Stainless steel bracelet variant available — robust and cohesive with case design.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1896" data-end="2032">
    <p data-start="1898" data-end="2032">Style: Combines Panerai’s heritage design with modern chronograph functionality — making it ideal for both sporty and luxury settings.</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="303" data-end="711">Discover the Panerai Luminor Daylight PAM00236 — a striking 44 mm stainless steel chronograph from the iconic Luminor series. With its bold black dial, sculpted stainless steel case, and meticulous Swiss automatic movement (OP XII calibre) delivering hours, minutes, small seconds, date and chronograph functions, this Panerai is built for both presence and performance.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    <p data-start="713" data-end="1021">Water-resistant to 100 m, complete with sapphire crystal and tachymeter bezel, the PAM00236 is a timepiece that blends tool-watch capability with refined luxury. Ideal for collectors and professionals in New York and Dallas seeking a standout watch that balances heritage, size and mechanical sophistication.</p>
    <h3 data-start="1028" data-end="1046">Key Features</h3>
    <ul data-start="1047" data-end="2032">
    <li data-start="1047" data-end="1156">
    <p data-start="1049" data-end="1156">Reference: <strong data-start="1060" data-end="1072">PAM00236</strong> – part of the Luminor Daylight Chrono line.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1157" data-end="1258">
    <p data-start="1159" data-end="1258">Case: 44 mm stainless steel cushion case — bold and modern.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1259" data-end="1416">
    <p data-start="1261" data-end="1416">Dial: Black chronograph dial with sub-dials, date display (between 4 and 5 o’clock) and mixed stick/Arabic markers.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1417" data-end="1517">
    <p data-start="1419" data-end="1517">Movement: Automatic (calibre OP XII) chronograph movement. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://watchbase.com/panerai/luminor/pam00236?utm_source=chatgpt.com" rel="noopener" alt="https://watchbase.com/panerai/luminor/pam00236?utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between"><span class="max-w-[15ch] grow truncate overflow-hidden text-center"></span></span></span></a></span></span>Water Resistance: Up to 100 m / 330 ft — built for everyday wear and active use. <span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"><a href="https://www.jomashop.com/panerai-luminor-chrono-pam00236.html?srsltid=AfmBOor1plvImsOwWXxilz4MHAVNphjQeVrRYx39ZqHYQkXZ7rS6VqYu&amp;utm_source=chatgpt.com" rel="noopener" alt="https://www.jomashop.com/panerai-luminor-chrono-pam00236.html?srsltid=AfmBOor1plvImsOwWXxilz4MHAVNphjQeVrRYx39ZqHYQkXZ7rS6VqYu&amp;utm_source=chatgpt.com" class="flex h-4.5 overflow-hidden rounded-xl px-2 text-[9px] font-medium transition-colors duration-150 ease-in-out text-token-text-secondary! bg-[#F4F4F4]! dark:bg-[#303030]!" target="_blank"><span class="relative start-0 bottom-0 flex h-full w-full items-center"><span class="flex h-4 w-full items-center justify-between"><span class="max-w-[15ch] grow truncate overflow-hidden text-center"></span></span></span></a></span></span>Crystal: Scratch-resistant sapphire crystal for durability and clarity.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1755" data-end="1895">
    <p data-start="1757" data-end="1895">Bracelet/Strap: Stainless steel bracelet variant available — robust and cohesive with case design.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1896" data-end="2032">
    <p data-start="1898" data-end="2032">Style: Combines Panerai’s heritage design with modern chronograph functionality — making it ideal for both sporty and luxury settings.</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 6100.0 }],
  } as Product,
  {
    id: "panerai-luminor-marina-pam01058-44mm-blue-dial-with-stainless-steel-bracelet",
    name: "Panerai Luminor Marina PAM01058 44MM Blue Dial With Stainless Steel Bracelet",
    category: "Panerai",
    photo:
      "assets/img/products/panerai-luminor-marina-pam01058-44mm-blue-dial-with-stainless-steel-bracelet.jfif",
    description: `<p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">&nbsp;– Pre-Owned</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Model</strong><span data-mce-fragment="1"> – Panerai Luminor Marina</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1"> – PAM01058</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Automatic</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> – Stainless Steel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1"> – Blue Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1"> – 44mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1"> – Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> –&nbsp;Stainless Steel&nbsp;Bracelet</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1"> – 30 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;– Men's</span> <script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p>`,
    description2: `<div class="productdesc"><p><strong data-mce-fragment="1">Panerai Luminor Marina PAM01058 44MM Blue Dial With Stainless Steel Bracelet</strong></p>
    <p>&nbsp;</p>
    <p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">&nbsp;– Pre-Owned</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Model</strong><span data-mce-fragment="1"> – Panerai Luminor Marina</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1"> – PAM01058</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Automatic</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> – Stainless Steel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1"> – Blue Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1"> – 44mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1"> – Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> –&nbsp;Stainless Steel&nbsp;Bracelet</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1"> – 30 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;– Men's</span> <script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p></div>`,
    prices: [{ unit: "unit", amount: 9270.0 }],
  } as Product,
  {
    id: "panerai-luminor-marina-pam00049-40mm-white-dial-with-black-rubber-bracelet",
    name: "Panerai Luminor Marina PAM00049 40MM White Dial With Black Rubber Bracelet",
    category: "Panerai",
    photo:
      "assets/img/products/panerai-luminor-marina-pam00049-40mm-white-dial-with-black-rubber-bracelet.jfif",
    description: `<p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">&nbsp;– Pre-Owned</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Model</strong><span data-mce-fragment="1"> – Panerai Luminor Marina</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1"> – PAM00049</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Automatic</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> – Stainless Steel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1"> – White Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1"> – 40mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1"> – Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> – Black Rubber Bracelet</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1"> – 30 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;–&nbsp;Unisex</span><script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p>`,
    description2: `<div class="productdesc"><p><strong data-mce-fragment="1">Panerai Luminor Marina PAM00049 40MM White Dial With Black Rubber Bracelet</strong></p>
    <p>&nbsp;</p>
    <p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1">&nbsp;– Pre-Owned</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Model</strong><span data-mce-fragment="1"> – Panerai Luminor Marina</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong><span data-mce-fragment="1"> – PAM00049</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Automatic</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> – Stainless Steel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1"> – White Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1"> – 40mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1"> – Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> – Black Rubber Bracelet</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1"> – 30 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;–&nbsp;Unisex</span><script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p></div>`,
    prices: [{ unit: "unit", amount: 6900.0 }],
  } as Product,
  // Panerai End Brand Collection

  // Omega Start Brand Collection
  {
    id: "omega-speedmaster-3511-80-00-date-blue-dial-chronograph-mens-watch",
    name: "omega-speedmaster-3511-80-00-date-blue-dial-chronograph-mens-watch",
    category: "Omega",
    photo:
      "assets/img/products/omega-speedmaster-3511-80-00-date-blue-dial-chronograph-mens-watch.jfif",
    description: `<div class="productdesc"><p style="text-align: left;"><strong>Brand</strong>: &nbsp; &nbsp;Omega<br><strong>Model Name</strong>: &nbsp; &nbsp;Omega Speedmaster Date Blue Dial Chronograph<br><strong>Model Number</strong>: &nbsp; &nbsp;3511.80.00<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel round case 39.0 mm in diameter.<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless steel bezel engraved with tachymeter scale<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch-resistant sapphire crystal with anti-reflective treatment inside.<br><strong>Dial</strong>: &nbsp; &nbsp;Blue dial with baton hour markers and hands. 3 sub-dials -- a small seconds counter, 30 minute recorder, and 12 hour recorder. Date window at the 3 o'clock position. Stick second and 1/5 second markers around the outer rim.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet with folding clasp. Fits an 8 1/4" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Omega box and cards<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    description2: `<div class="productdesc"><p style="text-align: left;"><strong>Brand</strong>: &nbsp; &nbsp;Omega<br><strong>Model Name</strong>: &nbsp; &nbsp;Omega Speedmaster Date Blue Dial Chronograph<br><strong>Model Number</strong>: &nbsp; &nbsp;3511.80.00<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel round case 39.0 mm in diameter.<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless steel bezel engraved with tachymeter scale<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch-resistant sapphire crystal with anti-reflective treatment inside.<br><strong>Dial</strong>: &nbsp; &nbsp;Blue dial with baton hour markers and hands. 3 sub-dials -- a small seconds counter, 30 minute recorder, and 12 hour recorder. Date window at the 3 o'clock position. Stick second and 1/5 second markers around the outer rim.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet with folding clasp. Fits an 8 1/4" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Omega box and cards<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    prices: [{ unit: "unit", amount: 3600.0 }],
  } as Product,
  {
    id: "omega-seamaster-planet-ocean-600m-gmt-ref-232-30-44-22-01-001",
    name: "Omega Seamaster Planet Ocean 600M GMT – Ref. 232.30.44.22.01.001",
    category: "Omega",
    photo:
      "assets/img/products/omega-seamaster-planet-ocean-600m-gmt-ref-232-30-44-22-01-001.jfif",
    description: `<ul data-start="1582" data-end="2074">
    <li data-start="1582" data-end="1634">
    <p data-start="1584" data-end="1634"><strong data-start="1584" data-end="1594">Model:</strong> Omega Seamaster Planet Ocean 600M GMT</p>
    </li>
    <li data-start="1635" data-end="1677">
    <p data-start="1637" data-end="1677"><strong data-start="1637" data-end="1651">Reference:</strong> <strong data-start="1652" data-end="1675">232.30.44.22.01.001</strong></p>
    </li>
    <li data-start="1678" data-end="1707">
    <p data-start="1680" data-end="1707"><strong data-start="1680" data-end="1694">Case Size:</strong> <strong data-start="1695" data-end="1705">43.5mm</strong></p>
    </li>
    <li data-start="1708" data-end="1746">
    <p data-start="1710" data-end="1746"><strong data-start="1710" data-end="1728">Case Material:</strong> Stainless Steel</p>
    </li>
    <li data-start="1747" data-end="1766">
    <p data-start="1749" data-end="1766"><strong data-start="1749" data-end="1758">Dial:</strong> Black</p>
    </li>
    <li data-start="1767" data-end="1807">
    <p data-start="1769" data-end="1807"><strong data-start="1769" data-end="1779">Bezel:</strong> Unidirectional dive bezel</p>
    </li>
    <li data-start="1808" data-end="1869">
    <p data-start="1810" data-end="1869"><strong data-start="1810" data-end="1823">Movement:</strong> Omega Co-Axial <strong data-start="1839" data-end="1855">Calibre 8605</strong> (Automatic)</p>
    </li>
    <li data-start="1870" data-end="1903">
    <p data-start="1872" data-end="1903"><strong data-start="1872" data-end="1885">Bracelet:</strong> Stainless Steel</p>
    </li>
    <li data-start="1904" data-end="1929">
    <p data-start="1906" data-end="1929"><strong data-start="1906" data-end="1918">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1930" data-end="1982">
    <p data-start="1932" data-end="1982"><strong data-start="1932" data-end="1953">Water Resistance:</strong> <strong data-start="1954" data-end="1980">600 meters / 2000 feet</strong></p>
    </li>
    <li data-start="1983" data-end="2074">
    <p data-start="1985" data-end="2074"><strong data-start="1985" data-end="1999">Functions:</strong> GMT (2nd time zone), date display, helium escape valve, luminous markers</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="393" data-end="838">Built for serious performance and designed with unmistakable Omega style, the <strong data-start="471" data-end="512">Omega Seamaster Planet Ocean 600M GMT</strong> is the ultimate tool watch for collectors who want both dive capability and travel functionality. The reference <strong data-start="625" data-end="648">232.30.44.22.01.001</strong> features a bold <strong data-start="665" data-end="696">43.5mm stainless steel case</strong>, a sleek <strong data-start="706" data-end="720">black dial</strong>, and a rugged unidirectional dive bezel — all engineered to thrive under pressure, whether underwater or on the move.</p>
    <p data-start="840" data-end="1335">This model adds the highly desirable <strong data-start="877" data-end="893">GMT function</strong>, allowing you to track a second time zone with ease — perfect for frequent travelers and global collectors. Powered by Omega’s <strong data-start="1021" data-end="1046">Co-Axial Calibre 8605</strong>, it delivers dependable accuracy, durability, and a smooth luxury feel on the wrist. With a professional-grade <strong data-start="1158" data-end="1205">600 meters (2,000 feet) of water resistance</strong> and Omega’s signature helium escape valve, the Planet Ocean GMT is a true high-performance timepiece with real-world versatility.</p>
    <p data-start="1337" data-end="1554">If you’re looking for a luxury sport watch that combines a bold presence, dive-ready engineering, and dual-time practicality, the <strong data-start="1467" data-end="1512">Planet Ocean 600M GMT 232.30.44.22.01.001</strong> is a standout addition to any collection.</p>
    <h3 data-start="1561" data-end="1581"><strong data-start="1565" data-end="1581">Key Features</strong></h3>
    <ul data-start="1582" data-end="2074">
    <li data-start="1582" data-end="1634">
    <p data-start="1584" data-end="1634"><strong data-start="1584" data-end="1594">Model:</strong> Omega Seamaster Planet Ocean 600M GMT</p>
    </li>
    <li data-start="1635" data-end="1677">
    <p data-start="1637" data-end="1677"><strong data-start="1637" data-end="1651">Reference:</strong> <strong data-start="1652" data-end="1675">232.30.44.22.01.001</strong></p>
    </li>
    <li data-start="1678" data-end="1707">
    <p data-start="1680" data-end="1707"><strong data-start="1680" data-end="1694">Case Size:</strong> <strong data-start="1695" data-end="1705">43.5mm</strong></p>
    </li>
    <li data-start="1708" data-end="1746">
    <p data-start="1710" data-end="1746"><strong data-start="1710" data-end="1728">Case Material:</strong> Stainless Steel</p>
    </li>
    <li data-start="1747" data-end="1766">
    <p data-start="1749" data-end="1766"><strong data-start="1749" data-end="1758">Dial:</strong> Black</p>
    </li>
    <li data-start="1767" data-end="1807">
    <p data-start="1769" data-end="1807"><strong data-start="1769" data-end="1779">Bezel:</strong> Unidirectional dive bezel</p>
    </li>
    <li data-start="1808" data-end="1869">
    <p data-start="1810" data-end="1869"><strong data-start="1810" data-end="1823">Movement:</strong> Omega Co-Axial <strong data-start="1839" data-end="1855">Calibre 8605</strong> (Automatic)</p>
    </li>
    <li data-start="1870" data-end="1903">
    <p data-start="1872" data-end="1903"><strong data-start="1872" data-end="1885">Bracelet:</strong> Stainless Steel</p>
    </li>
    <li data-start="1904" data-end="1929">
    <p data-start="1906" data-end="1929"><strong data-start="1906" data-end="1918">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1930" data-end="1982">
    <p data-start="1932" data-end="1982"><strong data-start="1932" data-end="1953">Water Resistance:</strong> <strong data-start="1954" data-end="1980">600 meters / 2000 feet</strong></p>
    </li>
    <li data-start="1983" data-end="2074">
    <p data-start="1985" data-end="2074"><strong data-start="1985" data-end="1999">Functions:</strong> GMT (2nd time zone), date display, helium escape valve, luminous markers</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 5000.0 }],
  } as Product,
  {
    id: "omega-speedmaster-date-3210-50-00-40mm-black-dial-with-stainless-steel-bracelet",
    name: "Omega Speedmaster Date 3210.50.00 – 40mm Black Dial with Stainless Steel Bracelet",
    category: "Omega",
    photo:
      "assets/img/products/omega-speedmaster-date-3210-50-00-40mm-black-dial-with-stainless-steel-bracelet.jfif",
    description: `<p data-start="1258" data-end="1608" class=""><strong data-start="1258" data-end="1275">Key Features:&nbsp;</strong><br data-start="1275" data-end="1278">Model: Omega Speedmaster Date<br data-start="1307" data-end="1310">Reference: 3210.50.00<br data-start="1331" data-end="1334">Case Material: Stainless Steel<br data-start="1364" data-end="1367">Case Size: 40mm<br data-start="1382" data-end="1385">Dial: Black with Chronograph Sub-Dials and Date at 3 o’clock<br data-start="1445" data-end="1448">Bezel: Fixed Tachymeter Scale in Black<br data-start="1486" data-end="1489">Bracelet: Stainless Steel Bracelet<br data-start="1523" data-end="1526">Buckle: Folding Clasp<br data-start="1547" data-end="1550">Movement: Automatic – Omega Caliber 1164 (ETA 7750 Base)</p>`,
    description2: `<div class="productdesc"><h3 data-start="127" data-end="216" class=""><strong data-start="131" data-end="216">Omega Speedmaster Date 3210.50.00 – 40mm Black Dial with Stainless Steel Bracelet</strong></h3>
    <p data-start="218" data-end="530" class="">Sporty, modern, and unmistakably Speedmaster, the Omega Speedmaster Date 3210.50.00 offers a contemporary twist on Omega’s storied chronograph line. With a 40mm stainless steel case and bold black dial, this reference balances everyday wearability with the technical prowess expected from the Speedmaster family.</p>
    <p data-start="532" data-end="939" class="">The dial features three well-spaced sub-dials for chronograph functions and a date window subtly placed at 3 o’clock. Luminous baton hands and applied hour markers enhance visibility, while the fixed black aluminum tachymeter bezel anchors the model in its motorsport roots. The case profile is sleek yet substantial, paired with a brushed and polished stainless steel bracelet for a cohesive, refined look.</p>
    <p data-start="941" data-end="1256" class="">Inside, the Omega Caliber 1164 automatic chronograph movement (based on the ETA 7750) powers this watch with reliable accuracy and a 44-hour power reserve. Designed for those who value both function and form, the 3210.50.00 remains a solid choice for enthusiasts seeking a modern Speedmaster with daily versatility.</p>
    <p data-start="1258" data-end="1608" class=""><strong data-start="1258" data-end="1275">Key Features:&nbsp;</strong><br data-start="1275" data-end="1278">Model: Omega Speedmaster Date<br data-start="1307" data-end="1310">Reference: 3210.50.00<br data-start="1331" data-end="1334">Case Material: Stainless Steel<br data-start="1364" data-end="1367">Case Size: 40mm<br data-start="1382" data-end="1385">Dial: Black with Chronograph Sub-Dials and Date at 3 o’clock<br data-start="1445" data-end="1448">Bezel: Fixed Tachymeter Scale in Black<br data-start="1486" data-end="1489">Bracelet: Stainless Steel Bracelet<br data-start="1523" data-end="1526">Buckle: Folding Clasp<br data-start="1547" data-end="1550">Movement: Automatic – Omega Caliber 1164 (ETA 7750 Base)</p>
    <p data-start="1610" data-end="1677" class=""><strong data-start="1610" data-end="1624">Functions:</strong><br data-start="1624" data-end="1627">Hours, Minutes, Small Seconds, Chronograph, Date</p>
    <p data-start="1679" data-end="1761" class="">Case Back: Solid Stainless Steel<br data-start="1711" data-end="1714">Water Resistance: 100m<br data-start="1736" data-end="1739">Condition: Pre-Owned</p></div>`,
    prices: [{ unit: "unit", amount: 8200.0 }],
  } as Product,
  {
    id: "omega-speedmaster-3523-30-00-day-date-chronograph-steel-mens-watch",
    name: "Omega Speedmaster 3523.30.00 Day Date Chronograph Steel Mens Watch",
    category: "Omega",
    photo:
      "assets/img/products/omega-speedmaster-3523-30-00-day-date-chronograph-steel-mens-watch.jfif",
    description: `<div class="productdesc"><p style="text-align: left;"><br><strong>Brand</strong>: &nbsp; &nbsp;Omega<br><strong>Model Name</strong>: &nbsp; &nbsp;Omega Speedmaster Day Date Chronograph&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;3523.30.00<br><strong>Gender</strong>: &nbsp; &nbsp;Mens<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement. Day and month indications.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel round case 39.0 mm in diameter.<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless steel bezel with tachymeter scale.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch-resistant sapphire crystal with anti-reflective treatment inside.<br><strong>Dial</strong>: &nbsp; &nbsp;Silver dial with raised index hour markers and luminous hands. Three silver chronograph sub-dials -- 30-minutes at 12 o'clock, 12-hours at 6 o'clock, and small seconds counter shared with the 24-hour hand at 9 o'clock. Day of the week and month windows at 12 o'clock. Pointer date function outside of minute track.<br><strong>Bracelet</strong>: &nbsp; &nbsp;Brushed and polished stainless steel bracelet with hidden clasp and single security pusher. Fits 7 3/4" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition.<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Presentation non-Omega box.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    description2: `<div class="productdesc"><p style="text-align: left;"><br><strong>Brand</strong>: &nbsp; &nbsp;Omega<br><strong>Model Name</strong>: &nbsp; &nbsp;Omega Speedmaster Day Date Chronograph&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;3523.30.00<br><strong>Gender</strong>: &nbsp; &nbsp;Mens<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement. Day and month indications.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel round case 39.0 mm in diameter.<br><strong>Bezel</strong>: &nbsp; &nbsp;Stainless steel bezel with tachymeter scale.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch-resistant sapphire crystal with anti-reflective treatment inside.<br><strong>Dial</strong>: &nbsp; &nbsp;Silver dial with raised index hour markers and luminous hands. Three silver chronograph sub-dials -- 30-minutes at 12 o'clock, 12-hours at 6 o'clock, and small seconds counter shared with the 24-hour hand at 9 o'clock. Day of the week and month windows at 12 o'clock. Pointer date function outside of minute track.<br><strong>Bracelet</strong>: &nbsp; &nbsp;Brushed and polished stainless steel bracelet with hidden clasp and single security pusher. Fits 7 3/4" wrist.<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition.<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Presentation non-Omega box.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    prices: [{ unit: "unit", amount: 3201.0 }],
  } as Product,
  {
    id: "omega-speedmaster-date-automatic-silver-dial-stainless-steel-39mm-3513-30-00",
    name: "Omega Speedmaster Date Automatic Silver Dial Stainless Steel 39mm – 3513.30.00",
    category: "Omega",
    photo:
      "assets/img/products/omega-speedmaster-date-automatic-silver-dial-stainless-steel-39mm-3513-30-00.jfif",
    description: `<ul data-start="1187" data-end="1580">
    <li data-section-id="48bhqg" data-start="1187" data-end="1205">
    <strong data-start="1189" data-end="1199">Brand:</strong> Omega</li>
    <li data-section-id="rq023" data-start="1206" data-end="1240">
    <strong data-start="1208" data-end="1223">Collection:</strong> Speedmaster Date</li>
    <li data-section-id="ye98vy" data-start="1241" data-end="1268">
    <strong data-start="1243" data-end="1257">Reference:</strong> 3513.30.00</li>
    <li data-section-id="b14bqh" data-start="1269" data-end="1290">
    <strong data-start="1271" data-end="1285">Case Size:</strong> 39mm</li>
    <li data-section-id="o5aaem" data-start="1291" data-end="1327">
    <strong data-start="1293" data-end="1311">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="12lh9z9" data-start="1328" data-end="1346">
    <strong data-start="1330" data-end="1339">Dial:</strong> Silver</li>
    <li data-section-id="13tp5iz" data-start="1347" data-end="1378">
    <strong data-start="1349" data-end="1362">Bracelet:</strong> Stainless Steel</li>
    <li data-section-id="fzksfg" data-start="1379" data-end="1404">
    <strong data-start="1381" data-end="1394">Movement:</strong> Automatic</li>
    <li data-section-id="od0u8b" data-start="1405" data-end="1465">
    <strong data-start="1407" data-end="1421">Functions:</strong> Chronograph, Date, Hours, Minutes &amp; Seconds</li>
    <li data-section-id="mrgz67" data-start="1466" data-end="1495">
    <strong data-start="1468" data-end="1485">Date Display:</strong> 3 O'Clock</li>
    <li data-section-id="12o8djm" data-start="1496" data-end="1525">
    <strong data-start="1498" data-end="1508">Bezel:</strong> Tachymeter Scale</li>
    <li data-section-id="1cd3ppx" data-start="1526" data-end="1580">
    <strong data-start="1528" data-end="1542">Swiss Made</strong> <span class="" data-state="closed"></span>
    </li>
    </ul>`,
    description2: `<div class="markdown prose dark:prose-invert wrap-break-word w-full light markdown-new-styling">
    <p data-start="352" data-end="630" class="PDq2pG_selectionAnchorContainer">Classic Speedmaster heritage meets everyday versatility in the <strong data-start="415" data-end="457">Omega Speedmaster Date Ref. 3513.30.00</strong>. Crafted in stainless steel, this sophisticated chronograph features a striking silver dial with a balanced three-register layout and a practical date display at 3 o'clock.<span aria-hidden="true" class="PDq2pG_selectionAnchor"></span></p>
    <p data-start="632" data-end="970">The polished and brushed stainless steel case is complemented by an engraved tachymeter bezel, reinforcing the Speedmaster's legendary racing-inspired character. Powered by an automatic movement, this timepiece combines precision, functionality, and timeless Omega design in a versatile 39mm profile. <span class="" data-state="closed"></span></p>
    <p data-start="972" data-end="1168">Paired with a stainless steel bracelet, the Speedmaster Date transitions effortlessly from everyday wear to more formal occasions, making it an exceptional addition to any luxury watch collection.</p>
    <h3 data-section-id="1iz91iu" data-start="1170" data-end="1186">Key Features</h3>
    <ul data-start="1187" data-end="1580">
    <li data-section-id="48bhqg" data-start="1187" data-end="1205">
    <strong data-start="1189" data-end="1199">Brand:</strong> Omega</li>
    <li data-section-id="rq023" data-start="1206" data-end="1240">
    <strong data-start="1208" data-end="1223">Collection:</strong> Speedmaster Date</li>
    <li data-section-id="ye98vy" data-start="1241" data-end="1268">
    <strong data-start="1243" data-end="1257">Reference:</strong> 3513.30.00</li>
    <li data-section-id="b14bqh" data-start="1269" data-end="1290">
    <strong data-start="1271" data-end="1285">Case Size:</strong> 39mm</li>
    <li data-section-id="o5aaem" data-start="1291" data-end="1327">
    <strong data-start="1293" data-end="1311">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="12lh9z9" data-start="1328" data-end="1346">
    <strong data-start="1330" data-end="1339">Dial:</strong> Silver</li>
    <li data-section-id="13tp5iz" data-start="1347" data-end="1378">
    <strong data-start="1349" data-end="1362">Bracelet:</strong> Stainless Steel</li>
    <li data-section-id="fzksfg" data-start="1379" data-end="1404">
    <strong data-start="1381" data-end="1394">Movement:</strong> Automatic</li>
    <li data-section-id="od0u8b" data-start="1405" data-end="1465">
    <strong data-start="1407" data-end="1421">Functions:</strong> Chronograph, Date, Hours, Minutes &amp; Seconds</li>
    <li data-section-id="mrgz67" data-start="1466" data-end="1495">
    <strong data-start="1468" data-end="1485">Date Display:</strong> 3 O'Clock</li>
    <li data-section-id="12o8djm" data-start="1496" data-end="1525">
    <strong data-start="1498" data-end="1508">Bezel:</strong> Tachymeter Scale</li>
    <li data-section-id="1cd3ppx" data-start="1526" data-end="1580">
    <strong data-start="1528" data-end="1542">Swiss Made</strong> <span class="" data-state="closed"></span>
    </li>
    </ul>
    <p data-start="1582" data-end="1683" data-is-last-node="" data-is-only-node=""><strong data-start="1582" data-end="1683" data-is-last-node="">A refined automatic chronograph combining iconic Speedmaster styling with everyday functionality.</strong></p>
    </div>`,
    prices: [{ unit: "unit", amount: 2500.0 }],
  } as Product,
  {
    id: "omega-speedmaster-professional-moonwatch-42mm-rose-gold-black-dial-chronograph-18k-sedna",
    name: "Omega Speedmaster Professional Moonwatch 42mm Rose Gold Black Dial Chronograph 18K Sedna",
    category: "Omega",
    photo:
      "assets/img/products/omega-speedmaster-professional-moonwatch-42mm-rose-gold-black-dial-chronograph-18k-sedna.jfif",
    description: `<p data-start="1291" data-end="1764"><strong data-start="1291" data-end="1301">Brand:</strong> Omega<br data-start="1307" data-end="1310"><strong data-start="1310" data-end="1320">Model:</strong> Speedmaster Professional Moonwatch<br data-start="1355" data-end="1358"><strong data-start="1358" data-end="1372">Case Size:</strong> 42mm<br data-start="1377" data-end="1380"><strong data-start="1380" data-end="1398">Case Material:</strong> 18K Sedna™ Rose Gold<br data-start="1419" data-end="1422"><strong data-start="1422" data-end="1432">Bezel:</strong> Black Tachymeter Bezel<br data-start="1455" data-end="1458"><strong data-start="1458" data-end="1467">Dial:</strong> Black Dial with Rose Gold Hands &amp; Markers<br data-start="1509" data-end="1512"><strong data-start="1512" data-end="1524">Crystal:</strong> Sapphire Crystal<br data-start="1541" data-end="1544"><strong data-start="1544" data-end="1557">Bracelet:</strong> 18K Sedna™ Rose Gold Bracelet<br data-start="1587" data-end="1590"><strong data-start="1590" data-end="1603">Movement:</strong> Mechanical Chronograph Movement<br data-start="1635" data-end="1638"><strong data-start="1638" data-end="1652">Functions:</strong> Hours, Minutes, Small Seconds, Chronograph<br data-start="1695" data-end="1698"><strong data-start="1698" data-end="1719" data-is-only-node="">Water Resistance:</strong> 50 meters / 5 ATM (typical Moonwatch spec)</p>`,
    description2: `<div class="productdesc"><h3 data-start="232" data-end="289">18K Sedna™ Rose Gold | Black Dial | 42mm | Chronograph</h3>
    <p data-start="291" data-end="350">A legend of space exploration, elevated in solid rose gold.</p>
    <p data-start="352" data-end="680">The <strong data-start="356" data-end="400">Omega Speedmaster Professional Moonwatch</strong> is one of the most iconic chronographs ever created — famously worn on the moon during the Apollo missions. This 18K Sedna™ rose gold edition transforms the historic tool watch into a statement of modern luxury, combining Omega’s engineering heritage with elevated craftsmanship.</p>
    <p data-start="682" data-end="1027">The 42mm rose gold case frames a deep black dial featuring three chronograph subdials, applied rose gold hour markers, and matching hands for striking contrast and exceptional legibility. The black tachymeter bezel preserves the Speedmaster’s racing DNA, while the solid rose gold bracelet delivers substantial wrist presence and refined weight.</p>
    <p data-start="1029" data-end="1187">Powered by Omega’s renowned mechanical chronograph movement, this Moonwatch remains faithful to its original spirit — precise, durable, and unmistakably bold.</p>
    <p data-start="1189" data-end="1265">This is not simply a timepiece — it is history, redefined in precious metal.</p>
    <hr data-start="1267" data-end="1270">
    <h2 data-start="1272" data-end="1289">Specifications</h2>
    <p data-start="1291" data-end="1764"><strong data-start="1291" data-end="1301">Brand:</strong> Omega<br data-start="1307" data-end="1310"><strong data-start="1310" data-end="1320">Model:</strong> Speedmaster Professional Moonwatch<br data-start="1355" data-end="1358"><strong data-start="1358" data-end="1372">Case Size:</strong> 42mm<br data-start="1377" data-end="1380"><strong data-start="1380" data-end="1398">Case Material:</strong> 18K Sedna™ Rose Gold<br data-start="1419" data-end="1422"><strong data-start="1422" data-end="1432">Bezel:</strong> Black Tachymeter Bezel<br data-start="1455" data-end="1458"><strong data-start="1458" data-end="1467">Dial:</strong> Black Dial with Rose Gold Hands &amp; Markers<br data-start="1509" data-end="1512"><strong data-start="1512" data-end="1524">Crystal:</strong> Sapphire Crystal<br data-start="1541" data-end="1544"><strong data-start="1544" data-end="1557">Bracelet:</strong> 18K Sedna™ Rose Gold Bracelet<br data-start="1587" data-end="1590"><strong data-start="1590" data-end="1603">Movement:</strong> Mechanical Chronograph Movement<br data-start="1635" data-end="1638"><strong data-start="1638" data-end="1652">Functions:</strong> Hours, Minutes, Small Seconds, Chronograph<br data-start="1695" data-end="1698"><strong data-start="1698" data-end="1719" data-is-only-node="">Water Resistance:</strong> 50 meters / 5 ATM (typical Moonwatch spec)</p></div>`,
    prices: [{ unit: "unit", amount: 35000.0 }],
  } as Product,
  // Omega End Brand Collection

  // Tag Heuer Start Brand Collection
  {
    id: "tag-heuer-carrera-calibre-cbn2012-grey-dial-steel-mens-watch",
    name: "Tag Heuer Carrera Calibre CBN2012 Grey Dial Steel Mens Watch",
    category: "Tag Heuer",
    photo:
      "assets/img/products/tag-heuer-carrera-calibre-cbn2012-grey-dial-steel-mens-watch.jfif",
    description: `<div class="productdesc"><p><strong>Brand</strong>: &nbsp; &nbsp;Tag Heuer<br><strong>Model Name</strong>: &nbsp; &nbsp;Tag Heuer Carrera Chronograph Black Dial&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;CBN201C.FC6542<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Jewels</strong>: &nbsp; &nbsp;33<br><strong>Caliber</strong>: &nbsp; &nbsp;HEUER02<br><strong>Case</strong>: &nbsp; &nbsp;Polished stainless steel case 42.0 mm in diameter. Transparent exhibition sapphire crystal case back.<br><strong>Bezel</strong>: &nbsp; &nbsp;Polished stainless steel bezel.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Black sunray brushed dial with luminous hands and baton hour markers. Orange lacquered central hand. Date display at the 6 o'clock position. Three chronograph sub-dials -- 1/4 seconds, 30 minutes and 12 hours. Gradient orange track along the outer rim.<br><strong>Bracelet</strong>: &nbsp; &nbsp;Black leather strap with stainless steel push-button folding clasp.<br><strong>Condition</strong>: &nbsp; &nbsp;Never been worn<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Tag Heuer box and card.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    description2: `<div class="productdesc"><p><strong>Brand</strong>: &nbsp; &nbsp;Tag Heuer<br><strong>Model Name</strong>: &nbsp; &nbsp;Tag Heuer Carrera Chronograph Black Dial&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;CBN201C.FC6542<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Jewels</strong>: &nbsp; &nbsp;33<br><strong>Caliber</strong>: &nbsp; &nbsp;HEUER02<br><strong>Case</strong>: &nbsp; &nbsp;Polished stainless steel case 42.0 mm in diameter. Transparent exhibition sapphire crystal case back.<br><strong>Bezel</strong>: &nbsp; &nbsp;Polished stainless steel bezel.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Black sunray brushed dial with luminous hands and baton hour markers. Orange lacquered central hand. Date display at the 6 o'clock position. Three chronograph sub-dials -- 1/4 seconds, 30 minutes and 12 hours. Gradient orange track along the outer rim.<br><strong>Bracelet</strong>: &nbsp; &nbsp;Black leather strap with stainless steel push-button folding clasp.<br><strong>Condition</strong>: &nbsp; &nbsp;Never been worn<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Tag Heuer box and card.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    prices: [{ unit: "unit", amount: 5700.0 }],
  } as Product,
  {
    id: "tag-heuer-carrera-chronograph-cbn201c-black-dial-steel-mens-watch",
    name: "Tag Heuer Carrera Chronograph CBN201C Black Dial Steel Mens Watch",
    category: "Tag Heuer",
    photo:
      "assets/img/products/tag-heuer-carrera-chronograph-cbn201c-black-dial-steel-mens-watch.jfif",
    description: `<div class="productdesc"><p><strong>Brand</strong>: &nbsp; &nbsp;Tag Heuer<br><strong>Model Name</strong>: &nbsp; &nbsp;Tag Heuer Carrera Chronograph Black Dial&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;CBN201C.FC6542<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Jewels</strong>: &nbsp; &nbsp;33<br><strong>Caliber</strong>: &nbsp; &nbsp;HEUER02<br><strong>Case</strong>: &nbsp; &nbsp;Polished stainless steel case 42.0 mm in diameter. Transparent exhibition sapphire crystal case back.<br><strong>Bezel</strong>: &nbsp; &nbsp;Polished stainless steel bezel.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Black sunray brushed dial with luminous hands and baton hour markers. Orange lacquered central hand. Date display at the 6 o'clock position. Three chronograph sub-dials -- 1/4 seconds, 30 minutes and 12 hours. Gradient orange track along the outer rim.<br><strong>Bracelet</strong>: &nbsp; &nbsp;Black leather strap with stainless steel push-button folding clasp.<br><strong>Condition</strong>: &nbsp; &nbsp;Never been worn<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Tag Heuer box and card.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    description2: `<div class="productdesc"><p><strong>Brand</strong>: &nbsp; &nbsp;Tag Heuer<br><strong>Model Name</strong>: &nbsp; &nbsp;Tag Heuer Carrera Chronograph Black Dial&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;CBN201C.FC6542<br><strong>Gender</strong>: &nbsp; &nbsp;Men's<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Jewels</strong>: &nbsp; &nbsp;33<br><strong>Caliber</strong>: &nbsp; &nbsp;HEUER02<br><strong>Case</strong>: &nbsp; &nbsp;Polished stainless steel case 42.0 mm in diameter. Transparent exhibition sapphire crystal case back.<br><strong>Bezel</strong>: &nbsp; &nbsp;Polished stainless steel bezel.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Black sunray brushed dial with luminous hands and baton hour markers. Orange lacquered central hand. Date display at the 6 o'clock position. Three chronograph sub-dials -- 1/4 seconds, 30 minutes and 12 hours. Gradient orange track along the outer rim.<br><strong>Bracelet</strong>: &nbsp; &nbsp;Black leather strap with stainless steel push-button folding clasp.<br><strong>Condition</strong>: &nbsp; &nbsp;Never been worn<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Tag Heuer box and card.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty</p></div>`,
    prices: [{ unit: "unit", amount: 5700.0 }],
  } as Product,
  {
    id: "tag-heuer-carrera-cbn2a1e-160-years-anniversary-steel-mens-watch",
    name: "Tag Heuer Carrera CBN2A1E 160 Years Anniversary Steel Mens Watch",
    category: "Tag Heuer",
    photo:
      "assets/img/products/tag-heuer-carrera-cbn2a1e-160-years-anniversary-steel-mens-watch.jfif",
    description: `<div class="productdesc"><p style="text-align: left;"><strong>Brand</strong>: &nbsp; &nbsp;Tag Heuer<br><strong>Model Name</strong>: &nbsp; &nbsp;Tag Heuer Carrera 160 Years Anniversary&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;CBN2A1E<br><strong>Gender</strong>: &nbsp; &nbsp;Mens<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel round case 44.0 mm in diameter. Transparent exhibition sapphire crystal caseback.<br><strong>Bezel</strong>: &nbsp; &nbsp;Blue ceramic bezel with tachymeter.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Blue dial with luminescent steel hands and index hour markers. Blue running seconds sub-dial at 6 o'clock. Two white chronograph sub-dial - 30 minutes and 12 hours. Date window at 12 o'clock.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet with push button deployment clasp. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition.<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Tag Heuer box and card.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty&nbsp;</p></div>`,
    description2: `<div class="productdesc"><p style="text-align: left;"><strong>Brand</strong>: &nbsp; &nbsp;Tag Heuer<br><strong>Model Name</strong>: &nbsp; &nbsp;Tag Heuer Carrera 160 Years Anniversary&nbsp;<br><strong>Model Number</strong>: &nbsp; &nbsp;CBN2A1E<br><strong>Gender</strong>: &nbsp; &nbsp;Mens<br><strong>Movement</strong>: &nbsp; &nbsp;Automatic self-winding chronograph movement.<br><strong>Case</strong>: &nbsp; &nbsp;Stainless steel round case 44.0 mm in diameter. Transparent exhibition sapphire crystal caseback.<br><strong>Bezel</strong>: &nbsp; &nbsp;Blue ceramic bezel with tachymeter.<br><strong>Crystal</strong>: &nbsp; &nbsp;Scratch resistant sapphire crystal.<br><strong>Dial</strong>: &nbsp; &nbsp;Blue dial with luminescent steel hands and index hour markers. Blue running seconds sub-dial at 6 o'clock. Two white chronograph sub-dial - 30 minutes and 12 hours. Date window at 12 o'clock.<br>Bracelet: &nbsp; &nbsp;Stainless steel bracelet with push button deployment clasp. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br><strong>Condition</strong>: &nbsp; &nbsp;Excellent condition.<br><strong>Engravings</strong>: &nbsp; &nbsp;None<br><strong>Box &amp; Papers</strong>: &nbsp; &nbsp;Tag Heuer box and card.<br><strong>Working Condition</strong>: &nbsp; &nbsp;Timed to precision on Witschi watch expert timing machine. Running strong and keeping the accurate time.<br><strong>Authenticity</strong>: &nbsp; &nbsp;100% authentic<br><strong>Warranty</strong>: &nbsp; &nbsp;The watch is covered by JD Watches 24-month warranty&nbsp;</p></div>`,
    prices: [{ unit: "unit", amount: 5700.0 }],
  } as Product,
  {
    id: "tag-heuer-formula-1-quartz-chronograph-caz1010-ba08420-43mm-black-dial",
    name: "Tag Heuer Formula 1 Quartz Chronograph CAZ1010.BA08420 43MM Black Dial",
    category: "Tag Heuer",
    photo:
      "assets/img/products/tag-heuer-formula-1-quartz-chronograph-caz1010-ba08420-43mm-black-dial.jfif",
    description: `<p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1"> –</span><span data-mce-fragment="1">&nbsp;Pre-Owned</span><strong data-mce-fragment="1"><br data-mce-fragment="1">Model</strong><span data-mce-fragment="1">&nbsp;– Tag Heuer Formula 1 Quartz Chronograph <br><strong data-mce-fragment="1">Reference Number</strong> – CAZ1010.BA08420</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Quartz Chronograph</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> –&nbsp;Stainless Steel and Black Fixed Bezel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1">&nbsp;– Black Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1">&nbsp;– 43mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1"> – Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> – Stainless Steel Bracelet</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1"> – 20 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;– Men's</span></p>`,
    description2: `<div class="productdesc"><p>&nbsp;</p>
    <p><strong>Tag Heuer Formula 1 Quartz Chronograph CAZ1010.BA08420 43MM Black Dial</strong></p>
    <p>&nbsp;</p>
    <p><strong data-mce-fragment="1">Condition</strong><span data-mce-fragment="1"> –</span><span data-mce-fragment="1">&nbsp;Pre-Owned</span><strong data-mce-fragment="1"><br data-mce-fragment="1">Model</strong><span data-mce-fragment="1">&nbsp;– Tag Heuer Formula 1 Quartz Chronograph <br><strong data-mce-fragment="1">Reference Number</strong> – CAZ1010.BA08420</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong><span data-mce-fragment="1">&nbsp;– Quartz Chronograph</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong><span data-mce-fragment="1"> –&nbsp;Stainless Steel and Black Fixed Bezel</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong><span data-mce-fragment="1">&nbsp;– Black Dial</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong><span data-mce-fragment="1">&nbsp;– 43mm</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong><span data-mce-fragment="1"> – Scratch-resistant Sapphire Crystal</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong><span data-mce-fragment="1"> – Stainless Steel Bracelet</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong><span data-mce-fragment="1"> – 20 ATM</span><br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong><span data-mce-fragment="1">&nbsp;– Men's</span></p></div>`,
    prices: [{ unit: "unit", amount: 2575.0 }],
  } as Product,
  {
    id: "tag-heuer-carrera-automatic-chronograph-cbn2a10-ba0643-44mm-green-dial",
    name: "Tag Heuer Carrera Automatic Chronograph CBN2A10.BA0643 44MM Green Dial",
    category: "Tag Heuer",
    photo:
      "assets/img/products/tag-heuer-carrera-automatic-chronograph-cbn2a10-ba0643-44mm-green-dial.jfif",
    description: `<p><strong>Condition</strong><span> –</span><span>&nbsp;Pre-Owned</span><strong><br>Model</strong><span>&nbsp;– Tag Heuer Carrera Automatic Chronograph<br><strong>Reference Number</strong> – CBN2A10.BA0643</span><br><strong>Movement</strong><span>&nbsp;– Automatic Chronograph</span><br><strong>Bezel</strong><span> –&nbsp;Stainless Steel</span><br><strong>Dial</strong><span>&nbsp;– Green Dial</span><br><strong>Case Size</strong><span>&nbsp;– 44mm</span><br><strong>Crystal</strong><span> – Scratch-resistant Sapphire Crystal</span><br><strong>Bracelet</strong><span> – Stainless Steel Bracelet</span><br><strong>Water Resistant</strong><span> – 20 ATM</span><br><strong>Gender</strong><span>&nbsp;– Men's</span></p>`,
    description2: `<div class="productdesc"><p><strong>Tag Heuer Carrera Automatic Chronograph CBN2A10.BA0643 44MM Green Dial</strong></p>
    <p>Discover the bold Tag Heuer Carrera CBN2A10 with a vivid green dial and 44MM steel case. Automatic chronograph built for precision.</p>
    <p>&nbsp;</p>
    <p><strong>Condition</strong><span> –</span><span>&nbsp;Pre-Owned</span><strong><br>Model</strong><span>&nbsp;– Tag Heuer Carrera Automatic Chronograph<br><strong>Reference Number</strong> – CBN2A10.BA0643</span><br><strong>Movement</strong><span>&nbsp;– Automatic Chronograph</span><br><strong>Bezel</strong><span> –&nbsp;Stainless Steel</span><br><strong>Dial</strong><span>&nbsp;– Green Dial</span><br><strong>Case Size</strong><span>&nbsp;– 44mm</span><br><strong>Crystal</strong><span> – Scratch-resistant Sapphire Crystal</span><br><strong>Bracelet</strong><span> – Stainless Steel Bracelet</span><br><strong>Water Resistant</strong><span> – 20 ATM</span><br><strong>Gender</strong><span>&nbsp;– Men's</span></p></div>`,
    prices: [{ unit: "unit", amount: 7725.0 }],
  } as Product,
  // Tag Heuer End Brand Collection

  // Chopard Start Brand Collection
  {
    id: "chopard-happy-sport-square-ref-278496-stainless-steel-floating-diamonds-quartz-ladies-watch",
    name: "Chopard Happy Sport Square Ref. 278496 — Stainless Steel “Floating Diamonds” Quartz Ladies Watch",
    category: "Chopard",
    photo:
      "assets/img/products/chopard-happy-sport-square-ref-278496-stainless-steel-floating-diamonds-quartz-ladies-watch.jfif",
    description: `<ul data-start="1102" data-end="2191">
    <li data-start="1102" data-end="1193">
    <p data-start="1104" data-end="1193">Reference: <strong data-start="1115" data-end="1125">278496</strong> (e.g., 278496-3002 variant)<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1194" data-end="1343">
    <p data-start="1196" data-end="1343">Case: Stainless steel square-shaped case, approx. 30 mm x 27 mm (or square medium 37.5 mm in some variants)<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1344" data-end="1510">
    <p data-start="1346" data-end="1510">Dial: Mother-of-pearl or white dial with applied steel Roman numerals and 7 floating diamonds between two sapphire crystals.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1511" data-end="1630">
    <p data-start="1513" data-end="1630">Movement: Quartz (battery powered) for accurate, low-maintenance performance.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1631" data-end="1717">
    <p data-start="1633" data-end="1717">Crystal: Scratch-resistant sapphire crystal.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1718" data-end="1831">
    <p data-start="1720" data-end="1831">Water Resistance: 30m / 3 ATM — suitable for everyday wear (not diving)&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1832" data-end="1990">
    <p data-start="1834" data-end="1990">Bracelet/Strap: Polished stainless steel bracelet (in many examples) or optional leather strap depending on variant.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1991" data-end="2107">
    <p data-start="1993" data-end="2107">Signature Feature: Floating diamonds — hallmark of Chopard Happy Sport line adding sparkle and unique character.</p>
    </li>
    <li data-start="2108" data-end="2191">
    <p data-start="2110" data-end="2191">Origin: Swiss Made, luxury house heritage rooted in fine watchmaking and jewelry.</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="345" data-end="1076">Discover the elegance of the Chopard Happy Sport Square Ref. 278496 — a distinctive ladies’ timepiece that marries Swiss precision with playful luxury. Crafted in polished stainless steel and sized for refined wear, this square-cased watch features Chopard’s signature <em data-start="614" data-end="633">floating diamonds</em> dancing between two layers of sapphire crystal. With a mother-of-pearl or white dial (depending on variant), Roman numeral hour markers, and a date window subtly placed between 4 and 5 o’clock, the 278496 offers both style and sophistication. Powered by a reliable quartz movement and finished with a sapphire crystal and water resistance to 30 m (3 ATM), this piece is perfect for discerning buyers seeking luxury jewelry-watch hybrid flair.</p>
    <h3 data-start="1083" data-end="1101">Key Features</h3>
    <ul data-start="1102" data-end="2191">
    <li data-start="1102" data-end="1193">
    <p data-start="1104" data-end="1193">Reference: <strong data-start="1115" data-end="1125">278496</strong> (e.g., 278496-3002 variant)<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1194" data-end="1343">
    <p data-start="1196" data-end="1343">Case: Stainless steel square-shaped case, approx. 30 mm x 27 mm (or square medium 37.5 mm in some variants)<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1344" data-end="1510">
    <p data-start="1346" data-end="1510">Dial: Mother-of-pearl or white dial with applied steel Roman numerals and 7 floating diamonds between two sapphire crystals.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1511" data-end="1630">
    <p data-start="1513" data-end="1630">Movement: Quartz (battery powered) for accurate, low-maintenance performance.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1631" data-end="1717">
    <p data-start="1633" data-end="1717">Crystal: Scratch-resistant sapphire crystal.<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1718" data-end="1831">
    <p data-start="1720" data-end="1831">Water Resistance: 30m / 3 ATM — suitable for everyday wear (not diving)&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1832" data-end="1990">
    <p data-start="1834" data-end="1990">Bracelet/Strap: Polished stainless steel bracelet (in many examples) or optional leather strap depending on variant.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1991" data-end="2107">
    <p data-start="1993" data-end="2107">Signature Feature: Floating diamonds — hallmark of Chopard Happy Sport line adding sparkle and unique character.</p>
    </li>
    <li data-start="2108" data-end="2191">
    <p data-start="2110" data-end="2191">Origin: Swiss Made, luxury house heritage rooted in fine watchmaking and jewelry.</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 2950.0 }],
  } as Product,
  {
    id: "chopard-happy-sport-ref-8475",
    name: "Chopard Happy Sport Ref. 8475",
    category: "Chopard",
    photo:
      "assets/img/products/chopard-happy-sport-ref-8475.jfif",
    description: `<ul data-start="804" data-end="1708">
    <li data-start="804" data-end="903">
    <p data-start="806" data-end="903">Reference: <strong data-start="817" data-end="825">8475</strong> — part of Chopard’s Happy Sport line.</p>
    </li>
    <li data-start="904" data-end="977">
    <p data-start="906" data-end="977">Case Material: Stainless steel.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="978" data-end="1057">
    <p data-start="980" data-end="1057">Case Size: Approx. 35–36 mm diameter.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1058" data-end="1191">
    <p data-start="1060" data-end="1191">Dial: White Dial with Roman numerals and 7 floating diamonds.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1192" data-end="1251">
    <p data-start="1194" data-end="1251">Movement: Quartz.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1252" data-end="1389">
    <p data-start="1254" data-end="1389">Strap/Bracelet: Options include stainless steel bracelet or leather strap depending on variant.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1390" data-end="1500">
    <p data-start="1392" data-end="1500">Crystal: Scratch-resistant sapphire crystal (typical for this line).&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1501" data-end="1594">
    <p data-start="1503" data-end="1594">Water Resistance: 30 m / 3 ATM (dress watch level).<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1595" data-end="1708">
    <p data-start="1597" data-end="1708">Signature Feature: Free-floating diamonds inside the watch’s crystal, a hallmark of the Happy Sport collection.</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p><meta charset="utf-8">Discover the Chopard Happy Sport Ref. 8475, a refined yet playful timepiece within the renowned Happy Sport collection by Chopard. Offered in stainless steel, this 35–36 mm ladies watch features the signature floating diamonds gracefully dancing across the dial, marrying Swiss precision with spirited elegance. Driven by a reliable quartz movement, the Ref. 8475 delivers both style and practicality.&nbsp;</p>
    <h3 data-start="785" data-end="803">Key Features</h3>
    <ul data-start="804" data-end="1708">
    <li data-start="804" data-end="903">
    <p data-start="806" data-end="903">Reference: <strong data-start="817" data-end="825">8475</strong> — part of Chopard’s Happy Sport line.</p>
    </li>
    <li data-start="904" data-end="977">
    <p data-start="906" data-end="977">Case Material: Stainless steel.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="978" data-end="1057">
    <p data-start="980" data-end="1057">Case Size: Approx. 35–36 mm diameter.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1058" data-end="1191">
    <p data-start="1060" data-end="1191">Dial: White Dial with Roman numerals and 7 floating diamonds.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1192" data-end="1251">
    <p data-start="1194" data-end="1251">Movement: Quartz.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1252" data-end="1389">
    <p data-start="1254" data-end="1389">Strap/Bracelet: Options include stainless steel bracelet or leather strap depending on variant.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1390" data-end="1500">
    <p data-start="1392" data-end="1500">Crystal: Scratch-resistant sapphire crystal (typical for this line).&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1501" data-end="1594">
    <p data-start="1503" data-end="1594">Water Resistance: 30 m / 3 ATM (dress watch level).<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1595" data-end="1708">
    <p data-start="1597" data-end="1708">Signature Feature: Free-floating diamonds inside the watch’s crystal, a hallmark of the Happy Sport collection.</p>
    </li>
    </ul>
    <p>&nbsp;</p></div>`,
    prices: [{ unit: "unit", amount: 7250.0 }],
  } as Product,
  {
    id: "chopard-happy-sport-square-278496-8495-37-5mm-white-dial",
    name: "Chopard Happy Sport Square 278496-8495 37.5MM Quartz White Dial With SS Diamond",
    category: "Chopard",
    photo:
      "assets/img/products/chopard-happy-sport-square-278496-8495-37-5mm-white-dial.jfif",
    description: `<p><strong>Condition</strong> – Pre-Owned <br data-mce-fragment="1"><strong>Model</strong> <span data-mce-fragment="1">–</span> Chopard Happy Sport<br data-mce-fragment="1"><strong>Reference Number</strong> <span data-mce-fragment="1">–</span> 278496-8495<br data-mce-fragment="1"><strong>Movement</strong> – Quartz<br data-mce-fragment="1"><strong>Bezel</strong> <span data-mce-fragment="1">–</span> Stainless Steel<br data-mce-fragment="1"><strong>Dial</strong> <span data-mce-fragment="1">–</span> White Dial<br data-mce-fragment="1"><strong>Case Size</strong> <span data-mce-fragment="1">–</span> 37.5mm<br data-mce-fragment="1"><strong>Crystal</strong> <span data-mce-fragment="1">–</span> Scratch-resistant Sapphire Crystal <br data-mce-fragment="1"><strong>Bracelet</strong> <span data-mce-fragment="1">–</span> Stainless Steel Bracelet<br data-mce-fragment="1"><strong>Water Resistant</strong> <span data-mce-fragment="1">–</span>&nbsp;3 ATM<br data-mce-fragment="1"><strong>Gender</strong> –&nbsp;Unisex<script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p>`,
    description2: `<div class="productdesc"><p><strong>Chopard Happy Sport Square 278496-8495 37.5MM White Dial</strong></p>
    <p>&nbsp;</p>
    <p><strong>Condition</strong> – Pre-Owned <br data-mce-fragment="1"><strong>Model</strong> <span data-mce-fragment="1">–</span> Chopard Happy Sport<br data-mce-fragment="1"><strong>Reference Number</strong> <span data-mce-fragment="1">–</span> 278496-8495<br data-mce-fragment="1"><strong>Movement</strong> – Quartz<br data-mce-fragment="1"><strong>Bezel</strong> <span data-mce-fragment="1">–</span> Stainless Steel<br data-mce-fragment="1"><strong>Dial</strong> <span data-mce-fragment="1">–</span> White Dial<br data-mce-fragment="1"><strong>Case Size</strong> <span data-mce-fragment="1">–</span> 37.5mm<br data-mce-fragment="1"><strong>Crystal</strong> <span data-mce-fragment="1">–</span> Scratch-resistant Sapphire Crystal <br data-mce-fragment="1"><strong>Bracelet</strong> <span data-mce-fragment="1">–</span> Stainless Steel Bracelet<br data-mce-fragment="1"><strong>Water Resistant</strong> <span data-mce-fragment="1">–</span>&nbsp;3 ATM<br data-mce-fragment="1"><strong>Gender</strong> –&nbsp;Unisex<script src="chrome-extension://hhojmcideegachlhfgfdhailpfhgknjm/web_accessible_resources/index.js"></script></p></div>`,
    prices: [{ unit: "unit", amount: 4650.0 }],
  } as Product,
  // Chopard End Brand Collection

  // Grand Seiko Start Brand Collection
  {
    id: "grand-seiko-heritage-collection-spring-drive-sbgj227-stainless-steel-case-green-peacock-dial-stainless-steel-bracelet",
    name: "Grand Seiko Heritage Collection Spring Drive SBGJ227 Green Peacock Dial With Stainless Steel Case And Stainless Steel Bracelet",
    category: "Grand Seiko",
    photo:
      "assets/img/products/grand-seiko-heritage-collection-spring-drive-sbgj227-stainless-steel-case-green-peacock-dial-stainless-steel-bracelet.jfif",
    description: `<div class="productdesc"><p data-mce-fragment="1"><strong data-mce-fragment="1">Condition</strong> – Pre-Owned<br data-mce-fragment="1"><strong data-mce-fragment="1">Model</strong> –&nbsp;Grand Seiko Heritage<br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong>&nbsp;– SBGJ227<br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong>&nbsp;– Automatic<br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong>&nbsp;– Stainless Steel<br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong>&nbsp;– &nbsp;Green Peacock Dial<br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong>&nbsp;– 40mm<br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong> – Scratch-resistant Sapphire Crystal<br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong>&nbsp;– Stainless Steel<br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong> – 10 ATM<br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong>&nbsp;– Men's<br data-mce-fragment="1"><strong data-mce-fragment="1">Box</strong>&nbsp;– Seiko Box<br data-mce-fragment="1"><strong data-mce-fragment="1">Papers</strong> – Seiko Certificate&nbsp;</p></div>`,
    description2: `<div class="productdesc"><p data-mce-fragment="1"><strong data-mce-fragment="1">Grand Seiko Heritage Collection Spring Drive SBGJ227 Green Peacock Dial With Stainless Steel Case And Stainless Steel Bracelet<br><br></strong><strong data-mce-fragment="1">Condition</strong> – Pre-Owned<br data-mce-fragment="1"><strong data-mce-fragment="1">Model</strong> –&nbsp;Grand Seiko Heritage<br data-mce-fragment="1"><strong data-mce-fragment="1">Reference Number</strong>&nbsp;– SBGJ227<br data-mce-fragment="1"><strong data-mce-fragment="1">Movement</strong>&nbsp;– Automatic<br data-mce-fragment="1"><strong data-mce-fragment="1">Bezel</strong>&nbsp;– Stainless Steel<br data-mce-fragment="1"><strong data-mce-fragment="1">Dial</strong>&nbsp;– &nbsp;Green Peacock Dial<br data-mce-fragment="1"><strong data-mce-fragment="1">Case Size</strong>&nbsp;– 40mm<br data-mce-fragment="1"><strong data-mce-fragment="1">Crystal</strong> – Scratch-resistant Sapphire Crystal<br data-mce-fragment="1"><strong data-mce-fragment="1">Bracelet</strong>&nbsp;– Stainless Steel<br data-mce-fragment="1"><strong data-mce-fragment="1">Water Resistant</strong> – 10 ATM<br data-mce-fragment="1"><strong data-mce-fragment="1">Gender</strong>&nbsp;– Men's<br data-mce-fragment="1"><strong data-mce-fragment="1">Box</strong>&nbsp;– Seiko Box<br data-mce-fragment="1"><strong data-mce-fragment="1">Papers</strong> – Seiko Certificate&nbsp;</p></div>`,
    prices: [{ unit: "unit", amount: 10300.0 }],
  } as Product,
  {
    id: "copy-of-grand-seiko-heritage-collection-spring-drive-sbgj227-stainless-steel-case-green-peacock-dial-stainless-steel-bracelet",
    name: "Grand Seiko Heritage Collection Spring Drive SBGA407 Blue Snowflake Dial With Stainless Steel Case And Leather Strap",
    category: "Grand Seiko",
    photo:
      "assets/img/products/copy-of-grand-seiko-heritage-collection-spring-drive-sbgj227-stainless-steel-case-green-peacock-dial-stainless-steel-bracelet.jfif",
    description: `<div class="productdesc"><p><strong>Condition</strong> – Pre-Owned<br><strong>Model</strong>&nbsp;–&nbsp;Grand Seiko Heritage<br><strong>Reference Number</strong>&nbsp;– SBGA407<br><strong>Movement</strong>&nbsp;– Automatic<br><strong>Bezel</strong>&nbsp;– Stainless Steel<br><strong>Dial</strong>&nbsp;– &nbsp;Blue Snowflake Dial<br><strong>Case Size</strong>&nbsp;– 40mm<br><strong>Crystal</strong>&nbsp;–&nbsp;Scratch-resistant Sapphire Crystal<br><strong>Bracelet</strong>&nbsp;– Black Leather Strap<br><strong>Water Resistant</strong> –&nbsp;10 ATM<br><strong>Gender</strong>&nbsp;– Men's<br><strong>Box</strong>&nbsp;– Seiko Box<br><strong>Papers&nbsp;</strong>–<strong> </strong>Seiko Certificate</p></div>`,
    description2: `<div class="productdesc"><p><strong>Grand Seiko Heritage Collection Spring Drive SBGA407 Blue Snowflake Dial With Stainless Steel Case And Leather Strap<br><br></strong><strong>Condition</strong> – Pre-Owned<br><strong>Model</strong>&nbsp;–&nbsp;Grand Seiko Heritage<br><strong>Reference Number</strong>&nbsp;– SBGA407<br><strong>Movement</strong>&nbsp;– Automatic<br><strong>Bezel</strong>&nbsp;– Stainless Steel<br><strong>Dial</strong>&nbsp;– &nbsp;Blue Snowflake Dial<br><strong>Case Size</strong>&nbsp;– 40mm<br><strong>Crystal</strong>&nbsp;–&nbsp;Scratch-resistant Sapphire Crystal<br><strong>Bracelet</strong>&nbsp;– Black Leather Strap<br><strong>Water Resistant</strong> –&nbsp;10 ATM<br><strong>Gender</strong>&nbsp;– Men's<br><strong>Box</strong>&nbsp;– Seiko Box<br><strong>Papers&nbsp;</strong>–<strong> </strong>Seiko Certificate</p></div>`,
    prices: [{ unit: "unit", amount: 6700.0 }],
  } as Product,
  {
    id: "grand-seiko-evolution-9-slgh00",
    name: "Grand Seiko Evolution 9 SLGH00",
    category: "Grand Seiko",
    photo:
      "assets/img/products/grand-seiko-evolution-9-slgh00.jfif",
    description: `<div class="productPageCollapsibleSectionHeader">
    <span class="specLabel"><strong>Product Code:</strong> </span><span class="specValue">18400218</span>
    </div><div class="productPageCollapsibleSectionBody productSpecification">
    <p><strong><span class="specLabel">Manufacturer Product Number: </span></strong><span class="specValue">SLGH005</span></p>
    <ul class="productSpecs">
    <li>
    <strong><span class="specLabel">Guarantee </span></strong><span class="specValue">JD Certified 2 Year Guarantee</span>
    </li>
    <li>
    <strong><span class="specLabel">Category: </span></strong><span class="specValue">Watches</span>
    </li>
    <li>
    <span class="specLabel"><strong>Brand</strong>: </span><span class="specValue">Grand Seiko</span>
    </li>
    <li>
    <span class="specLabel"><strong>Watch Markers:</strong> </span><span class="specValue">Batons</span>
    </li>
    <li>
    <span class="specLabel"><strong>Water Resistant</strong>: </span><span class="specValue">100 Meters</span>
    </li>
    <li>
    <span class="specLabel"><strong>Recipient:</strong> </span><span class="specValue">For Him</span>
    </li>
    <li>
    <span class="specLabel"><strong>Movement:</strong> </span><span class="specValue">Automatic</span>
    </li>
    <li>
    <strong><span class="specLabel">Case Material: </span></strong><span class="specValue">Stainless Steel</span>
    </li>
    <li>
    <strong><span class="specLabel">Dial Color: </span></strong><span class="specValue">White</span>
    </li>
    <li>
    <span class="specLabel"><strong>Strap Material:</strong> </span><span class="specValue">Stainless Steel</span>
    </li>
    <li>
    <span class="specLabel"><strong>Diameter:</strong> <a href="https://www.watchesofswitzerland.com/watch-buying-guide/watch-size-guide" target="_blank"><i class="fal fa-info-circle"></i></a></span><span class="specValue">40mm</span>
    </li>
    <li>
    <strong><span class="specLabel">Brand Collections: </span></strong><span class="specValue">Grand Seiko Evolution 9</span>
    </li>
    </ul>
    </div>`,
    description2: `<div class="productdesc"><div class="productPageCollapsibleSectionHeader"><strong>SPECIFICATION</strong></div>
    <div class="productPageCollapsibleSectionHeader">
    <span class="specLabel"><strong></strong></span><br>
    </div>
    <div class="productPageCollapsibleSectionHeader">
    <span class="specLabel"><strong>Product Code:</strong> </span><span class="specValue">18400218</span>
    </div>
    <div class="productPageCollapsibleSectionBody productSpecification">
    <p><strong><span class="specLabel">Manufacturer Product Number: </span></strong><span class="specValue">SLGH005</span></p>
    <ul class="productSpecs">
    <li>
    <strong><span class="specLabel">Guarantee </span></strong><span class="specValue">JD Certified 2 Year Guarantee</span>
    </li>
    <li>
    <strong><span class="specLabel">Category: </span></strong><span class="specValue">Watches</span>
    </li>
    <li>
    <span class="specLabel"><strong>Brand</strong>: </span><span class="specValue">Grand Seiko</span>
    </li>
    <li>
    <span class="specLabel"><strong>Watch Markers:</strong> </span><span class="specValue">Batons</span>
    </li>
    <li>
    <span class="specLabel"><strong>Water Resistant</strong>: </span><span class="specValue">100 Meters</span>
    </li>
    <li>
    <span class="specLabel"><strong>Recipient:</strong> </span><span class="specValue">For Him</span>
    </li>
    <li>
    <span class="specLabel"><strong>Movement:</strong> </span><span class="specValue">Automatic</span>
    </li>
    <li>
    <strong><span class="specLabel">Case Material: </span></strong><span class="specValue">Stainless Steel</span>
    </li>
    <li>
    <strong><span class="specLabel">Dial Color: </span></strong><span class="specValue">White</span>
    </li>
    <li>
    <span class="specLabel"><strong>Strap Material:</strong> </span><span class="specValue">Stainless Steel</span>
    </li>
    <li>
    <span class="specLabel"><strong>Diameter:</strong> <a href="https://www.watchesofswitzerland.com/watch-buying-guide/watch-size-guide" target="_blank"><i class="fal fa-info-circle"></i></a></span><span class="specValue">40mm</span>
    </li>
    <li>
    <strong><span class="specLabel">Brand Collections: </span></strong><span class="specValue">Grand Seiko Evolution 9</span>
    </li>
    </ul>
    </div></div>`,
    prices: [{ unit: "unit", amount: 6200.0 }],
  } as Product,
  // Grand Seiko End Brand Collection

  // IWC Start Brand Collection
  {
    id: "iwc-pilot-s-watch-chronograph-iw500916-43-mm-stainless-steel-automatic",
    name: "IWC Pilot’s Watch Chronograph IW500916 – 43 mm Stainless Steel Automatic",
    category: "IWC",
    photo:
      "assets/img/products/iwc-pilot-s-watch-chronograph-iw500916-43-mm-stainless-steel-automatic.jfif",
    description: `<ul data-start="1020" data-end="1853">
    <li data-start="1020" data-end="1090">
    <p data-start="1022" data-end="1090">Case: Stainless steel, approx. 43 mm diameter — bold yet wearable.</p>
    </li>
    <li data-start="1091" data-end="1186">
    <p data-start="1093" data-end="1186">Movement: Automatic chronograph calibre (in-house from IWC) providing reliable performance.</p>
    </li>
    <li data-start="1187" data-end="1313">
    <p data-start="1189" data-end="1313">Dial: Blue Dial with sub-dials for chronograph functionality, clear legibility and applied markers/hands.</p>
    </li>
    <li data-start="1314" data-end="1389">
    <p data-start="1316" data-end="1389">Crystal: Scratch-resistant sapphire crystal for durability and clarity.</p>
    </li>
    <li data-start="1390" data-end="1510">
    <p data-start="1392" data-end="1510">Bracelet/Strap: Brown Leather Strap</p>
    </li>
    <li data-start="1511" data-end="1599">
    <p data-start="1513" data-end="1599">Water Resistance: Suitable for daily wear (please verify exact spec for this model).</p>
    </li>
    <li data-start="1600" data-end="1727">
    <p data-start="1602" data-end="1727">Heritage: Part of the IWC Pilot’s collection, rooted in aviation-inspired design serving both aesthetics and functionality.</p>
    </li>
    <li data-start="1728" data-end="1853">
    <p data-start="1730" data-end="1853">Appeal: Designed for the luxury professional, collector or enthusiast who values mechanical excellence and timeless design.</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="385" data-end="772">The IWC Pilot’s Watch Chronograph IW500916 delivers both heritage and performance in a refined 43 mm stainless steel case that’s built for daily wear and serious horology. Equipped with a robust automatic movement, this timepiece features precise chronograph functions, the classic pilot’s dial layout and a comfortable bracelet or strap suited for both professional and casual settings.</p>
    <p data-start="774" data-end="994">Designed with the collector in mind, the IW500916 offers the perfect balance of cockpit-inspired aesthetics and Swiss craftsmanship—ideal for JD Watches’ New York and Dallas clientele seeking a premium luxury instrument.</p>
    <h3 data-start="1001" data-end="1019">Key Features</h3>
    <ul data-start="1020" data-end="1853">
    <li data-start="1020" data-end="1090">
    <p data-start="1022" data-end="1090">Case: Stainless steel, approx. 43 mm diameter — bold yet wearable.</p>
    </li>
    <li data-start="1091" data-end="1186">
    <p data-start="1093" data-end="1186">Movement: Automatic chronograph calibre (in-house from IWC) providing reliable performance.</p>
    </li>
    <li data-start="1187" data-end="1313">
    <p data-start="1189" data-end="1313">Dial: Blue Dial with sub-dials for chronograph functionality, clear legibility and applied markers/hands.</p>
    </li>
    <li data-start="1314" data-end="1389">
    <p data-start="1316" data-end="1389">Crystal: Scratch-resistant sapphire crystal for durability and clarity.</p>
    </li>
    <li data-start="1390" data-end="1510">
    <p data-start="1392" data-end="1510">Bracelet/Strap: Brown Leather Strap</p>
    </li>
    <li data-start="1511" data-end="1599">
    <p data-start="1513" data-end="1599">Water Resistance: Suitable for daily wear (please verify exact spec for this model).</p>
    </li>
    <li data-start="1600" data-end="1727">
    <p data-start="1602" data-end="1727">Heritage: Part of the IWC Pilot’s collection, rooted in aviation-inspired design serving both aesthetics and functionality.</p>
    </li>
    <li data-start="1728" data-end="1853">
    <p data-start="1730" data-end="1853">Appeal: Designed for the luxury professional, collector or enthusiast who values mechanical excellence and timeless design.</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 7250.0 }],
  } as Product,
  {
    id: "iwc-pilot-s-watch-spitfire-chronograph-iw387803-43-mm-18k-rose-gold",
    name: "IWC Pilot’s Watch Spitfire Chronograph IW387803 43 mm 18k Rose Gold",
    category: "IWC",
    photo:
      "assets/img/products/iwc-pilot-s-watch-spitfire-chronograph-iw387803-43-mm-18k-rose-gold.jfif",
    description: `<ul data-start="1038" data-end="1879">
    <li data-start="1038" data-end="1140">
    <p data-start="1040" data-end="1140">Reference: <strong data-start="1051" data-end="1063">IW387803</strong> (Pilot’s Watch Spitfire Chronograph)&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1141" data-end="1249">
    <p data-start="1143" data-end="1249">Case: 18k rose gold, 43.0 mm diameter, approximately 15.5 mm thick&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1250" data-end="1374">
    <p data-start="1252" data-end="1374">Movement: IWC Calibre 89365 automatic, flyback chronograph, ~68-hour power reserve.</p>
    </li>
    <li data-start="1375" data-end="1517">
    <p data-start="1377" data-end="1517">Dial: Ardoise (slate grey) with rose-gold numerals &amp; hands, chronograph sub-dials, date at 3 o’clock&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1518" data-end="1588">
    <p data-start="1520" data-end="1588">Crystal: Scratch-resistant sapphire with anti-reflective treatment</p>
    </li>
    <li data-start="1589" data-end="1701">
    <p data-start="1591" data-end="1701">Water Resistance: Approximately 60 m / 6 ATM (depending on model year)&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1702" data-end="1780">
    <p data-start="1704" data-end="1780">Strap/Bracelet: Brown leather strap with rose gold buckle</p>
    </li>
    <li data-start="1781" data-end="1879">
    <p data-start="1783" data-end="1879">Heritage &amp; Style: Aviation inspired “Pilot’s” line from IWC with a premium rose-gold execution</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="285" data-end="666">Discover the IWC Pilot’s Watch Spitfire Chronograph Ref. IW387803 — a distinguished timepiece crafted in 18k rose gold with a 43 mm case and the heritage of aviation instrumentation. Equipped with IWC’s in-house Calibre 89365 automatic movement, this watch features a flyback chronograph function and approximately 68 hours of power reserve.&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    <p data-start="668" data-end="1012">The slate-grey (ardoise) dial, rose-gold applied numerals and hands, and the robust case form an elegant yet powerful aesthetic. The “Spitfire” connection evokes classic pilot watches, leaving a strong impression in both performance and design — perfect for collectors in New York and Dallas seeking premium finishing and mechanical excellence.</p>
    <h3 data-start="1019" data-end="1037">Key Features</h3>
    <ul data-start="1038" data-end="1879">
    <li data-start="1038" data-end="1140">
    <p data-start="1040" data-end="1140">Reference: <strong data-start="1051" data-end="1063">IW387803</strong> (Pilot’s Watch Spitfire Chronograph)&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1141" data-end="1249">
    <p data-start="1143" data-end="1249">Case: 18k rose gold, 43.0 mm diameter, approximately 15.5 mm thick&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1250" data-end="1374">
    <p data-start="1252" data-end="1374">Movement: IWC Calibre 89365 automatic, flyback chronograph, ~68-hour power reserve.</p>
    </li>
    <li data-start="1375" data-end="1517">
    <p data-start="1377" data-end="1517">Dial: Ardoise (slate grey) with rose-gold numerals &amp; hands, chronograph sub-dials, date at 3 o’clock&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1518" data-end="1588">
    <p data-start="1520" data-end="1588">Crystal: Scratch-resistant sapphire with anti-reflective treatment</p>
    </li>
    <li data-start="1589" data-end="1701">
    <p data-start="1591" data-end="1701">Water Resistance: Approximately 60 m / 6 ATM (depending on model year)&nbsp;<span class="" data-state="closed"><span class="ms-1 inline-flex max-w-full items-center relative top-[-0.094rem] animate-[show_150ms_ease-in]" data-testid="webpage-citation-pill"></span></span></p>
    </li>
    <li data-start="1702" data-end="1780">
    <p data-start="1704" data-end="1780">Strap/Bracelet: Brown leather strap with rose gold buckle</p>
    </li>
    <li data-start="1781" data-end="1879">
    <p data-start="1783" data-end="1879">Heritage &amp; Style: Aviation inspired “Pilot’s” line from IWC with a premium rose-gold execution</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 19500.0 }],
  } as Product,
  {
    id: "iwc-portuguese-yacht-club-chronograph-43-5mm-grey-dial-with-rubber-bracelet",
    name: "IWC Portuguese Yacht Club Chronograph 43.5MM Grey Dial With Rubber Bracelet",
    category: "IWC",
    photo:
      "assets/img/products/iwc-portuguese-yacht-club-chronograph-43-5mm-grey-dial-with-rubber-bracelet.jfif",
    description: `<div class="productdesc"><strong>Condition&nbsp;</strong>-&nbsp;Pre-Owned<strong><br>Model</strong> – IWC Portuguese Yacht Club Chronograph<br><strong>Reference Number</strong> - 390503<br><strong>Movement</strong> – Automatic<br><strong>Bezel</strong> - Stainless Steel<br><strong>Dial</strong> – Grey Dial<br><strong>Case Size</strong> – 43.5mm<br><strong>Crystal</strong> - Scratch-resistant Sapphire Crystal <br><strong>Bracelet</strong> - Rubber<br><strong>Water Resistant</strong> - 6 ATM<br><strong>Gender</strong> – Men's<br><b>Box - Included</b><br><b>Card - included&nbsp;</b></div>`,
    description2: `<div class="productdesc"><strong>Condition&nbsp;</strong>-&nbsp;Pre-Owned<strong><br>Model</strong> – IWC Portuguese Yacht Club Chronograph<br><strong>Reference Number</strong> - 390503<br><strong>Movement</strong> – Automatic<br><strong>Bezel</strong> - Stainless Steel<br><strong>Dial</strong> – Grey Dial<br><strong>Case Size</strong> – 43.5mm<br><strong>Crystal</strong> - Scratch-resistant Sapphire Crystal <br><strong>Bracelet</strong> - Rubber<br><strong>Water Resistant</strong> - 6 ATM<br><strong>Gender</strong> – Men's<br><b>Box - Included</b><br><b>Card - included&nbsp;</b></div>`,
    prices: [{ unit: "unit", amount: 10000.0 }],
  } as Product,
  // IWC End Brand Collection

  // Tudor Start Brand Collection
  {
    id: "tudor-black-bay-gmt-41mm-black-dial-stainless-steel-watch-m79830rb",
    name: "TUDOR Black Bay GMT 41mm Black Dial Stainless Steel Watch – M79830RB",
    category: "Tudor",
    photo:
      "assets/img/products/tudor-black-bay-gmt-41mm-black-dial-stainless-steel-watch-m79830rb.jfif",
    description: `<ul data-start="1042" data-end="1550">
    <li data-section-id="4pyccx" data-start="1042" data-end="1060">
    <strong data-start="1044" data-end="1054">Brand:</strong> TUDOR</li>
    <li data-section-id="1e33ebr" data-start="1061" data-end="1092">
    <strong data-start="1063" data-end="1078">Collection:</strong> Black Bay GMT</li>
    <li data-section-id="1lvl4ot" data-start="1093" data-end="1123">
    <strong data-start="1095" data-end="1109">Reference:</strong> M79830RB-0001</li>
    <li data-section-id="b1b2o6" data-start="1124" data-end="1145">
    <strong data-start="1126" data-end="1140">Case Size:</strong> 41mm</li>
    <li data-section-id="o5aaem" data-start="1146" data-end="1182">
    <strong data-start="1148" data-end="1166">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="5nss0l" data-start="1183" data-end="1200">
    <strong data-start="1185" data-end="1194">Dial:</strong> Black</li>
    <li data-section-id="1yj4ypn" data-start="1201" data-end="1247">
    <strong data-start="1203" data-end="1213">Bezel:</strong> Burgundy &amp; Blue 24-Hour GMT Bezel</li>
    <li data-section-id="15xumue" data-start="1248" data-end="1300">
    <strong data-start="1250" data-end="1263">Movement:</strong> Automatic Manufacture Calibre MT5652</li>
    <li data-section-id="1occl81" data-start="1301" data-end="1336">
    <strong data-start="1303" data-end="1321">Certification:</strong> COSC Certified</li>
    <li data-section-id="1mz2pek" data-start="1337" data-end="1380">
    <strong data-start="1339" data-end="1357">Power Reserve:</strong> Approximately 70 Hours</li>
    <li data-section-id="lk0f2p" data-start="1381" data-end="1418">
    <strong data-start="1383" data-end="1395">Crystal:</strong> Domed Sapphire Crystal</li>
    <li data-section-id="39psme" data-start="1419" data-end="1458">
    <strong data-start="1421" data-end="1434">Bracelet:</strong> Riveted Stainless Steel</li>
    <li data-section-id="nrs5ee" data-start="1459" data-end="1495">
    <strong data-start="1461" data-end="1482">Water Resistance:</strong> 200m / 660ft</li>
    <li data-section-id="1u372xh" data-start="1496" data-end="1550">
    <strong data-start="1498" data-end="1512">Swiss Made</strong> <span class="" data-state="closed"></span>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="227" data-end="409" class="PDq2pG_selectionAnchorContainer">Built for the modern traveler, the <strong data-start="262" data-end="299">TUDOR Black Bay GMT M79830RB-0001</strong> combines the iconic design language of the Black Bay collection with a practical multiple time-zone function.<span aria-hidden="true" class="PDq2pG_selectionAnchor"></span></p>
    <p data-start="411" data-end="707">Crafted in stainless steel, the 41mm case features a striking bidirectional 24-hour bezel with a matte burgundy and blue aluminum insert. The domed black dial is accented by TUDOR's signature Snowflake hands, luminous hour markers, a bold red GMT hand, and a date display positioned at 3 o'clock.</p>
    <p data-start="709" data-end="1023" class="">Powered by the COSC-certified <strong data-start="739" data-end="788">Manufacture Calibre MT5652 automatic movement</strong>, the Black Bay GMT offers approximately 70 hours of power reserve and the ability to track multiple time zones. A riveted stainless steel bracelet completes its robust, vintage-inspired aesthetic. <span class="" data-state="closed"></span></p>
    <h3 data-section-id="1iz91iu" data-start="1025" data-end="1041">Key Features</h3>
    <ul data-start="1042" data-end="1550">
    <li data-section-id="4pyccx" data-start="1042" data-end="1060">
    <strong data-start="1044" data-end="1054">Brand:</strong> TUDOR</li>
    <li data-section-id="1e33ebr" data-start="1061" data-end="1092">
    <strong data-start="1063" data-end="1078">Collection:</strong> Black Bay GMT</li>
    <li data-section-id="1lvl4ot" data-start="1093" data-end="1123">
    <strong data-start="1095" data-end="1109">Reference:</strong> M79830RB-0001</li>
    <li data-section-id="b1b2o6" data-start="1124" data-end="1145">
    <strong data-start="1126" data-end="1140">Case Size:</strong> 41mm</li>
    <li data-section-id="o5aaem" data-start="1146" data-end="1182">
    <strong data-start="1148" data-end="1166">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="5nss0l" data-start="1183" data-end="1200">
    <strong data-start="1185" data-end="1194">Dial:</strong> Black</li>
    <li data-section-id="1yj4ypn" data-start="1201" data-end="1247">
    <strong data-start="1203" data-end="1213">Bezel:</strong> Burgundy &amp; Blue 24-Hour GMT Bezel</li>
    <li data-section-id="15xumue" data-start="1248" data-end="1300">
    <strong data-start="1250" data-end="1263">Movement:</strong> Automatic Manufacture Calibre MT5652</li>
    <li data-section-id="1occl81" data-start="1301" data-end="1336">
    <strong data-start="1303" data-end="1321">Certification:</strong> COSC Certified</li>
    <li data-section-id="1mz2pek" data-start="1337" data-end="1380">
    <strong data-start="1339" data-end="1357">Power Reserve:</strong> Approximately 70 Hours</li>
    <li data-section-id="lk0f2p" data-start="1381" data-end="1418">
    <strong data-start="1383" data-end="1395">Crystal:</strong> Domed Sapphire Crystal</li>
    <li data-section-id="39psme" data-start="1419" data-end="1458">
    <strong data-start="1421" data-end="1434">Bracelet:</strong> Riveted Stainless Steel</li>
    <li data-section-id="nrs5ee" data-start="1459" data-end="1495">
    <strong data-start="1461" data-end="1482">Water Resistance:</strong> 200m / 660ft</li>
    <li data-section-id="1u372xh" data-start="1496" data-end="1550">
    <strong data-start="1498" data-end="1512">Swiss Made</strong> <span class="" data-state="closed"></span>
    </li>
    </ul>
    <p data-start="1552" data-end="1669"><strong data-start="1552" data-end="1669">Iconic TUDOR heritage, GMT functionality, and unmistakable wrist presence — designed for wherever time takes you.</strong></p>
    <p data-start="1671" data-end="1733" data-is-last-node="" data-is-only-node="">&nbsp;</p></div>`,
    prices: [{ unit: "unit", amount: 4750.0 }],
  } as Product,
  {
    id: "tudor-black-bay-58-burgundy-39mm-stainless-steel-automatic-watch-m7939a1a0ru",
    name: "TUDOR Black Bay 58 Burgundy 39mm Stainless Steel Automatic Watch – M7939A1A0RU",
    category: "Tudor",
    photo:
      "assets/img/products/tudor-black-bay-58-burgundy-39mm-stainless-steel-automatic-watch-m7939a1a0ru.jfif",
    description: `<ul data-start="1207" data-end="1653">
    <li data-section-id="4pyccx" data-start="1207" data-end="1225">
    <strong data-start="1209" data-end="1219">Brand:</strong> TUDOR</li>
    <li data-section-id="zyg9h0" data-start="1226" data-end="1256">
    <strong data-start="1228" data-end="1243">Collection:</strong> Black Bay 58</li>
    <li data-section-id="n93f6e" data-start="1257" data-end="1285">
    <strong data-start="1259" data-end="1273">Reference:</strong> M7939A1A0RU</li>
    <li data-section-id="b14bqh" data-start="1286" data-end="1307">
    <strong data-start="1288" data-end="1302">Case Size:</strong> 39mm</li>
    <li data-section-id="o5aaem" data-start="1308" data-end="1344">
    <strong data-start="1310" data-end="1328">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="1jcyaie" data-start="1345" data-end="1365">
    <strong data-start="1347" data-end="1356">Dial:</strong> Burgundy</li>
    <li data-section-id="1bsg8eo" data-start="1366" data-end="1417">
    <strong data-start="1368" data-end="1378">Bezel:</strong> Burgundy Unidirectional Rotating Bezel</li>
    <li data-section-id="fu66d3" data-start="1418" data-end="1473">
    <strong data-start="1420" data-end="1433">Movement:</strong> Automatic, Manufacture Calibre MT5400-U</li>
    <li data-section-id="1nnxtg9" data-start="1474" data-end="1517">
    <strong data-start="1476" data-end="1494">Certification:</strong> COSC &amp; METAS Certified</li>
    <li data-section-id="1n75n5k" data-start="1518" data-end="1561">
    <strong data-start="1520" data-end="1538">Power Reserve:</strong> Approximately 65 Hours</li>
    <li data-section-id="lk0f2p" data-start="1562" data-end="1599">
    <strong data-start="1564" data-end="1576">Crystal:</strong> Domed Sapphire Crystal</li>
    <li data-section-id="nrs5ee" data-start="1600" data-end="1636">
    <strong data-start="1602" data-end="1623">Water Resistance:</strong> 200m / 660ft</li>
    <li data-section-id="1bq5d4" data-start="1637" data-end="1653"><strong data-start="1639" data-end="1653">Swiss Made</strong></li>
    </ul>`,
    description2: `<div class="productdesc"><p data-start="342" data-end="678" class="PDq2pG_selectionAnchorContainer">Bold in color and rich in TUDOR heritage, the <strong data-start="388" data-end="431">TUDOR Black Bay 58 Burgundy M7939A1A0RU</strong> delivers a modern interpretation of the brand's iconic dive watch design. The striking burgundy dial and matching burgundy bezel create a distinctive monochromatic look, complemented by TUDOR's signature Snowflake hands and luminous hour markers.<span aria-hidden="true" class="PDq2pG_selectionAnchor"></span></p>
    <p data-start="680" data-end="1022">Crafted in stainless steel with a refined <strong data-start="722" data-end="735">39mm case</strong>, this Black Bay 58 is powered by the <strong data-start="773" data-end="805">Manufacture Calibre MT5400-U</strong>, a self-winding mechanical movement certified by COSC and METAS. The watch offers approximately <strong data-start="902" data-end="931">65 hours of power reserve</strong> and is water resistant to <strong data-start="958" data-end="983">200 meters / 660 feet</strong>. <span class="" data-state="closed"></span></p>
    <p data-start="1024" data-end="1184">A bold yet versatile luxury sports watch, the Black Bay 58 Burgundy combines vintage-inspired character, modern precision, and unmistakable TUDOR craftsmanship.</p>
    <h3 data-section-id="pm8yra" data-start="1186" data-end="1206"><span role="text"><strong data-start="1190" data-end="1206">Key Features</strong></span></h3>
    <ul data-start="1207" data-end="1653">
    <li data-section-id="4pyccx" data-start="1207" data-end="1225">
    <strong data-start="1209" data-end="1219">Brand:</strong> TUDOR</li>
    <li data-section-id="zyg9h0" data-start="1226" data-end="1256">
    <strong data-start="1228" data-end="1243">Collection:</strong> Black Bay 58</li>
    <li data-section-id="n93f6e" data-start="1257" data-end="1285">
    <strong data-start="1259" data-end="1273">Reference:</strong> M7939A1A0RU</li>
    <li data-section-id="b14bqh" data-start="1286" data-end="1307">
    <strong data-start="1288" data-end="1302">Case Size:</strong> 39mm</li>
    <li data-section-id="o5aaem" data-start="1308" data-end="1344">
    <strong data-start="1310" data-end="1328">Case Material:</strong> Stainless Steel</li>
    <li data-section-id="1jcyaie" data-start="1345" data-end="1365">
    <strong data-start="1347" data-end="1356">Dial:</strong> Burgundy</li>
    <li data-section-id="1bsg8eo" data-start="1366" data-end="1417">
    <strong data-start="1368" data-end="1378">Bezel:</strong> Burgundy Unidirectional Rotating Bezel</li>
    <li data-section-id="fu66d3" data-start="1418" data-end="1473">
    <strong data-start="1420" data-end="1433">Movement:</strong> Automatic, Manufacture Calibre MT5400-U</li>
    <li data-section-id="1nnxtg9" data-start="1474" data-end="1517">
    <strong data-start="1476" data-end="1494">Certification:</strong> COSC &amp; METAS Certified</li>
    <li data-section-id="1n75n5k" data-start="1518" data-end="1561">
    <strong data-start="1520" data-end="1538">Power Reserve:</strong> Approximately 65 Hours</li>
    <li data-section-id="lk0f2p" data-start="1562" data-end="1599">
    <strong data-start="1564" data-end="1576">Crystal:</strong> Domed Sapphire Crystal</li>
    <li data-section-id="nrs5ee" data-start="1600" data-end="1636">
    <strong data-start="1602" data-end="1623">Water Resistance:</strong> 200m / 660ft</li>
    <li data-section-id="1bq5d4" data-start="1637" data-end="1653"><strong data-start="1639" data-end="1653">Swiss Made</strong></li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 5000.0 }],
  } as Product,
  {
    id: "tudor-black-bay-chrono-pink-dial-41mm-ref-79360n-0019",
    name: "Tudor Black Bay Chrono Pink Dial 41mm – Ref. 79360N-0019",
    category: "Tudor",
    photo:
      "assets/img/products/tudor-black-bay-chrono-pink-dial-41mm-ref-79360n-0019.jfif",
    description: `<div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/tudor">
  Tudor 
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/tudor?rb_snize_facet1=Black Bay Chrono">Black Bay Chrono</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">79360N-0019</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/tudor?rb_snize_facet2=41mm">41mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed stainless steel with black aluminum tachymeter insert</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Pink domed dial with black chronograph sub-dials, luminous hands and markers</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Domed sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Manufacture Caliber MT5813 (automatic, COSC-certified)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Stainless steel five-link bracelet with T-Fit clasp</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">200 meters / 660 feet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/tudor?rb_snize_facet5=Unisex">Unisex</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    description2: `<div class="productdesc"><p>Bold and distinctive, the Tudor Black Bay Chrono 41mm with a striking pink dial is authenticity-certified, recently inspected, and comes with full insurance protection. A rare and modern collectible blending performance with style—secure this sought-after Black Bay Chrono today with complete confidence and peace of mind.</p></div><div class="product-specification__grid">

      
    <div class="spec-item">
      <span class="spec-label">Brand</span>
      <span class="spec-value">
        




<a href="/collections/tudor">
  Tudor 
</a>



          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Model</span>
      <span class="spec-value">
          
         
             <a href="/collections/tudor?rb_snize_facet1=Black Bay Chrono">Black Bay Chrono</a>



          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Reference Number</span>
      <span class="spec-value">79360N-0019</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Case Size</span>
      <span class="spec-value">
          
          
           
             <a href="/collections/tudor?rb_snize_facet2=41mm">41mm</a>


          
          
          </span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bezel</span>
      <span class="spec-value">Fixed stainless steel with black aluminum tachymeter insert</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Dial Color</span>
      <span class="spec-value">Pink domed dial with black chronograph sub-dials, luminous hands and markers</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Crystal</span>
      <span class="spec-value">Domed sapphire</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Movement</span>
      <span class="spec-value">Manufacture Caliber MT5813 (automatic, COSC-certified)</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Bracelet</span>
      <span class="spec-value">Stainless steel five-link bracelet with T-Fit clasp</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Water Resistance</span>
      <span class="spec-value">200 meters / 660 feet</span>
    </div>
  

  
    <div class="spec-item">
      <span class="spec-label">Gender</span>
      <span class="spec-value">
          
    
          
           
             <a href="/collections/tudor?rb_snize_facet5=Unisex">Unisex</a>


          
          
          
          </span>
    </div>
  

 <!--  -->

  

</div>`,
    prices: [{ unit: "unit", amount: 13000.0 }],
  } as Product,
  {
    id: "tudor-black-bay-chrono-79360n-0024-turquoise-dial-41mm",
    name: "Tudor Black Bay Chrono 79360N-0024 – Turquoise Dial | 41mm",
    category: "Tudor",
    photo:
      "assets/img/products/tudor-black-bay-chrono-79360n-0024-turquoise-dial-41mm.jfif",
    description: `<ul data-start="854" data-end="1313">
    <li data-start="854" data-end="874" class="">
    <p data-start="856" data-end="874" class=""><strong data-start="856" data-end="866">Brand:</strong> Tudor</p>
    </li>
    <li data-start="875" data-end="906" class="">
    <p data-start="877" data-end="906" class=""><strong data-start="877" data-end="887">Model:</strong> Black Bay Chrono</p>
    </li>
    <li data-start="907" data-end="944" class="">
    <p data-start="909" data-end="944" class=""><strong data-start="909" data-end="930">Reference Number:</strong> 79360N-0024</p>
    </li>
    <li data-start="945" data-end="997" class="">
    <p data-start="947" data-end="997" class=""><strong data-start="947" data-end="960">Movement:</strong> Automatic (MT5813, COSC-Certified)</p>
    </li>
    <li data-start="998" data-end="1029" class="">
    <p data-start="1000" data-end="1029" class=""><strong data-start="1000" data-end="1018">Power Reserve:</strong> 70 Hours</p>
    </li>
    <li data-start="1030" data-end="1068" class="">
    <p data-start="1032" data-end="1068" class=""><strong data-start="1032" data-end="1050">Case Material:</strong> Stainless Steel</p>
    </li>
    <li data-start="1069" data-end="1096" class="">
    <p data-start="1071" data-end="1096" class=""><strong data-start="1071" data-end="1089">Case Diameter:</strong> 41mm</p>
    </li>
    <li data-start="1097" data-end="1140" class="">
    <p data-start="1099" data-end="1140" class=""><strong data-start="1099" data-end="1108">Dial:</strong> Turquoise with Black Subdials</p>
    </li>
    <li data-start="1141" data-end="1166" class="">
    <p data-start="1143" data-end="1166" class=""><strong data-start="1143" data-end="1155">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1167" data-end="1200" class="">
    <p data-start="1169" data-end="1200" class=""><strong data-start="1169" data-end="1182">Bracelet:</strong> Stainless Steel</p>
    </li>
    <li data-start="1201" data-end="1231" class="">
    <p data-start="1203" data-end="1231" class=""><strong data-start="1203" data-end="1224">Water Resistance:</strong> 200m</p>
    </li>
    <li data-start="1232" data-end="1250" class="">
    <p data-start="1234" data-end="1250" class=""><strong data-start="1234" data-end="1243">Year:</strong> 2025</p>
    </li>
    <li data-start="1251" data-end="1273" class="">
    <p data-start="1253" data-end="1273" class=""><strong data-start="1253" data-end="1267">Condition:</strong> New</p>
    </li>
    <li data-start="1274" data-end="1313" class="">
    <p data-start="1276" data-end="1313" class=""><strong data-start="1276" data-end="1289">Includes:</strong> Original Box &amp; Papers</p>
    </li>
    </ul>`,
    description2: `<div class="productdesc"><h3 data-start="236" data-end="305" class=""><strong data-start="243" data-end="305">Tudor Black Bay Chrono 79360N-0024 – Turquoise Dial | 41mm</strong></h3>
    <p data-start="307" data-end="823" class="">A bold twist on a classic. The <strong data-start="338" data-end="376">Tudor Black Bay Chrono 79360N-0024</strong> stands out with a striking <strong data-start="404" data-end="422">turquoise dial</strong>contrasted by <strong data-start="437" data-end="455">black subdials</strong>, combining vintage chronograph aesthetics with vibrant modern flair. Housed in a robust <strong data-start="544" data-end="573">41mm stainless steel case</strong>, this timepiece is powered by the <strong data-start="608" data-end="652">COSC-certified MT5813 automatic movement</strong>, delivering precision and a <strong data-start="681" data-end="706">70-hour power reserve</strong>. Durable, stylish, and distinct—this Black Bay Chrono is built for collectors and enthusiasts who want to stand out.</p>
    <hr data-start="825" data-end="828" class="">
    <h3 data-start="830" data-end="852" class="">Specifications:</h3>
    <ul data-start="854" data-end="1313">
    <li data-start="854" data-end="874" class="">
    <p data-start="856" data-end="874" class=""><strong data-start="856" data-end="866">Brand:</strong> Tudor</p>
    </li>
    <li data-start="875" data-end="906" class="">
    <p data-start="877" data-end="906" class=""><strong data-start="877" data-end="887">Model:</strong> Black Bay Chrono</p>
    </li>
    <li data-start="907" data-end="944" class="">
    <p data-start="909" data-end="944" class=""><strong data-start="909" data-end="930">Reference Number:</strong> 79360N-0024</p>
    </li>
    <li data-start="945" data-end="997" class="">
    <p data-start="947" data-end="997" class=""><strong data-start="947" data-end="960">Movement:</strong> Automatic (MT5813, COSC-Certified)</p>
    </li>
    <li data-start="998" data-end="1029" class="">
    <p data-start="1000" data-end="1029" class=""><strong data-start="1000" data-end="1018">Power Reserve:</strong> 70 Hours</p>
    </li>
    <li data-start="1030" data-end="1068" class="">
    <p data-start="1032" data-end="1068" class=""><strong data-start="1032" data-end="1050">Case Material:</strong> Stainless Steel</p>
    </li>
    <li data-start="1069" data-end="1096" class="">
    <p data-start="1071" data-end="1096" class=""><strong data-start="1071" data-end="1089">Case Diameter:</strong> 41mm</p>
    </li>
    <li data-start="1097" data-end="1140" class="">
    <p data-start="1099" data-end="1140" class=""><strong data-start="1099" data-end="1108">Dial:</strong> Turquoise with Black Subdials</p>
    </li>
    <li data-start="1141" data-end="1166" class="">
    <p data-start="1143" data-end="1166" class=""><strong data-start="1143" data-end="1155">Crystal:</strong> Sapphire</p>
    </li>
    <li data-start="1167" data-end="1200" class="">
    <p data-start="1169" data-end="1200" class=""><strong data-start="1169" data-end="1182">Bracelet:</strong> Stainless Steel</p>
    </li>
    <li data-start="1201" data-end="1231" class="">
    <p data-start="1203" data-end="1231" class=""><strong data-start="1203" data-end="1224">Water Resistance:</strong> 200m</p>
    </li>
    <li data-start="1232" data-end="1250" class="">
    <p data-start="1234" data-end="1250" class=""><strong data-start="1234" data-end="1243">Year:</strong> 2025</p>
    </li>
    <li data-start="1251" data-end="1273" class="">
    <p data-start="1253" data-end="1273" class=""><strong data-start="1253" data-end="1267">Condition:</strong> New</p>
    </li>
    <li data-start="1274" data-end="1313" class="">
    <p data-start="1276" data-end="1313" class=""><strong data-start="1276" data-end="1289">Includes:</strong> Original Box &amp; Papers</p>
    </li>
    </ul></div>`,
    prices: [{ unit: "unit", amount: 12700.0 }],
  } as Product,
  // Tudor End Brand Collection
];
